import { examPlayerI18n, examPlayerI18nEs } from './exam-player.i18n';
import { itemBankAdminI18n, itemBankAdminI18nEs } from './item-bank-admin.i18n';
import { itemBankContentI18n, itemBankContentI18nEs } from './item-bank-content.i18n';
import { itemBankSetupI18n, itemBankSetupI18nEs } from './item-bank-setup.i18n';
import { itemBankExamsI18n, itemBankExamsI18nEs } from './item-bank-exams.i18n';
import { itemBankExamStatsI18n, itemBankExamStatsI18nEs } from './item-bank-exam-statistics.i18n';
import { smeWorkspaceI18n, smeWorkspaceI18nEs } from './sme-workspace.i18n';

const currentYear = new Date().getFullYear();

/* eslint-disable max-len */
export const commonI18n = {
  // English
  en: {
    confirmDialog: {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    },
    commonConfirmDialog: {
      title: 'Confirmation',
      content: 'Are you sure you want to continue with this action?',
      unsavedChange: 'Do you want to close the dialog?',
      confirmation: 'Confirmation',
    },
    commonDeleteDialog: {
      title: 'Delete',
      content: 'Are you sure you want to delete this?',
    },
    editProfile: {
      userId: 'User ID',
      firstName: 'First Name',
      lastName: 'Last Name',
      middleName: 'Middle Name',
      company: 'Company',
      jobTitle: 'Job Title',
      address: 'Address',
      unitSuitApt: 'Unit/Suite/Apt #',
      dob: 'Date of Birth',
      language: 'Language',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      additionalPhoneNumber: 'Additional Phone Number',
      updateProfileSuccess: 'Update your information successfully',

      addDateOfBirth: 'Add date of birth',
      courseRequireDob: 'This course require date of birth to proceed. Please input your date of birth.',
    },
    viewLearnerDetail: {
      apexRegistration: 'This registration belongs to Apex Workplace Solutions. Please log in to the Apex website to see details',
      view: 'View',
    },
    accountSetting: {
      status: 'Status',
      userName: 'Username',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
    },
    paymentDialog: {
      addOrChargeCreditCard: 'Add/Charge Credit Card',
      payment: 'Payment',
      choosePaymentMethods: 'Choose payment methods',
      chargeSelectedCard: 'Charge selected card',
      checkName: 'Check name',
      checkNumber: 'Check number',
      amount: 'Amount ($)',
      payWithoutCheck: 'Pay without check',
      proceedWithoutCheck: 'Proceed without check',
      checkInfoNotRequired: 'Check info not required',
      allowSeatAssignmentsWithoutCheck: 'Allow seat assignments without check',
      pleaseMailYourCheckTo: 'Please mail your check to',
      groupAdminNoticeMessage: 'TRAINING PACKAGES WILL NOT BECOME ACTIVE UNTIL PAYMENT IS RECEIVED',
    },
    title: {
      assignedSeats: 'Assigned Seats',
      assigned: 'Assigned',
      classRegistrations: 'In-Person Food Manager',
      proctorURegistrations: 'Online Food Manager',
      actions: 'Actions',
      orders: 'Orders',
      adminELearning: 'Online Courses',
      studentELearning: 'Online Courses',
      learners: 'Learners',
      accountSettings: 'Account Settings',
    },
    button: {
      getStarted: 'Get started',
      excelReport: 'Excel Report',
      hideUnhideRegistrations: 'Hide/Unhide Registrations',
      hideRegistrations: 'Hide Registrations',
      unhideRegistrations: 'Unhide Registrations',
      emailCertificate: 'Email Certificate',
      downloadCertificates: 'Download Certificates',
      resendPassword: 'Resend Password',
      submit: 'Submit',
      generate: 'Generate',
      send: 'Send',
      orderPrintedCopy: 'Order Printed Copy',
      downloadCertificate: 'Download Certificate',
      downloadCert: 'Download Certificate',
      save: 'Save',
      edit: 'Edit',
      continueToCheckout: 'Continue to Checkout',
      documents: 'Documents',
      back: 'Back',
      markAsPaid: 'Mark as Paid',
      pay: 'Pay',
      remove: 'Remove',
      cancel: 'Cancel',
      close: 'Close',
      refund: 'Refund',
      refunded: 'Refunded',
      classRegistrationRefunded: 'This class was refunded',
      proctorURefunded: 'This code was refunded',
      eLearningRefunded: 'This training was refunded',
      notSupportRefundByCheck: 'Refunds by check are not supported',
      notSupportRefundByPaymentMethod: 'Refunds by {paymentMethod} are not supported',
      done: 'Done',
      applyToSelected: 'Apply to Selected',
      create: 'Create',
      download: 'Download',
      expandMore: 'Expand More',
    },
    header: {
      firstName: 'First Name',
      lastName: 'Last Name',
      serverId: 'Server ID',
      emailAddress: 'Email Address',
      email: 'Email',
      status: 'Status',
      userId: 'User ID',
      instructorNotes: 'Instructor notes',
    },
    deleteLearnerDialog: {
      title: 'Delete learner',
      content: 'Are you sure you want to delete this learner?',
      pfsAdminContent: 'This action will unassign the learner from all assigned training courses with the NOT_STARTED status.',
    },
    updateLearnerPosition: {
      update: 'Update',
    },
    updateLearnerProgress: {
      update: 'Update',
    },
    form: {
      requiredField: 'Required field',
    },

    // Components start from here.
    addQuizForm: {
      addAttempt: 'Add Attempt',
      addAttemptPlaceholder: 'Select Exam',
      add: 'Add',
    },
    assignedCourseDetail: {
      generalSettings: 'General Settings',
      examResults: 'Results',
      actions: 'Actions',
      updateLearnerPosition: 'Update Learner\'s Position',
      currentProgress: 'Current Progress',
      studentInfo: 'Student Info',
      studentCourses: 'Student Courses',
      close: 'Close',
      saveCurrentProgressAs: 'Save current position as',
      details: 'Details',
    },
    assignedCourse: {
      course: 'Course',
      packageInfo: 'Package Info',
      createdDate: 'Create Date',
      courseExpiration: 'Course Expiration',
      courseStatus: 'Course Status',
      hide: 'Hide Learners',
      unhide: 'Unhide Learners',
      hideUnhideLearners: 'Hide/Unhide Learners',
      changeVisibilityGuidance: 'Select learners to update visibility',
      hiddenUnhidden: 'Hidden/Unhidden',
    },
    visibility: {
      hidden: 'Hidden',
      unhidden: 'Unhidden',
    },
    courseStatus: {
      notStarted: 'Not Started',
      inProgress: 'In Progress',
      completed: 'Completed',
      active: 'Active',
      expired: 'Expired',
      notExpired: 'Not Expired',
    },
    assignedCourseTable: {
      userId: 'User ID',
      confirmation: 'Confirmation',
      assignedDate: 'Registered On',
      expiredDate: 'Expires On',
      course: 'Course',
      order: 'Order',
      serverId: 'Server ID',
      licenseStatus: 'License Status',
      quickActions: 'Quick Actions',
      trainingStatus: 'Training Status',
      courseProgress: 'Course Progress',
      completed: 'Completed On',
      verificationCode: 'Verification Code #',
      studentName: 'Student Name',
      admin: 'Admin',
    },
    assignedProctorU: {
      assigned: 'Assigned',
      sent: 'Sent',
      transferPackage: 'Transfer Package',
      notSentYet: 'Not sent yet',
      unassigned: 'Unassigned',
      resendExamCode: 'Resend Exam Code',
      confirmation: 'Confirmation',
      studentName: 'Student Name',
      purchaseDate: 'Purchase Date',
      assignDate: 'Assign Date',
      examCode: 'Exam Code',
      packageInfo: 'Package Info',
      packageName: 'Package Name',
      order: 'Order',
      resendCodeSuccessfully: 'The code has been sent successfully',
      resendCodesSuccessfully: 'All codes have been sent successfully.',
      actions: 'Actions',
      documents: 'Documents',
      proctorURegistrations: 'Online ServSafe Exam with ProctorU',
      dateSent: 'Date Sent',
      restartTraining: 'Restart Training',
      buyExamCodes: 'Buy Exam Codes',
      noAssignedRegistrations: 'You currently do not have any registrations.',
      code: 'Code',
      willBeTransferredFrom: 'will be transferred from',
      to: 'to',
    },
    proctorUColumns: {
      conf: 'Conf',
      order: 'Order',
      regDate: 'Reg. Date',
      paid: 'Paid',
      balance: 'Balance',
      registeredBy: 'Registered By',
      companyName: 'Company Name',
      status: 'Status',
      examCode: 'Exam Code',
    },
    assignedSeats: {
      confirmation: 'Confirmation',
      studentName: 'Student Name',
      order: 'Order',
      createdDate: 'Created Date',
      state: 'State',
      classInfo: 'Class Info',
      packageInfo: 'Package Info',
      packageName: 'Package Name',
      attendStatus: 'Status',
      balance: 'Balance',
      websiteOrLinks: 'Website / Links',
      studentPortal: 'Student Resources',
      classLocation: 'Class Location',
      classDate: 'Class Date',
      schedule: 'Schedule',
      noDataText: 'No registration found.',
      haveNoRegistrations: 'You currently do not have any registrations',
      buySeats: 'Buy Seats',
      newClassRegistration: 'New Class Registration',
      expirationDate: 'Exp. Date',
      selectDate: 'Select Date',
    },
    assignment: {
      state: 'State',
      addLine: 'Add line',
      online: 'Online Courses',
      almostFull: 'Almost full',
      full: 'Full',
      inPerson: 'In-Person Food Manager',
      proctorU: 'Online Food Manager',
      selectPackageToSeeLearnersList: 'Select a package to load learners list',
      classLanguage: 'Class language',
      year: 'Year',
      package: 'Package',
      assigned: 'assigned',
      assignedSuccessfully: 'Assigned Successfully',
      step1: 'Select Available Packages - Step 1',
      step2: 'Select Learners - Step 2',
      step3: 'Assign Seats - Step 3',
      assignLearners: 'Assign Learners',
      done: 'Done',
      noLearnerAvailable: 'No learners available',
      selectAtLeastOneLearner: 'You must add at least one learner to assign to the selected package',
      next: 'Next',
      courseRequireDob: 'This course requires the learner’s date of birth to comply with local regulatory authority reporting guidelines. Please make sure you enter the correct date below.',
      importAndAssignComplete: 'Import and assign package to learners complete',
      learnerSelectedExceedQuantity: 'The number of new learners selected exceeds the number of available packages.',
      selectAvailablePackagesSubtitle: 'All contents of packages will be assigned to a single learner',
      learners: 'Learners',
      success: 'Success',
      successSubtitle: 'You have successfully assigned the following to {learnerNumber} learners.',
      packageIncludes: 'Package Includes',
      show: 'Show',
      enroll: 'Enroll',
      states: 'States',
      businessZipCode: 'Business Zip Code',
      inactiveLearnersInSelections: 'There are inactive learners in selection list. Please deselect those learners.',
      location: 'Location',
      miles: 'Miles',
      language: 'Language',
      selected: 'Selected',
      select: 'Select',
      selectedLearners: 'Selected Learners',
      packageSelected: 'Package Selected',
      remainingQuantity: '{quantity} available',
      productList: 'Product List',
      enrollAndContinue: 'Enroll & Continue',
      footerNote: 'All contents of a package will be assigned to each learner.',
      classCancelled: 'Class Cancelled',
      rescheduleFee: 'Reschedule Fee',
      note: 'Note',
      rescheduleRegistration: 'Reschedule Registration',
      skipForNow: 'Skip for Now',
      skipForNowNote1: 'This package also includes an in-person class.',
      skipForNowNote2: 'Please select the date of the in-person Class',
      selectExamLanguage: 'Select Exam Language',
      assign: 'Assign',
      selectPackage: 'Selected Package',
      selectAPackage: 'Select a package',
      noPackageAvailable: 'No package available',

      rbsInstruction1: 'The CA Dept. of Alcoholic Beverage Control requires all servers to',
      createRbsAccount: 'Create an RBS Account',
      rbsInstruction2: 'to obtain a Server ID prior to starting the RBS training.',
      rbsInstruction3: 'The CA Dept. of Alcoholic Beverage Control requires all servers to obtain a Server ID prior to starting the RBS training.',
      rbsServerIdFee: 'Please note: the ABC charges a $3 fee to obtain a Server ID.',
      rbsServerId: 'RBS Server ID',
      learnerInfo: 'Learner Info',
      serverId: 'Server ID Here',
      enter: 'Enter',
      rbsDialogStep1: 'Click here to',
      rbsDialogStep3: 'Verify your information is correct',

      dob: 'Date of Birth',
      shortDob: 'DOB',
      lastName: 'Last Name',
      seatsLeft: 'Seats Left',
      seatLeft: 'Seat Left',
      noSeatsLeft: 'Class full',
      noClassFound: 'No class found.',
      instantResults: 'Instant results',
      instantResultsNote: 'Classes marked with a star will be offered with instant results. Learners will need a laptop and a ServSafe account set up in advance. Details will be sent via email.',
      instantResultsLegend: 'Instant Results - Please bring your own laptop',

      private: 'Private Class',
      employeeId: 'Employee ID',

      manage: 'Manage',
      managePackages: 'Manage Packages',
      packageName: 'Package Name',
      availableQuantity: 'Available Quantity',
      deleteAvailablePackages: 'Delete Available Packages',
      areYouSureYouWantToDelete: 'Are you sure you want to delete',
      thisActionCannotBeUndone: 'This action cannot be undone.',
      totalAvailablePackages: 'Total available packages of this type',
      toConfirmPleaseTypeTheNumberOfAvailable: 'To confirm, please type the number of available',
      toDelete: 'to delete',
      seatRemovedSuccess: 'Available Seat removed successfully!',
    },
    examResults: {
      save: 'Save',
      delete: 'Delete',
      quizName: 'Quiz Name',
      language: 'Language',
      correctAnswers: 'Correct Answers',
      totalQuestions: 'Total Questions',
      examScore: 'Exam Score',
      dateStarted: 'Date Started',
      dateUpdated: 'Date Updated',
    },
    addressDialog: {
      requestForLaminatedCard: 'A laminated card has already been bought by your group admin. Enter the mailing address for card delivery.',
    },
    lookup: {
      courses: 'Courses',
      licenseStatus: 'License Statuses',
      attendanceStatus: 'Attendance Statuses',
      filterBy: 'Filter by',
      selected: 'Selected',
      package: 'Packages',
      trainingStatuses: 'Training Statuses',
      expirationStatuses: 'Expiration Statuses',
      visibility: 'Visibility',
      packageType: 'Package Type',
    },
    printedCopyPaymentDialog: {
      description: 'Order a Hard Copy of Your Certificate for',
    },
    newOrders: {
      selectPackage: 'Select Package',
      productsIncluded: 'Products Included',
      orderFreeOfCharge: 'This is order is free of charge. Are you sure to pay for this order?',
      quantity: 'Quantity',
      discount: 'Discount',
      price: 'Price',
      newOrder: 'New Order',
      addAdditionalPackages: 'Add Additional Packages',
      guide: 'Select package to see included products.',
      removeDiscount: 'Remove Discount',
      applyDiscount: 'Apply Discount',
      orderTotal: 'Order total',
      discountErrorMessage: 'Discount value must smaller than package price.',
      cannotDelete: 'You cannot delete this package. At least one package must be in a new order.',
      addOrChangeCreditCard: 'Add/Charge Credit card',
      addPayment: 'Add Payment',
      payNow: 'Pay Now',
      errorNotification: 'Please check the errors log on fields',
      successNotification: 'New order has been created successfully',
    },
    orders: {
      freeFoodHandlerCardNote: 'Free with Premium Food Manager package. Transferable to employee.',
      paymentType: 'Payment Type',
      balanceDue: 'Balance Due',
      purchaseOrderGuide: 'Click here to choose a training package and add to a new order',
      name: 'Name',
      productPackages: 'Product/Packages',
      exportOrders: 'Export Orders',
      exportSelectedOrders: 'Export Selected Orders',
      exportAllOrders: 'Export All Orders',
      exportOrdersInSelectedPage: 'Export Orders in selected page',
      creditCardInfo: 'Credit Card Info',
      zip: 'Zip',
      address: 'Address',
      packageId: 'Package ID',
      packageName: 'Package Name',
      price: 'Price',
      markAsPaid: 'Mark as Paid',
      markAsUnpaid: 'Mark as Unpaid',
      quantity: 'Quantity',
      status: 'Status',
      paymentDate: 'Payment Date',
      expirationDate: 'Expiration Date',
      appliedCode: 'Code',
      discountAmount: 'Discount Amount',
      perUnit: 'per unit',
      totalDiscount: 'Total Discount',
      totalAmount: 'Total Amount',
      deleteOrder: 'Delete order',
      deleteConfirmationText: 'Are you sure you want to delete this order?',
      deleteConfirmedText: 'Yes, delete',
      deleteSuccessfullyText: 'Order successfully deleted',
      delete: 'Delete',
      edit: 'Edit',
      viewReceiptInvoice: 'View Receipt/Invoice',
      viewInvoice: 'View Invoice',
      cancel: 'Cancel',
      saveChanges: 'Save Changes',
      order: 'Order',
      confirmation: 'Confirmation',
      studentName: 'Student Name',
      classDate: 'Class Date',
      city: 'City',
      createdDate: 'Created Date',
      createdBy: 'Created By',
      orderTotal: 'Order Total',
      balance: 'Balance',
      noOrderText: 'You currently do not have any orders.',
      notAllowEditAndDelete: 'Packages from this order have been assigned prior to payment. You cannot delete or edit this order.',
      buyProducts: 'Buy Packages',
      check: 'Check',
      checkNumber: 'Check number',
      orderNotPaidYet: 'This order is not paid. Packages have been released for assignment.',
      dateOfRefund: 'Date of Refund',
      totalRefunded: 'Total Refunded',
      refundIssued: 'Refund Issued',
      refund: 'Refund',
      checkedTotal: '{checkedTotal} Items',
      selectedForRefund: 'Selected for Refund',
      enterRefundAmount: 'Enter Refund Amount',
      enterAmount: 'Enter Amount',
      issueRefund: 'Issue Refund',
      packageColumnName: 'Package',
      assignedToColumnName: 'Assigned to',
      refundSuccess: 'Success!',
      refundSuccessDescription: 'You have successfully refunded the following items',
      products: 'Products',
      unassigned: 'Unassigned',
      remove: 'Remove',
      apply: 'Apply',
      discountCode: 'Discount Code',
      discountTotal: 'Discount Total',
      cannotViewInvoice: 'An invoice/receipt can’t be generated for this order. Please contact us at 800-676-3121 to request a copy of the document, or send an email info&#64;premierfoodsafety.com',
      deleteOrderConfirmation: 'Are you sure to delete this order?',
      licensesColumnName: 'Licenses',
      packagedIncludes: 'Packages Includes',
      addOn: 'Add On',
      physicalCard: 'Physical card',
      laminatedCert: 'Laminated Certificate',
      selectedForPay: '{count} orders selected',
      paySelected: 'Pay Selected',
      clear: 'Clear',
      payPalTransactionId: 'PayPal Transaction ID',
      payPalCancelConfirmMessage: 'If you close the PayPal payment window, you will be logged into the system and can complete the payment later.',
      payPalSuccessButPaymentCouldNotBeCompleted: 'The PayPal payment was successful, but there was a minor issue with the payment flow. If the order has not been marked as paid or anything unusual occurs, please contact support at 800-676-3121.',
      applePaySuccessButPaymentCouldNotBeCompleted: 'The Apple Pay payment was successful, but there was a minor issue with the payment flow. If the order has not been marked as paid or anything unusual occurs, please contact support at 800-676-3121.',
      enterCheckNumber: 'Enter Check Number',
      refundMethod: 'Refund Method',
      refundByCard: 'Refund by Card',
      refundByCheck: 'Refund by Check',
      refundByPayPal: 'Refund by PayPal',
      generateInvoice: 'Generate Invoice',
    },
    purchasePackages: {
      purchasePackages: 'Purchase More Packages',
      total: 'Total',
      promoCode: 'Promo Code',
      enterPromoCode: 'Enter Promo Code',
      applyCode: 'Apply Code',
      discountAppliedTo: 'Discount Applied to',
      code: 'Code',
      addAdditionalPackage: 'Add Additional Packages',
      checkout: 'Checkout',
      cannotApplyMultipleCodeMessage: 'You cannot apply multiple codes for 1 package.',
      codeIsAppliedMessage: 'Code {code} has already been applied.',
      removeDiscountCode: 'Remove discount code',
      recentPurchases: 'Recent purchases',
      selectAndAddPackages: 'Select and add from the following packages',
      addToCart: 'Add to cart',
      noPackages: 'No packages added',
      selectThenAddPackages: 'Select then add available packages.',
      rbsCta: 'Add California Responsible Beverage Service Training',
      bassetCta: 'Add IL BASSET - Beverage Alcohol Sellers and Servers Education and Training',
      caFhCta: 'Add CA Food Handler Card Training',
      sdFhCta: 'Add San Diego Food Handler Card Training',
      ilFhCta: 'Add IL Food Handler Card Training',
      flFhCta: 'Add FL Food Handler Card Training',
      azFhCta: 'Add AZ Food Handler Card Training',
      txFhCta: 'Add TX Food Handler Card Training',
      nmFhCta: 'Add NM Food Handler Card Training',
      utFhCta: 'Add UT Food Handler Card Training',
      allergenCta: 'Add Food Allergen Awareness Training',
    },
    unassignedCodes: {
      selectCodes: 'Select Codes',
      title: 'Unassigned Codes 4',
      assignCodeButton: 'Assign Code(s)',
      buyCodeButton: 'Buy Code(s)',
    },
    unassignedCourses: {
      title: 'Unassigned Courses',
      buyLicense: 'Buy License(s)',
      assignCourses: 'Assign Courses(s)',
      assignCourse: 'Assign Course',
    },
    unassignedLearnersTable: {
      deleteButton: 'Delete',
      addNewLearner: 'Add Learner',
      markAsActive: 'Mark Learners as Active',
      markAsInactive: 'Mark Learners as Inactive',
      markAsActiveInactive: 'Mark Learners as Active/Inactive',
      changeStatusGuidance: 'Select learners with the same status to update their status.',

      confirmMarkingInactive: 'Are you sure you want to mark learner(s) as inactive?',
      contentMarkingInactive: 'This will cancel the learner(s) account and also permanently remove all assigned training courses. <br/> To avoid losing any unused training packages, please transfer them to a new learner before proceeding.',
    },
    unassignedSeats: {
      title: 'Unassigned Seats',
      buySeats: 'Buy Seat(s)',
      assignSeats: 'Assign Seat(s)',
    },
    unassignedSections: {
      selectLearners: 'Select Learners',
      addNewLearner: 'Add Learner',
    },
    addNewLearnerDialog: {
      addNewLearner: 'Add Learner',
      firstName: 'First name',
      lastName: 'Last name',
      dob: 'Date Of Birth',
      emailAddress: 'Email address',
      jobTitle: 'Job title',
    },
    learnersTable: {
      bulkImport: 'Bulk Import',
      importLearnersInstructionDownloadTemplate: 'Add students in bulk by uploading a completed CSV Learners List template.',
      importLearnersInstructionUpload: 'Add your learners\' information to the template. Once done, you can upload your file here.',
      uploadLearnerList: 'Upload Learner List ',
      downloadSample: 'Download Template',
    },
    ancillary: {
      needHelp: 'Need Help',
      contactUs: 'Contact Us',
      text1: 'We are available to answer questions that are specifically related to the elearning training and course material',
      text2: 'If you have specific questions in regards to your business, please contact your local health department',
      callHelpDesk: 'Call Help Desk',
    },
    appFooter: {
      copyright: `©Copyright 2000-${currentYear} Premier Food Safety. All rights reserved.`,
    },
    coursePlayer: {
      select: 'Select',
      courseProgress: 'Course Progress',
      frameNotSupported: 'Your browser does not support frames.',
      certificateDialogTitle: 'Notification',
      certificateDialogMessage: 'Congratulations, your certificate has been emailed to you.',
      certificateDialogButtonText: 'OK',
      goToExam: 'Go to final exam',
      backToCourse: 'Back to course',
    },
    courseProgress: {
      purchased: 'Purchased',
      expires: 'Expires',
      buyLaminatedCard: 'Buy Credit Card Style Card',
      transfer: 'Transfer',
      download: 'Download',
      start: 'Start',
      continue: 'Continue',
      review: 'Review',
    },
    courses: {
      myCourses: 'My Courses',
      doNotHaveCoursesAndAssign: 'You currently do not have any courses assigned to you. Click above to assign.',
      doNotHaveCourses: 'You currently do not have any courses assigned to you.',
      noCompletedCourses: 'You currently do not have any completed courses.',
      instruction: 'Select a course to see the details.',
    },
    documentGenerationDialog: {
      header: 'Documents appear here',
      note1: 'Please regenerate the document before sending',
      note2: 'This might be blank when this screen loads the first time',
      generateDocument: 'Generate Document',
    },
    headerActions: {
      myPortal: 'Home',
      publicSite: 'Shop PFS',
      faq: 'FAQ',
      contactUs: 'Contact Us',
      myAccount: 'My Account',
      logout: 'Logout',
      purchase: 'Purchase',
      purchaseCourse: 'Purchase course',
      purchaseMore: 'Purchase more',
      purchaseComplete: 'Purchase Complete',
      learners: 'Learners',
      orders: 'Orders',
    },
    fmSurvey: {
      title: 'Get a $20 Amazon e-Gift Card',
      description: 'Complete our Food Manager survey and we will email you a $20 Amazon e-Gift Card within 1 week of completing it.',
      duration: 'Takes about 15 minutes',
      eligibilityLead: 'Eligibility: Only for those with',
      eligibilityYears: '3+ years',
      eligibilityTail: 'of experience working as a Food Manager',
      limit: 'Limit one survey per student.',
      takeSurvey: 'Take the Survey',
      giftIconAlt: 'Gift icon',
      clockIconAlt: 'Clock icon',
    },
    dashboardAnnouncement: {
      dismiss: 'Dismiss announcement',
    },
    logo: {
      title: 'Premier Food Safety',
    },
    profile: {
      registered: 'Registered',
      by: 'By',
      userId: 'User ID',
      editProfile: 'Edit profile',
    },
    stats: {
      assignSeats: 'Assign Seats',
      assigned: 'Assigned',
      classRegistrations: 'In-Person Food Manager',
      proctorURegistrations: 'Online Food Manager',
      elearningLicense: 'Online Courses',
      assignLicense: 'Assign License',
      assignCode: 'Assign Code',
      unassigned: 'Available',
      purchased: 'Purchased',
      yourPurchases: 'Purchases',
      noPurchases: 'You don\'t have any seats yet. Seats show up here once an order is paid.',
    },
    userInfo: {
      welcome: 'Welcome back',
    },
    faqs: {
      common: {
        title: 'Online Courses - FAQs',
        1: 'The screen is frozen. I can\'t click the next button or do anything.',
        2: 'Log out and log back in',
        3: 'Restart your computer',
        4: 'Safari browser is currently not supported. Please make sure to view the course using',
        5: 'They are recommended for the best training experience',
        6: 'Clear your cache. This is important if you are using a shared computer where someone may have previously taken the same course',
        7: 'Use a different computer',
        8: 'I can\'t get to the next slide.',
        9: 'Click the \'Next\' or \'Play\' button to move forward',
        10: 'Make sure you are using',
        11: 'or',
        12: 'as your browser.',
        13: 'I finished the training but I can\'t print the certificate.',
        14: `To print the certificate you must achieve the passing score as stated in the Final Quiz.
          If you have not achieved this, you will not be able to print your certificate.
          You are able to view your score(s) in 'My Course Progress'
          and, for most courses, you are also able to re-take the quiz until you pass.`,
        15: 'I printed the certificate and it has another person\'s name.',
        16: `Verify that you are using your own login information by going to 'Course Progress'
          and verifying that your name appears on the top left corner`,
        17: 'If you registered under a different name, we will not be able to make any changes after the certificate has been issued',
        18: 'The screen is frozen or it is loading slowly.',
      },
      general: {
        title: 'General FAQs',
        createAccount: 'How to create an Account',
        login: 'How to Log in to an Existing Account',
        assignOnlineCourses: 'How to Assign Online Courses to Yourself',
        selfRegister: 'How to Self-Register for an In-Person Class',
        updateUserInfo: 'How to Update Your User Info',
        accessOnlineGuide: 'How to Access the Online Study Guide',
        resetPassword: 'How to Reset Your Password',
      },
      individualTutorial: {
        title: 'Tutorials for Individual Users',
        studentPortalFeature: 'Complete Guide to Student Portal Features',
        startOnlineCourse: 'How to Start Your Online Training Course',
        accessClassInformation: 'How to Access In-Person Class Information',
        findExamCode: 'How to Find your ProctorU Exam Code',
      },
      groupAdminTutorial: {
        title: 'Tutorials for Group Admins',
        completeGuide: 'Complete Guide to Group Admin Portal Features',
        addNewLearner: 'How to Add a New Learner',
        addGroupLearners: 'How to Add a Group of Learners in Bulk',
        removeLearner: 'How to Remove a Learner',
        markLearnerInactive: 'How to Mark Learners as Inactive',
        assignPackage: 'How to Assign In-Person and Online Training Packages to Yourself and Others',
        emailLearnersGroup: 'How to Email a Group of Learners Enrolled in an Online Course',
        resendExam: 'How to Resend a ProctorU Exam and Instructions to a Learner',
        accessDownLoadCards: 'How to Access and Download Cards and/or Certificates for Learners taking an Online Course',
        transferUnusedCourse: 'How to Transfer an Unused Online Course to a New Learner',
        generateLeanerReports: 'How to Generate Learner Reports',
        updateLearnerEmail: 'How to Update a Learner’s Email Address',
        resendPassword: 'How to Resend Password to a Learner',
        updatePassword: 'How to Update Your Admin Password',
        addSavePayment: 'How to Add and Save Payment Methods to your Account',
        shopMainSite: 'How to Shop the Main PFS Site',
        purchaseTrainingPackage: 'How to Purchase Training Packages from the Group Admin Dashboard',
      },
    },
    myAccount: {
      title: 'My Account',
      resetPassword: 'Reset password',
      deactivate: 'Deactivate account',
      activate: 'Activate account',
      saveChanges: 'Save Changes',
      changeUsername: 'Change username',
      resetPasswordSuccessfully: 'Reset password successfully.',
      changeUsernameSuccessfully: 'Change username successfully.',
      deactivateAccountConfirmation: 'Are you sure you want to deactivate your account?',
      reminderSettings: 'Reminder Settings',
      certificateRenewalReminder: 'Certificate renewal reminder',
      certificateRenewalReminderNote: 'Receive an email reminder as your certificate expiration date approaches.',
      inPersonClassReminder: 'In-Person Food Manager class reminder',
      inPersonClassReminderNote: 'Receive an email reminder about upcoming In-Person Food Manager certification classes',
      smsCertificateRenewalReminder: 'SMS certificate renewal reminder',
      smsCertificateRenewalReminderNote: 'Receive a text message reminder as your certificate expiration date approaches.',
      saveReminderSettings: 'Save Reminder Settings',
    },
    contactUs: {
      name: 'Name',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      subject: 'Subject',
      comment: 'Comment',
      submit: 'Submit',
      submitting: 'Submitting...',
    },
    eLearning: {
      emailLearners: 'Email Learners',
      hideStudent: 'Hide Student',
      unhideStudent: 'Unhide Student',
      noAssignedCourses: 'You currently do not have any registrations.',
      buyLicenses: 'Buy Licenses',
      restartTraining: 'Restart Training',
      newELearningLicenses: 'New e-Learning Licenses',
      orderLaminatedCard: 'Order Laminated Card',
      congratulateOnExam: 'Congratulations on passing your exam',
      style: 'Style',
      buyACreditCard: 'Buy a Credit Card',
      preBoughtCreditCard: 'You pre-bought a Credit Card',
      laminatedCardDescription1: 'Food Handler Card for',
      laminatedCardDescription2: 'You\'ll receive it within 7-10 business days.',
      buyNow: 'Buy Now',
      continue: 'Continue',
      purchaseSuccess: 'Thank you for your purchase',
      purchaseLaminatedCardSuccessInfo: 'Your order is being processed. Please allow 7-10 business days to receive your card in the mail.',
      mailingNote: 'Enter the',
      mailingAddress: 'Mailing Address',
      mailingNote2: 'you want the card sent to.',
      laminatedCardNameNote: 'The following name will appear on your card. If the name is spelled incorrectly, please call us at 800-676-3121',
    },
    noteDrawer: {
      notes: 'Notes',
      addNote: 'Add Note',
      system: 'PFS System',
    },
    dashboard: {
      adminViewTitle: 'PFS Admin View',
      adminViewSubtitle: 'Home - User information',
      editUserInfo: 'edit-user-info-element',
      noGroupAdminWarning: 'Please select 1 Group Admin.',
      invalidUser: 'User ID is invalid. Please check it again.',
      unpaidOrders: {
        title: 'Unpaid Orders',
        description: 'These orders are awaiting payment. Seats become available once payment is received.',
        orderNumber: 'Order #',
        createdDate: 'Created Date',
        total: 'Total',
        balance: 'Balance Due',
        quickActions: 'Quick Actions',
        viewAllOrders: 'View all orders',
        latestNote: 'Showing the {count} most recent unpaid orders.',
      },
    },
    classRegistrations: {
      instructor: 'Instructor',
      forUser: 'for user',
      selectClassForRetest: 'Select Class for Retest',
      selectClassForReschedule: 'Select Class for Reschedule',
      notAllowReschedule: 'This registration seems too late to be RESCHEDULED. Only allowing the following status to be rescheduled: Approved, No-Show.',
      notAllowRetest: 'Only the following registration statuses accepted for retest: Attended, Completed-Fail.',
      notAllowDownloadCertificate: 'Only the following registration statuses accepted for downloading certificate: Completed-Pass.',
      certificateInProgress: 'Certificate is still in progress, please wait a little while.',
      select: 'Select',
      classMaterialsAndDocs: 'Class Materials & Docs',
      onlyAllow1Class: 'Please choose a class registration',
      notAllowOrderPrintedCopy: 'A printed copy is only available once students have taken and passed the ServSafe exam. This registration does not yet meet that criteria.',
      studentPortal: 'Student Portal',
      yes: 'Y',
      no: 'N',
      generalSettings: 'General Settings',
      actions: 'Actions',
      documents: 'Documents',
      reschedule: 'Reschedule',
      transfer: 'Transfer',
      retest: 'Retest',
      cancel: 'Cancel',
      emailCertificate: 'Download Certificate',
      setFlag: 'Set Flag',
      unsetFlag: 'Unset Flag',
      discount: 'Discount',
      classCancelled: 'Class Cancelled',
      package: 'Package',
      // Columns name here.
      confirmation: 'Conf',
      order: 'Order',
      regBy: 'Reg. by',
      coName: 'Co. Name',
      regDate: 'Reg. Date',
      classDate: 'Class Date',
      classLocation: 'Class Location',
      compStatus: 'Comp. Status',
      paid: 'Paid',
      attendStatus: 'Status',
      balance: 'Balance',
    },
    restartTraining: {
      confirmationText: 'Are you sure you want to restart training?',
      title: 'Restart Training',
    },
    registration: {
      descriptionForOrderFromApex: 'This registration is from APEX, please click confirm button to process to APEX site.',
    },
    paymentInformation: {
      text: 'Payment Information',
      useNewCreditCard: 'Use New Credit Card',
      removeSelectedCard: 'Remove Selected Card',
      pleaseChooseCard: 'Please select a card.',
      proceedToPayPal: 'Proceed to PayPal',
      proceedToPayPalNote: '* You will complete your payment in PayPal (a new window or a redirect may open depending on your browser).',
    },
    paymentOptions: {
      payByCreditCard: 'Pay by Credit Card',
      payByCheck: 'Pay by Check',
      payByApplePay: 'Apple Pay',
      payByPayPal: 'Pay by PayPal',
    },
    paymentInformationForm: {
      addAndChargeCreditCard: 'Add & Charge Credit Card',
      addCreditCard: 'Add Credit Card',
      type: 'Type',
      typePlaceholder: 'Credit Card',
      nameOnCard: 'Name on Card',
      enterPlaceholder: 'Enter',
      creditCardNumber: 'Credit Card Number',
      expiration: 'Expiration',
      monthPlaceholder: 'Month',
      yearPlaceholder: 'Year',
      billingAddress: 'Billing Address',
      billingZip: 'Billing Zip',
      CC2Sev: 'Security Code CVV/CVC',
      saveForFutureUse: 'Save for future use',
    },
    creditCard: {
      readableVisa: 'Visa Credit Card',
      readableMasterCard: 'Master Card',
      readableAmEx: 'American Express Card',
      readableDiscover: 'Discover Card',
      endingIn: 'ending in',
      unknown: 'Unknown',
    },
    paymentStatus: {
      paid: 'Paid',
      unpaid: 'Unpaid',
    },
    userTypeReadable: {
      client: 'Client',
      instructor: 'Instructor',
      staff: 'Staff',
      manager: 'Manager',
      admin: 'Admin',
      elearningManager: 'ELearning Manager',
      elearningStudent: 'ELearning Student',
      student: 'Student',
    },
    readableMyAccountTabs: {
      myPortal: 'My Portal',
      accountSettings: 'Account Settings',
      userInformation: 'User Information',
      paymentInformation: 'Payment Information',
    },
    notificationMessage: {
      default: 'Something went wrong!',
      commonSuccess: 'Success',
      missingRequiredFields: 'Please fill in all required fields.',
    },
    ordersService: {
      addOrChangeCreditCard: 'Add/Charge Credit card',
      addPayment: 'Add Payment',
      payNow: 'Pay Now',
    },
    cancelRegistrationDialog: {
      title: 'Cancel Registration',
      formTitle: '**** {days} days past class date ****',
      transactions: 'Transactions:',
      transactionsDescription: 'No payments found for this registration.',
      totalPaid: 'Total Paid:',
      proceedWithCancelation: 'Proceed with cancelation',
      refundRequested: 'Refund Requested',
      reason: 'Reason',
      type: 'Type',
      name: 'Name',
      amount: 'Amount',
      approve: 'Approve',
    },
    returnLicenseDialog: {
      return: 'Return',
      title: 'Return License',
      content: 'Return the {course} license assigned to {learner} back to available licenses? This cancels the assignment and the license can then be assigned to anyone in the group.',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    },
    transferCourseDialog: {
      title: 'Transfer Course',
      assign: 'Assign',
      transfer: 'Transfer',
    },
    transferClassRegistrationDialog: {
      title: 'Transfer Class',
      assign: 'Assign',
      note: 'Note',
    },
    generalSetting: {
      updateGeneralSettings: 'Update General Settings',
    },
    packageBenefits: {
      freeFoodHandlerCard: 'Free Food Handler Card',
      freeFoodHandlerCardTooltip: 'Transferable to employee',
      limitedTimeOffer: 'Limited-Time Offer',
    },
    checkout: {
      orderSummary: 'Order Summary',
      apply: 'Apply',
      total: 'Total',
      continueToCheckout: 'Continue to Checkout',
      removePackage: 'Remove Package',
      removePackageDialogContent: 'Are you sure you want to remove this package and all related discounts?',
      foodHandlerCardIncludedTitle: 'Food Handler Card Included',
      foodHandlerCardIncludedContent: 'A Food Handler Card is already included in your package. Do you still want to purchase the add-on?',
      freeFoodHandlerCardNote: 'Free with your Premium package. Transferable to employee.',
      confirm: 'Yes',
      cancel: 'No',
      removeDiscount: 'Remove Discount',
      removeDiscountDialogContent: 'Are you sure you want to remove this discount?',
      licenses: 'Licenses',
      includes: 'Includes',
      discountAppliedTo: 'Discount applied to',
      code: 'Code',
      purchase: 'Purchase',
      selectPackageForInformation: 'Please select package for more information',
      buyPackages: 'Buy Packages',
      startShopping: 'Start shopping',
      currentCartEmpty: 'Your shopping cart is currently empty',
    },
    reviewCart: {
      reviewYourCart: 'Review your cart',
    },
    createPaymentInformation: {
      unsupportedCardType: 'We support Visa, Amex, MasterCard, Discover only.',
    },
    userStatus: {
      active: 'Active',
      inactive: 'Inactive',
      activeInactive: 'Active/Inactive',
      all: 'All',
    },
    search: 'Search',
    searchExtendedCourses: 'Search by User ID, Order Id or Confirmation #',
    documentGenerationForm: {
      type: 'Type',
      to: 'To',
      from: 'From',
      cc: 'CC',
      additionalDocumentToAttach: 'Additional Document to Attach',
      addRegistrationNote: 'Add Registration Note (Optional)',
    },
    licenseStatus: {
      approved: 'Approved',
      attended: 'Attended',
      noShow: 'No-Show',
      completedPass: 'Completed-Pass',
      completedFail: 'Completed-Fail',
      cancelled: 'Cancelled',
      retestScheduled: 'Retest scheduled',
      chargeback: 'Chargeback',

      // Additional license status for online course.
      new: 'New',
      allocated: 'Allocated',
    },
    table: {
      viewing: 'Viewing',
      total: 'Total',
      noDataText: 'No data available',
      viewInfo: 'View Info',
    },
    time: {
      hours: 'hours',
      minutes: 'minutes',
      hour: 'hour',
      minute: 'minute',
    },
    packageType: {
      elearning: 'Online Courses',
      inPerson: 'In-Person Food Manager',
      proctoru: 'Online Food Manager',
    },
    languages: {
      english: 'English',
      spanish: 'Spanish',
      chinese: 'Chinese',
      korean: 'Korean',
    },
    transferPackage: {
      information: 'This list only shows eligible learners. Learners who have been assigned a package in this same category, or learners assigned an equivalent package in another category will not appear on this list.',
    },
    distances: {
      anyDistance: 'Any distance',
      miles: 'miles',
    },
    emailLearnersDialog: {
      emailLearner: 'Email Learners',
      subject: 'Subject',
      body: 'Body',
      from: 'From',
    },
    requireContactInfoDialog: {
      description: 'A mailing address and phone number are required to process the printed certificate. Please update your information in the My Account tab.',
      goToMyAccountTab: 'Go to My Account tab',
      useBillingAddress: 'Use the same as billing address',
    },
    registrationSuccessModal: {
      title: 'Welcome! Your Account is Ready',
      subTitle: 'Registration Complete!',
      info1: 'Your username and password have been emailed.',
      info2: 'Please save your login information:',
    },
    copied: 'Copied!',
    loading: 'Loading...',
    folderManager: {
      title: 'SCORM Upload Manager',
      uploadingLabel: 'Uploading SCORM Package:',
      uploadingDesc: 'This process may take a few minutes depending on file size. Please do not close this window.',
      infoAlert: 'Upload SCORM packages to S3. Existing folders will be replaced.',
      labels: {
        language: 'Language',
        s3Folder: 'S3 Folder',
        scormPackage: 'SCORM Package',
        targetFolder: 'Target Folder',
        warning: 'Warning:',
        uploadSuccess: 'Upload Successful',
        uploadError: 'Upload Error',
      },
      messages: {
        confirmUploadFor: 'Do you want to upload the SCORM package for',
        folderReplacedWarning: 'This action will permanently replace all existing files in the target S3 folder. This cannot be undone.',
        uploadSuccess: 'Folder uploaded successfully to S3.',
        uploadFailed: 'Upload failed.',
        connectionError: 'Please check your connection and try again.',
      },
      buttons: {
        upload: 'Upload to S3',
        confirmUpload: 'Confirm Upload',
        cancel: 'Cancel',
        close: 'Close',
      },
    },
    externalLmsClientKeys: {
      title: 'External LMS Client Keys',
      createButton: 'Create New Client Key',
      editHeader: 'Edit New Client Key',
      clientName: 'Client Name',
      clientKey: 'Client Key',
      active: 'Active',
      action: 'Action',
      createdDate: 'Created Date',
      courseIds: 'Course IDs',
      leaveEmptyForAll: 'Leave empty for all',
      courses: 'Courses',
      searchPlaceholder: 'Search by Name or Client Key',
      clientKeyHint: 'Min 10 characters, e.g. PANDA_12345',
      allCourses: '(All Courses)',
      domains: 'Domains',
      pricePerRegistration: 'Price per Registration ($)',
      messages: {
        fetchFailed: 'Failed to fetch client keys.',
        updateSuccess: 'External LMS client key updated successfully.',
        updateFailed: 'Failed to update client key.',
        createSuccess: 'External LMS client key created successfully.',
        createFailed: 'Failed to create client key.',
        nameRequired: 'Client name is required.',
        keyRequired: 'Client key is required.',
        keyMinLength: 'Client key must be at least 10 characters.',
        domainsRequired: 'At least one domain is required.',
        invalidDomain: 'Invalid domain format (e.g. example.com).',
        clientKeyAlreadyExists: 'This client key already exists.',
      },
    },
    dashboardAnnouncementAdmin: {
      title: 'Title',
      message: 'Message',
      plainTextHint: 'Plain text only. Line breaks are kept.',
      startTime: 'Start time',
      endTime: 'End time',
      enabled: 'Enabled',
      dateTimePlaceholder: 'mm/dd/yyyy hh:mm AM',
      createdBy: 'Created by {name} on {date}',
      updatedBy: 'Last updated by {name} on {date}',
      unknownUser: 'User #{id}',
      messages: {
        required: 'This field is required.',
        invalidDateTime: 'Enter a date and time as mm/dd/yyyy hh:mm AM/PM.',
        endAfterStart: 'End time must be after Start time.',
        saveSuccess: 'Announcement saved.',
        saveFailed: 'Could not save the announcement.',
        fetchFailed: 'Could not load the announcement.',
      },
    },
    externalLmsRegistrations: {
      title: 'External LMS Registrations',
      confirmation: 'Conf #',
      occurrence: 'Occurrence',
      externalLearnerId: 'External Learner ID',
      trainingStatus: 'Training Status',
      searchPlaceholder: 'Search by Client Key, User ID, Confirmation #',
      status: {
        notStarted: 'Not Started',
        inProgress: 'In Progress',
        completedPassed: 'Completed Passed',
        completedFailed: 'Completed Failed',
      },
      completedDate: 'Completed Date',
      startDate: 'Start Date',
      endDate: 'End Date',
      exportExcel: 'Export Excel',
      exportSuccess: 'Export is ready.',
      exportFailed: 'Failed to export registrations.',
      exportStartDateRequired: 'Please select a start date.',
      exportEndDateBeforeStart: 'End date must be on or after the start date.',
    },
    handlerTopPane: {
      foodHandlersCard: 'Food Handlers Card',
      startOnlineTraining: 'Start Online Training',
      groupDiscountsAvailable: 'Group discounts available',
      contactUs: 'Contact Us',
      features: [
        'ANAB-Accredited',
        'Approved by the California Department of Health',
        'Download & Print Card Instantly',
      ],
    },
    ctaForm: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      whichCounty: 'Which county do you work in?',
      selectYourCounty: 'Select Your County',
      continue: 'Continue',
      sanDiegoNotice: 'CA Food Handler Cards are not valid in San Diego County. If you work in San Diego County,',
      sanBernardinoNotice: 'CA Food Handler Card is not valid in San Bernardino County. For more information,',
      riversideNotice: 'CA Food Handler Card is not valid in Riverside County. For more information,',
      clickHere: 'click here.',
    },
    customerStats: {
      over45Years: 'Over 45 Years',
      ofExperience: 'Of Experience',
      over3Million: 'Over 3 Million',
      clientsTrained: 'Clients Trained',
      moneyGuarantee: 'Money Guarantee',
    },
    customerTestimonials: {
      addToCart: 'Add to Cart',
    },
    faqSection: {
      title: 'Frequently Asked Questions',
      ca: {
        q1: 'What is the California Food Handler Card Law?',
        a1: 'The California Food Handlers Card Law (based on SB303) requires all food handlers, unless exempt, to get a Food Handlers Card within 30 days of date of new hire and renew every 3 years.',
        q2: 'How do I get a ',
        q2_link: 'California Food Handlers Card?',
        q2_href: '/food-handlers-card/california',
        a2_start: 'The card issued upon successful completion of an ANAB-accredited food safety program, such as ',
        a2_link: 'Premier Food Safety',
        a2_end: ', and a 40-question exam with a minimum score of 70%.',
        q3: 'Who is considered a food handler?',
        a3: 'A food handler is any individual who is involved in the preparation, storage, or service of food in a food facility.',
        q4: 'Are there any exceptions to the California Food Handlers Card Law?',
        a4_title: 'Food handlers employed at any of the following are exempt from the law:',
        a4_list: [
          'Temporary food facilities (food booths),',
          'Certified farmers’ markets,',
          'Commissaries, grocery stores (including convenience stores),',
          'Licensed health care facilities,',
          'Mobile support units,',
          'Public and private school cafeterias,',
          'Restricted food service facilities,',
          'Retail stores where a majority of sales are from a pharmacy,',
          'Venues with snack bar services in which the majority of sales are from admission tickets,',
          'Certain food facilities with approved in-house food safety training,',
          'Food facilities subject to a collective bargaining agreement,',
          'Any city, county, city and county, state or regional facility used for the confinement of adults or minors, including, but not limited to, a county jail, juvenile hall, camp, ranch, or residential facility,',
          'An elderly nutrition program, administered by the California Department of Aging, and',
          'Food handlers working in the counties of Riverside, San Bernardino and San Diego and food handlers holding a valid Manager’s Food Safety Certificate.',
        ],
        q5: 'I work as a volunteer at a soup kitchen, food bank or a volunteer run restaurant. Do I require a Food Handlers Card?',
        a5: 'No, volunteers are exempt. The law only applies to employees who have been hired by food service establishments.',
        q6: 'Are grocery store employees required to get a Food Handlers Card?',
        a6: 'No, grocery stores are exempt from the ',
        a6_link: 'California Food Handlers Card law.',
        a6_href: '/food-handlers-card/california',
        q7: 'I work at a demonstration booth serving food samples at a grocery store. Am I required to get a California Food Handlers Card?',
        a7: 'No. Grocery store employees are exempt and demonstration companies are not permitted as food facilities.',
        q8: 'I currently hold a valid Manager’s Food Safety Certification. Do I need a California Food Handlers Card?',
        a8: 'No. The Food Manager Certification is a higher, more comprehensive certificate training that meets and exceeds the Food Handlers Card law requirements; therefore you are not required to obtain the Food Handlers Card.',
        q9: 'I am a part-time or temporary employee. Am I required to get a Food Handlers Card?',
        a9: 'Yes, all food handlers, regardless of how many hours they work, are required to obtain a Food Handlers Card, unless exempt.',
        q10: 'When will I get my Food Handlers Card?',
        a10: 'You will be able to download and print your Food Handlers Card as soon as you finish the online training and pass the final test.',
        q11: 'Do I have to complete the training all at once?',
        a11: 'No, you may complete the training in multiple sessions. Every time you log out of your account, your progress is saved, allowing you to resume the training later from the same section where you left off.',
        q12: 'What if I don’t have a printer at home to print my Food Handlers Card?',
        a12: 'If you don’t have access to a computer with a printer, you can still take the training online and, once you have passed the test, we can mail a printed copy of your California Food Handlers Card for an additional fee of $9.99.',
        q13: 'Is my employer responsible for paying for my training and Food Handlers Card?',
        a13: 'Yes. Effective January 1st, 2024, California Employers will be required to cover the cost of the food handler card training for all employees. For more information about the SB476 Law, please ',
        a13_link: 'click here',
        a13_href: '/food-handlers-card/california/sb476-law',
        q14: 'When will my food handlers card expire?',
        a14: 'The food handler card is valid for 3 years before you need to renew.',
        q15: 'Is my card valid anywhere in California?',
        a15_start: 'Your ',
        a15: ' is valid to work in any food service establishment in California, with the exception of those located in San Bernardino, Riverside and San Diego counties. These counties issue their own Food Handlers Cards.',
        a15_link: 'California Food Handlers Card',
        a15_href: '/food-handlers-card/california',
        q16: 'I need to get my Food Handlers Card but I do not have a computer, tablet or smartphone, what can I do?',
        a16_title: 'If you don’t have access to a computer or mobile device, here are a few suggestions:',
        a16_list: [
          'Go to your local library – computers are available for use to the public',
          'Ask a friend if you could borrow their computer for a few hours',
          'Talk to your supervisor about using a computer at work',
        ],
        q17: 'I work for multiple establishments. Do I need a Food Handlers Card for every single one of them?',
        a17: 'Generally, no. Your food handler card will be issued under your name and valid for 3 years, even if you start working for a different employer or work for two or more restaurants. However, if any of the establishments you work for is located in San Bernardino, San Diego or Riverside County, you will need to obtain a Food Handlers Card to work there. These counties issue their own food handler card.',
        q18: 'I currently work at a restaurant located in San Diego and hold a specific ',
        q18_link1: 'San Diego Food Handlers Card',
        q18_href1: '/food-handlers-card/san-diego-county',
        q18_mid: '. Am I required by law to get a ',
        q18_link2: 'California Food Handlers Card',
        q18_href2: '/food-handlers-card/california',
        q18_end: ' also?',
        a18: 'Yes, if you work for a restaurant outside San Diego County, such as Orange County, you need to get a California Food Handlers Card. This same rule applies if you are currently working for a restaurant in San Bernardino or Riverside County.',
        q19: 'What documentation are employers required to keep?',
        a19: 'Employers are responsible for maintaining accurate records that all food handlers employed by the establishment hold a valid California Food Handlers Card. An example of proper documentation would be to keep a copy of each food handler’s card on file, so it is available upon request to the next health inspector.',
        q20: 'If you have a group of 100 or more employees who need to be trained, please call us to receive a special group discount.',
        a20: 'For more information, call ',
        a20_phone: '800-676-3121',
        a20_phone_href: 'tel:+18006763121',
        a20_mid: ' or ',
        a20_link: 'request a quote',
        a20_href: '/food-handlers-card/california',
      },
    },
    estimateTime: {
      text: '90 mins',
      description: 'Estimated time to complete course + exam',
    },
    easyProcessVideo: {
      alt: 'How to Get a California Food Handlers Card',
      title: 'How to Get a California Food Handlers Card',
    },
    onlineProgram: {
      title: 'Join over 3 Million Satisfied Food Service Professionals',
      subTitle: 'Get your food handlers card with this 90-minute online certificate program',
      startedToday: 'Get started today',
    },
    aboutPfs: {
      subTitle: 'Industry Leader in Food Training',
      title: 'About Premier Food Safety',
      description: 'With over 45 years of experience, we are the leading providers of food safety training and certification solutions for the food service industry. Our accredited programs are approved by local health departments and designed to give you maximum flexibility when choosing training for yourself or your staff.',
      programs: 'We offer the ServSafe Food Manager Certification nationwide, and state-specific Food Handler Card programs to help you meet regulatory requirements easily and in an affordable manner.',
    },
    howItWorks: {
      caTitle: 'How to Get a CA Food Handler Card',
      caDescription: 'To get your card today, all you have to do is register, take the online course, and pass the exam. Your card will be ready for you to download immediately after. Watch the video for a step-by-step guide on the process.',
      easyProcess: 'Our Easy Process',
      step1: 'STEP 1',
      step2: 'STEP 2',
      step3: 'STEP 3',
    },
    steps: {
      step1: {
        title: 'Register & Train',
        languages: 'Languages: English, Spanish (Español), Chinese (中文), and Korean (한국어)',
        onlineCourseLength: '100% Online Course Length: 90 Minutes (including exam)',
        startAndStop: 'Start and Stop as Needed',
        features: 'Course features full text transcript and closed captioning',
      },
      step2: {
        title: 'Take the Exam',
        attempts: 'Number of exam attempts: Unlimited (after 2 failed attempts, the course must be viewed from the beginning)',
        passingScore: 'Minimum passing score: 70%',
        onlineAndMobile: '100% online and mobile friendly',
      },
      step3: {
        title: 'Print Card and Certificate',
        downloadAndPrint: 'Download & Print from Home',
        validFor3Years: 'Card Valid for 3 Years',
        acceptedThroughout: 'Accepted throughout California, except for Riverside, San Bernardino and San Diego Counties',
        accessFor1Year: 'Training Access for 1 Year',
      },
    },
    contactSection: {
      groupDiscount: 'Looking for a group discount?',
      contactUs: 'Contact us',
    },
    certifications: {
      alcohol: {
        location: 'California AB1825 and SB1343 Courses',
        title: 'Workplace California Harassment Prevention Training for Employees',
        items: [
          'Register for Online Training',
          'Complete the Course & Print Certificate of Completion',
        ],
        learnMore: 'Learn More',
      },
      foodManager: {
        location: 'California Food Manager Certification',
        title: 'ServSafe® Online Course + Online Exam',
        items: [
          'Register for ServSafe In-Person Class or Online Course',
          'Choose Paper-based or Online ServSafe Exam',
        ],
        selectPackage: 'Select a Package',
      },
    },
    resources: {
      title: 'Resources',
      items: {
        regulations: 'California Regulations',
        retailFoodCode: 'California Retail Food Code',
        practiceTest: 'Free Food Handler Practice Test',
        aboutCard: 'About the Food Handler Card',
        handwashing: 'Handwashing Guidelines',
        readyToEat: 'Guidelines for Preparing Ready-to-Eat Food',
      },
    },
    handlerTopPane: {
      foodHandlersCard: 'Food Handlers Card',
      startOnlineTraining: 'Start Online Training',
      groupDiscountsAvailable: 'Group discounts available',
      contactUs: 'Contact Us',
      features: [
        'ANAB-Accredited',
        'Approved by the California Department of Health',
        'Download & Print Card Instantly',
      ],
    },
    ctaForm: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      whichCounty: 'Which county do you work in?',
      selectYourCounty: 'Select Your County',
      continue: 'Continue',
      sanDiegoNotice: 'CA Food Handler Cards are not valid in San Diego County. If you work in San Diego County,',
      sanBernardinoNotice: 'CA Food Handler Card is not valid in San Bernardino County. For more information,',
      riversideNotice: 'CA Food Handler Card is not valid in Riverside County. For more information,',
      clickHere: 'click here.',
    },
    customerStats: {
      over45Years: 'Over 45 Years',
      ofExperience: 'Of Experience',
      over3Million: 'Over 3 Million',
      clientsTrained: 'Clients Trained',
      moneyGuarantee: 'Money Guarantee',
    },
    customerTestimonials: {
      addToCart: 'Add to Cart',
    },
    faqSection: {
      title: 'Frequently Asked Questions',
      ca: {
        q1: 'What is the California Food Handler Card Law?',
        a1: 'The California Food Handlers Card Law (based on SB303) requires all food handlers, unless exempt, to get a Food Handlers Card within 30 days of date of new hire and renew every 3 years.',
        q2: 'How do I get a ',
        q2_link: 'California Food Handlers Card?',
        q2_href: '/food-handlers-card/california',
        a2_start: 'The card issued upon successful completion of an ANAB-accredited food safety program, such as ',
        a2_link: 'Premier Food Safety',
        a2_end: ', and a 40-question exam with a minimum score of 70%.',
        q3: 'Who is considered a food handler?',
        a3: 'A food handler is any individual who is involved in the preparation, storage, or service of food in a food facility.',
        q4: 'Are there any exceptions to the California Food Handlers Card Law?',
        a4_title: 'Food handlers employed at any of the following are exempt from the law:',
        a4_list: [
          'Temporary food facilities (food booths),',
          'Certified farmers’ markets,',
          'Commissaries, grocery stores (including convenience stores),',
          'Licensed health care facilities,',
          'Mobile support units,',
          'Public and private school cafeterias,',
          'Restricted food service facilities,',
          'Retail stores where a majority of sales are from a pharmacy,',
          'Venues with snack bar services in which the majority of sales are from admission tickets,',
          'Certain food facilities with approved in-house food safety training,',
          'Food facilities subject to a collective bargaining agreement,',
          'Any city, county, city and county, state or regional facility used for the confinement of adults or minors, including, but not limited to, a county jail, juvenile hall, camp, ranch, or residential facility,',
          'An elderly nutrition program, administered by the California Department of Aging, and',
          'Food handlers working in the counties of Riverside, San Bernardino and San Diego and food handlers holding a valid Manager’s Food Safety Certificate.',
        ],
        q5: 'I work as a volunteer at a soup kitchen, food bank or a volunteer run restaurant. Do I require a Food Handlers Card?',
        a5: 'No, volunteers are exempt. The law only applies to employees who have been hired by food service establishments.',
        q6: 'Are grocery store employees required to get a Food Handlers Card?',
        a6: 'No, grocery stores are exempt from the ',
        a6_link: 'California Food Handlers Card law.',
        a6_href: '/food-handlers-card/california',
        q7: 'I work at a demonstration booth serving food samples at a grocery store. Am I required to get a California Food Handlers Card?',
        a7: 'No. Grocery store employees are exempt and demonstration companies are not permitted as food facilities.',
        q8: 'I currently hold a valid Manager’s Food Safety Certification. Do I need a California Food Handlers Card?',
        a8: 'No. The Food Manager Certification is a higher, more comprehensive certificate training that meets and exceeds the Food Handlers Card law requirements; therefore you are not required to obtain the Food Handlers Card.',
        q9: 'I am a part-time or temporary employee. Am I required to get a Food Handlers Card?',
        a9: 'Yes, all food handlers, regardless of how many hours they work, are required to obtain a Food Handlers Card, unless exempt.',
        q10: 'When will I get my Food Handlers Card?',
        a10: 'You will be able to download and print your Food Handlers Card as soon as you finish the online training and pass the final test.',
        q11: 'Do I have to complete the training all at once?',
        a11: 'No, you may complete the training in multiple sessions. Every time you log out of your account, your progress is saved, allowing you to resume the training later from the same section where you left off.',
        q12: 'What if I don’t have a printer at home to print my Food Handlers Card?',
        a12: 'If you don’t have access to a computer with a printer, you can still take the training online and, once you have passed the test, we can mail a printed copy of your California Food Handlers Card for an additional fee of $9.99.',
        q13: 'Is my employer responsible for paying for my training and Food Handlers Card?',
        a13: 'Yes. Effective January 1st, 2024, California Employers will be required to cover the cost of the food handler card training for all employees. For more information about the SB476 Law, please ',
        a13_link: 'click here',
        a13_href: '/food-handlers-card/california/sb476-law',
        q14: 'When will my food handlers card expire?',
        a14: 'The food handler card is valid for 3 years before you need to renew.',
        q15: 'Is my card valid anywhere in California?',
        a15_start: 'Your ',
        a15: ' is valid to work in any food service establishment in California, with the exception of those located in San Bernardino, Riverside and San Diego counties. These counties issue their own Food Handlers Cards.',
        a15_link: 'California Food Handlers Card',
        a15_href: '/food-handlers-card/california',
        q16: 'I need to get my Food Handlers Card but I do not have a computer, tablet or smartphone, what can I do?',
        a16_title: 'If you don’t have access to a computer or mobile device, here are a few suggestions:',
        a16_list: [
          'Go to your local library – computers are available for use to the public',
          'Ask a friend if you could borrow their computer for a few hours',
          'Talk to your supervisor about using a computer at work',
        ],
        q17: 'I work for multiple establishments. Do I need a Food Handlers Card for every single one of them?',
        a17: 'Generally, no. Your food handler card will be issued under your name and valid for 3 years, even if you start working for a different employer or work for two or more restaurants. However, if any of the establishments you work for is located in San Bernardino, San Diego or Riverside County, you will need to obtain a Food Handlers Card to work there. These counties issue their own food handler card.',
        q18: 'I currently work at a restaurant located in San Diego and hold a specific ',
        q18_link1: 'San Diego Food Handlers Card',
        q18_href1: '/food-handlers-card/san-diego-county',
        q18_mid: '. Am I required by law to get a ',
        q18_link2: 'California Food Handlers Card',
        q18_href2: '/food-handlers-card/california',
        q18_end: ' also?',
        a18: 'Yes, if you work for a restaurant outside San Diego County, such as Orange County, you need to get a California Food Handlers Card. This same rule applies if you are currently working for a restaurant in San Bernardino or Riverside County.',
        q19: 'What documentation are employers required to keep?',
        a19: 'Employers are responsible for maintaining accurate records that all food handlers employed by the establishment hold a valid California Food Handlers Card. An example of proper documentation would be to keep a copy of each food handler’s card on file, so it is available upon request to the next health inspector.',
        q20: 'If you have a group of 100 or more employees who need to be trained, please call us to receive a special group discount.',
        a20: 'For more information, call ',
        a20_phone: '800-676-3121',
        a20_phone_href: 'tel:+18006763121',
        a20_mid: ' or ',
        a20_link: 'request a quote',
        a20_href: '/food-handlers-card/california',
      },
    },
    estimateTime: {
      text: '90 mins',
      description: 'Estimated time to complete course + exam',
    },
    easyProcessVideo: {
      alt: 'How to Get a California Food Handlers Card',
      title: 'How to Get a California Food Handlers Card',
    },
    onlineProgram: {
      title: 'Join over 3 Million Satisfied Food Service Professionals',
      subTitle: 'Get your food handlers card with this 90-minute online certificate program',
      startedToday: 'Get started today',
    },
    aboutPfs: {
      subTitle: 'Industry Leader in Food Training',
      title: 'About Premier Food Safety',
      description: 'With over 45 years of experience, we are the leading providers of food safety training and certification solutions for the food service industry. Our accredited programs are approved by local health departments and designed to give you maximum flexibility when choosing training for yourself or your staff.',
      programs: 'We offer the ServSafe Food Manager Certification nationwide, and state-specific Food Handler Card programs to help you meet regulatory requirements easily and in an affordable manner.',
    },
    howItWorks: {
      caTitle: 'How to Get a CA Food Handler Card',
      caDescription: 'To get your card today, all you have to do is register, take the online course, and pass the exam. Your card will be ready for you to download immediately after. Watch the video for a step-by-step guide on the process.',
      easyProcess: 'Our Easy Process',
      step1: 'STEP 1',
      step2: 'STEP 2',
      step3: 'STEP 3',
    },
    steps: {
      step1: {
        title: 'Register & Train',
        languages: 'Languages: English, Spanish (Español), Chinese (中文), and Korean (한국어)',
        onlineCourseLength: '100% Online Course Length: 90 Minutes (including exam)',
        startAndStop: 'Start and Stop as Needed',
        features: 'Course features full text transcript and closed captioning',
      },
      step2: {
        title: 'Take the Exam',
        attempts: 'Number of exam attempts: Unlimited (after 2 failed attempts, the course must be viewed from the beginning)',
        passingScore: 'Minimum passing score: 70%',
        onlineAndMobile: '100% online and mobile friendly',
      },
      step3: {
        title: 'Print Card and Certificate',
        downloadAndPrint: 'Download & Print from Home',
        validFor3Years: 'Card Valid for 3 Years',
        acceptedThroughout: 'Accepted throughout California, except for Riverside, San Bernardino and San Diego Counties',
        accessFor1Year: 'Training Access for 1 Year',
      },
    },
    contactSection: {
      groupDiscount: 'Looking for a group discount?',
      contactUs: 'Contact us',
    },
    certifications: {
      alcohol: {
        location: 'California AB1825 and SB1343 Courses',
        title: 'Workplace California Harassment Prevention Training for Employees',
        items: [
          'Register for Online Training',
          'Complete the Course & Print Certificate of Completion',
        ],
        learnMore: 'Learn More',
      },
      foodManager: {
        location: 'California Food Manager Certification',
        title: 'ServSafe® Online Course + Online Exam',
        items: [
          'Register for ServSafe In-Person Class or Online Course',
          'Choose Paper-based or Online ServSafe Exam',
        ],
        selectPackage: 'Select a Package',
      },
    },
    resources: {
      title: 'Resources',
      items: {
        regulations: 'California Regulations',
        retailFoodCode: 'California Retail Food Code',
        practiceTest: 'Free Food Handler Practice Test',
        aboutCard: 'About the Food Handler Card',
        handwashing: 'Handwashing Guidelines',
        readyToEat: 'Guidelines for Preparing Ready-to-Eat Food',
      },
    },
    handlerTopPane: {
      foodHandlersCard: 'Food Handlers Card',
      startOnlineTraining: 'Start Online Training',
      groupDiscountsAvailable: 'Group discounts available',
      contactUs: 'Contact Us',
      features: [
        'ANAB-Accredited',
        'Approved by the California Department of Health',
        'Download & Print Card Instantly',
      ],
    },
    ctaForm: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      whichCounty: 'Which county do you work in?',
      selectYourCounty: 'Select Your County',
      continue: 'Continue',
      sanDiegoNotice: 'CA Food Handler Cards are not valid in San Diego County. If you work in San Diego County,',
      sanBernardinoNotice: 'CA Food Handler Card is not valid in San Bernardino County. For more information,',
      riversideNotice: 'CA Food Handler Card is not valid in Riverside County. For more information,',
      clickHere: 'click here.',
    },
    customerStats: {
      over45Years: 'Over 45 Years',
      ofExperience: 'Of Experience',
      over3Million: 'Over 3 Million',
      clientsTrained: 'Clients Trained',
      moneyGuarantee: 'Money Guarantee',
    },
    customerTestimonials: {
      addToCart: 'Add to Cart',
    },
    faqSection: {
      title: 'Frequently Asked Questions',
      ca: {
        q1: 'What is the California Food Handler Card Law?',
        a1: 'The California Food Handlers Card Law (based on SB303) requires all food handlers, unless exempt, to get a Food Handlers Card within 30 days of date of new hire and renew every 3 years.',
        q2: 'How do I get a ',
        q2_link: 'California Food Handlers Card?',
        q2_href: '/food-handlers-card/california',
        a2_start: 'The card issued upon successful completion of an ANAB-accredited food safety program, such as ',
        a2_link: 'Premier Food Safety',
        a2_end: ', and a 40-question exam with a minimum score of 70%.',
        q3: 'Who is considered a food handler?',
        a3: 'A food handler is any individual who is involved in the preparation, storage, or service of food in a food facility.',
        q4: 'Are there any exceptions to the California Food Handlers Card Law?',
        a4_title: 'Food handlers employed at any of the following are exempt from the law:',
        a4_list: [
          'Temporary food facilities (food booths),',
          'Certified farmers’ markets,',
          'Commissaries, grocery stores (including convenience stores),',
          'Licensed health care facilities,',
          'Mobile support units,',
          'Public and private school cafeterias,',
          'Restricted food service facilities,',
          'Retail stores where a majority of sales are from a pharmacy,',
          'Venues with snack bar services in which the majority of sales are from admission tickets,',
          'Certain food facilities with approved in-house food safety training,',
          'Food facilities subject to a collective bargaining agreement,',
          'Any city, county, city and county, state or regional facility used for the confinement of adults or minors, including, but not limited to, a county jail, juvenile hall, camp, ranch, or residential facility,',
          'An elderly nutrition program, administered by the California Department of Aging, and',
          'Food handlers working in the counties of Riverside, San Bernardino and San Diego and food handlers holding a valid Manager’s Food Safety Certificate.',
        ],
        q5: 'I work as a volunteer at a soup kitchen, food bank or a volunteer run restaurant. Do I require a Food Handlers Card?',
        a5: 'No, volunteers are exempt. The law only applies to employees who have been hired by food service establishments.',
        q6: 'Are grocery store employees required to get a Food Handlers Card?',
        a6: 'No, grocery stores are exempt from the ',
        a6_link: 'California Food Handlers Card law.',
        a6_href: '/food-handlers-card/california',
        q7: 'I work at a demonstration booth serving food samples at a grocery store. Am I required to get a California Food Handlers Card?',
        a7: 'No. Grocery store employees are exempt and demonstration companies are not permitted as food facilities.',
        q8: 'I currently hold a valid Manager’s Food Safety Certification. Do I need a California Food Handlers Card?',
        a8: 'No. The Food Manager Certification is a higher, more comprehensive certificate training that meets and exceeds the Food Handlers Card law requirements; therefore you are not required to obtain the Food Handlers Card.',
        q9: 'I am a part-time or temporary employee. Am I required to get a Food Handlers Card?',
        a9: 'Yes, all food handlers, regardless of how many hours they work, are required to obtain a Food Handlers Card, unless exempt.',
        q10: 'When will I get my Food Handlers Card?',
        a10: 'You will be able to download and print your Food Handlers Card as soon as you finish the online training and pass the final test.',
        q11: 'Do I have to complete the training all at once?',
        a11: 'No, you may complete the training in multiple sessions. Every time you log out of your account, your progress is saved, allowing you to resume the training later from the same section where you left off.',
        q12: 'What if I don’t have a printer at home to print my Food Handlers Card?',
        a12: 'If you don’t have access to a computer with a printer, you can still take the training online and, once you have passed the test, we can mail a printed copy of your California Food Handlers Card for an additional fee of $9.99.',
        q13: 'Is my employer responsible for paying for my training and Food Handlers Card?',
        a13: 'Yes. Effective January 1st, 2024, California Employers will be required to cover the cost of the food handler card training for all employees. For more information about the SB476 Law, please ',
        a13_link: 'click here',
        a13_href: '/food-handlers-card/california/sb476-law',
        q14: 'When will my food handlers card expire?',
        a14: 'The food handler card is valid for 3 years before you need to renew.',
        q15: 'Is my card valid anywhere in California?',
        a15_start: 'Your ',
        a15: ' is valid to work in any food service establishment in California, with the exception of those located in San Bernardino, Riverside and San Diego counties. These counties issue their own Food Handlers Cards.',
        a15_link: 'California Food Handlers Card',
        a15_href: '/food-handlers-card/california',
        q16: 'I need to get my Food Handlers Card but I do not have a computer, tablet or smartphone, what can I do?',
        a16_title: 'If you don’t have access to a computer or mobile device, here are a few suggestions:',
        a16_list: [
          'Go to your local library – computers are available for use to the public',
          'Ask a friend if you could borrow their computer for a few hours',
          'Talk to your supervisor about using a computer at work',
        ],
        q17: 'I work for multiple establishments. Do I need a Food Handlers Card for every single one of them?',
        a17: 'Generally, no. Your food handler card will be issued under your name and valid for 3 years, even if you start working for a different employer or work for two or more restaurants. However, if any of the establishments you work for is located in San Bernardino, San Diego or Riverside County, you will need to obtain a Food Handlers Card to work there. These counties issue their own food handler card.',
        q18: 'I currently work at a restaurant located in San Diego and hold a specific ',
        q18_link1: 'San Diego Food Handlers Card',
        q18_href1: '/food-handlers-card/san-diego-county',
        q18_mid: '. Am I required by law to get a ',
        q18_link2: 'California Food Handlers Card',
        q18_href2: '/food-handlers-card/california',
        q18_end: ' also?',
        a18: 'Yes, if you work for a restaurant outside San Diego County, such as Orange County, you need to get a California Food Handlers Card. This same rule applies if you are currently working for a restaurant in San Bernardino or Riverside County.',
        q19: 'What documentation are employers required to keep?',
        a19: 'Employers are responsible for maintaining accurate records that all food handlers employed by the establishment hold a valid California Food Handlers Card. An example of proper documentation would be to keep a copy of each food handler’s card on file, so it is available upon request to the next health inspector.',
        q20: 'If you have a group of 100 or more employees who need to be trained, please call us to receive a special group discount.',
        a20: 'For more information, call ',
        a20_phone: '800-676-3121',
        a20_phone_href: 'tel:+18006763121',
        a20_mid: ' or ',
        a20_link: 'request a quote',
        a20_href: '/food-handlers-card/california',
      },
    },
    estimateTime: {
      text: '90 mins',
      description: 'Estimated time to complete course + exam',
    },
    easyProcessVideo: {
      alt: 'How to Get a California Food Handlers Card',
      title: 'How to Get a California Food Handlers Card',
    },
    onlineProgram: {
      title: 'Join over 3 Million Satisfied Food Service Professionals',
      subTitle: 'Get your food handlers card with this 90-minute online certificate program',
      startedToday: 'Get started today',
    },
    aboutPfs: {
      subTitle: 'Industry Leader in Food Training',
      title: 'About Premier Food Safety',
      description: 'With over 45 years of experience, we are the leading providers of food safety training and certification solutions for the food service industry. Our accredited programs are approved by local health departments and designed to give you maximum flexibility when choosing training for yourself or your staff.',
      programs: 'We offer the ServSafe Food Manager Certification nationwide, and state-specific Food Handler Card programs to help you meet regulatory requirements easily and in an affordable manner.',
    },
    howItWorks: {
      caTitle: 'How to Get a CA Food Handler Card',
      caDescription: 'To get your card today, all you have to do is register, take the online course, and pass the exam. Your card will be ready for you to download immediately after. Watch the video for a step-by-step guide on the process.',
      easyProcess: 'Our Easy Process',
      step1: 'STEP 1',
      step2: 'STEP 2',
      step3: 'STEP 3',
    },
    steps: {
      step1: {
        title: 'Register & Train',
        languages: 'Languages: English, Spanish (Español), Chinese (中文), and Korean (한국어)',
        onlineCourseLength: '100% Online Course Length: 90 Minutes (including exam)',
        startAndStop: 'Start and Stop as Needed',
        features: 'Course features full text transcript and closed captioning',
      },
      step2: {
        title: 'Take the Exam',
        attempts: 'Number of exam attempts: Unlimited (after 2 failed attempts, the course must be viewed from the beginning)',
        passingScore: 'Minimum passing score: 70%',
        onlineAndMobile: '100% online and mobile friendly',
      },
      step3: {
        title: 'Print Card and Certificate',
        downloadAndPrint: 'Download & Print from Home',
        validFor3Years: 'Card Valid for 3 Years',
        acceptedThroughout: 'Accepted throughout California, except for Riverside, San Bernardino and San Diego Counties',
        accessFor1Year: 'Training Access for 1 Year',
      },
    },
    contactSection: {
      groupDiscount: 'Looking for a group discount?',
      contactUs: 'Contact us',
    },
    certifications: {
      alcohol: {
        location: 'California AB1825 and SB1343 Courses',
        title: 'Workplace California Harassment Prevention Training for Employees',
        items: [
          'Register for Online Training',
          'Complete the Course & Print Certificate of Completion',
        ],
        learnMore: 'Learn More',
      },
      foodManager: {
        location: 'California Food Manager Certification',
        title: 'ServSafe® Online Course + Online Exam',
        items: [
          'Register for ServSafe In-Person Class or Online Course',
          'Choose Paper-based or Online ServSafe Exam',
        ],
        selectPackage: 'Select a Package',
      },
    },
    resources: {
      title: 'Resources',
      items: {
        regulations: 'California Regulations',
        retailFoodCode: 'California Retail Food Code',
        practiceTest: 'Free Food Handler Practice Test',
        aboutCard: 'About the Food Handler Card',
        handwashing: 'Handwashing Guidelines',
        readyToEat: 'Guidelines for Preparing Ready-to-Eat Food',
      },
    },
    ...examPlayerI18n,
    ...itemBankAdminI18n,
    ...itemBankContentI18n,
    ...itemBankSetupI18n,
    ...itemBankExamsI18n,
    ...itemBankExamStatsI18n,
    ...smeWorkspaceI18n,
  },

  // Spanish
  es: {
    confirmDialog: {
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    },
    commonConfirmDialog: {
      title: 'Confirmación',
      content: '¿Estás seguro que quieres continuar con esta acción?',
      unsavedChange: 'Do you want to close the dialog?',
      confirmation: 'Confirmation',
    },
    commonDeleteDialog: {
      title: 'Borrar',
      content: '¿Estás seguro que quieres borrar esto?',
    },
    editProfile: {
      userId: 'User ID',
      firstName: 'First Name',
      lastName: 'Last Name',
      middleName: 'Middle Name',
      company: 'Company',
      jobTitle: 'Job Title',
      address: 'Address',
      unitSuitApt: 'Unit/Suite/Apt #',
      dob: 'Date of Birth',
      language: 'Language',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      additionalPhoneNumber: 'Additional Phone Number',
      updateProfileSuccess: 'Update your information successfully',

      addDateOfBirth: 'Add date of birth',
      courseRequireDob: 'This course require date of birth to proceed. Please input your date of birth.',
    },
    viewLearnerDetail: {
      apexRegistration: 'This registration is belong to Apex site. Please log in on Apex site to see detail',
      view: 'View',
    },
    accountSetting: {
      status: 'Status',
      userName: 'Username',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
    },
    paymentDialog: {
      addOrChargeCreditCard: 'Agregar/Cargar a Tarjeta de Crédito',
      payment: 'Pago',
      choosePaymentMethods: 'Elige tu forma de pago',
      chargeSelectedCard: 'Usar la tarjeta seleccionada',
      checkName: 'Nombre en el Cheque',
      checkNumber: 'Número de Cheque',
      amount: 'Cantidad ($)',
      payWithoutCheck: 'Pagar sin cheque',
      proceedWithoutCheck: 'Continuar sin cheque',
      checkInfoNotRequired: 'Información de cheque no requerida',
      allowSeatAssignmentsWithoutCheck: 'Permitir asignación de asientos sin cheque',
      pleaseMailYourCheckTo: 'Por favor envía tu cheque por correo a',
      groupAdminNoticeMessage: 'LOS PAQUETES SE ACTIVARÁN UNA VEZ QUE SE HAYA RECIBIDO EL PAGO',
    },
    title: {
      assignedSeats: 'Asientos Asignados',
      assigned: 'Asignado',
      classRegistrations: 'Gerente de Alimentos Presencial',
      proctorURegistrations: 'Gerente de Alimentos en Línea',
      actions: 'Acciones',
      orders: 'Tus Compras',
      adminELearning: 'Cursos en Línea',
      studentELearning: 'Cursos en Línea',
      learners: 'Usuarios',
      accountSettings: 'Configuración de Cuenta',
    },
    button: {
      getStarted: 'Comenzar',
      excelReport: 'Reporte en Excel',
      hideUnhideRegistrations: 'Ocultar/Mostrar registros',
      hideRegistrations: 'Ocultar registros',
      unhideRegistrations: 'Mostrar registros',
      emailCertificate: 'Enviar Certificado por Email',
      downloadCertificates: 'Descargar Certificados',
      resendPassword: 'Reenviar Contraseña',
      submit: 'Ingresar',
      generate: 'Generar',
      send: 'Enviar',
      orderPrintedCopy: 'Comprar Copia Impresa',
      downloadCertificate: 'Descargar Certificado',
      downloadCert: 'Descargar Certificado',
      save: 'Guardar',
      edit: 'Modificar',
      continueToCheckout: 'Continuar al Pago',
      documents: 'Documentos',
      back: 'Regresar',
      markAsPaid: 'Marcar como pagado',
      pay: 'Pagar',
      remove: 'Eliminar',
      cancel: 'Cancelar',
      close: 'Cerrar',
      refund: 'Reembolsar',
      refunded: 'Reembolsado',
      classRegistrationRefunded: 'Esta clase fue reembolsada',
      proctorURefunded: 'Este código fue reembolsado',
      eLearningRefunded: 'Este curso fue reembolsado',
      notSupportRefundByCheck: 'El sistema no acepta reembolsos si el pago es con cheque',
      notSupportRefundByPaymentMethod: 'El sistema no acepta reembolsos si el pago es con {paymentMethod}',
      applyToSelected: 'Aplicar a Seleccionado',
      create: 'Crear',
      download: 'Descargar',
      expandMore: 'Expandir más',
    },
    header: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      serverId: 'ID de servidor',
      status: 'Status',
      emailAddress: 'Correo electrónico',
      email: 'Correo electrónico',
      userId: 'ID de Usuario',
      instructorNotes: 'Instructor Notes',
    },
    deleteLearnerDialog: {
      title: 'Eliminar Usuario',
      content: '¿Estás seguro que quieres eliminar este usuario?',
      pfsAdminContent: 'Esta acción desasignará al estudiante de todos los cursos de formación asignados con el estado NOT_STARTED.',
    },
    updateLearnerPosition: {
      update: 'Actualizar',
    },
    updateLearnerProgress: {
      update: 'Actualizar',
    },
    form: {
      requiredField: 'Campo obligatorio',
    },

    // Components start from here.
    addQuizForm: {
      addAttempt: 'Agregar Intento',
      addAttemptPlaceholder: 'Seleccionar Examen',
      add: 'Add',
    },
    assignedCourseDetail: {
      generalSettings: 'Configuración General',
      examResults: 'Resultados',
      actions: 'Acciones',
      updateLearnerPosition: 'Actualizar Posición de Usuario',
      currentProgress: 'Progreso Actual',
      studentInfo: 'Información de Usuario',
      studentCourses: 'Cursos Asignados al Usuario',
      close: 'Cerrar',
      saveCurrentProgressAs: 'Save current position as',
      details: 'Detalles',
    },
    assignedCourse: {
      course: 'Curso',
      packageInfo: 'Información de Paquete',
      createdDate: 'Fecha de Creación',
      courseExpiration: 'Fecha de Expiración',
      courseStatus: 'Estatus del Curso',
      hide: 'Hide Learners',
      unhide: 'Unhide Learners',
      hideUnhideLearners: 'Hide/Unhide Learners',
      changeVisibilityGuidance: 'Select learners to update visibility',
      hiddenUnhidden: 'Hidde/Unhidden',
    },
    visibility: {
      hidden: 'Hidden',
      unhidden: 'Unhidden',
    },
    courseStatus: {
      notStarted: 'Sin Empezar',
      inProgress: 'En Progreso',
      completed: 'Completo',
      active: 'Activo',
      expired: 'Vencido',
      notExpired: 'No Vencido',
    },
    assignedCourseTable: {
      userId: 'ID de Usuario',
      confirmation: 'Confirmación',
      assignedDate: 'Fecha Asignación',
      expiredDate: 'Fecha Expiración',
      course: 'Curso',
      order: 'Pedido',
      serverId: 'ID de servidor',
      licenseStatus: 'Estatus Licencia',
      quickActions: 'Quick Actions',
      trainingStatus: 'Estatus del Curso',
      courseProgress: 'Progreso del Curso',
      completed: 'Completado',
      verificationCode: 'Código de Verificación',
      studentName: 'Nombre Usuario',
      admin: 'Admin',
    },
    assignedProctorU: {
      assigned: 'Asignado',
      sent: 'Enviado',
      transferPackage: 'Transferir Paquete',
      notSentYet: 'No Enviado',
      unassigned: 'No Asignado',
      resendExamCode: 'Reenviar Código de Examen',
      confirmation: 'Confirmación',
      studentName: 'Nombre del Alumno',
      purchaseDate: 'Fecha de Compra',
      assignDate: 'Fecha de Asignación',
      examCode: 'Código de Examen',
      packageInfo: 'Información Paquete',
      packageName: 'Nombre del Paquete',
      order: 'Pedido',
      resendCodeSuccessfully: 'El código ha sido enviado exitosamente',
      resendCodesSuccessfully: 'Todos los códigos han sido enviados exitosamente.',
      actions: 'Acciones',
      documents: 'Documentos',
      proctorURegistrations: 'Registros ProctorU',
      dateSent: 'Fecha de Envío',
      restartTraining: 'Reiniciar Curso',
      buyExamCodes: 'Comprar Códigos de Examen',
      noAssignedRegistrations: 'Aún no has comprado ningún paquete en esta categoría.',
      code: 'Code',
      willBeTransferredFrom: 'will be transferred from',
      to: 'to',
    },
    proctorUColumns: {
      conf: 'Conf',
      order: 'Orden',
      regDate: 'Fecha de Registro',
      paid: 'Pagado',
      balance: 'Adeudo',
      registeredBy: 'Registrado por',
      companyName: 'Nombre Negocio',
      status: 'Estatus',
      examCode: 'Código de Examen',
    },
    assignedSeats: {
      confirmation: 'Confirmación',
      studentName: 'Nombre del Alumno',
      order: 'Pedido',
      createdDate: 'Fecha de Creación',
      state: 'Estado',
      classInfo: 'Info de Clase',
      packageInfo: 'Información del Paquete',
      packageName: 'Nombre del Paquete',
      attendStatus: 'Estatus Asistencia',
      balance: 'Adeudo',
      websiteOrLinks: 'Página Web / Links',
      studentPortal: 'Documentos del Alumno',
      classLocation: 'Ubicación de la Clase',
      classDate: 'Fecha de Clase',
      schedule: 'Horario',
      noDataText: 'No se encontraron registros.',
      haveNoRegistrations: 'Aún no has comprado ningún paquete en esta categoría',
      buySeats: 'Comprar Lugares',
      newClassRegistration: 'Nuevo Registro a Clase',
      expirationDate: 'Fecha de Expiración',
      selectDate: 'Elegir Fecha',
    },
    assignment: {
      state: 'State',
      addLine: 'Add line',
      online: 'Online Courses',
      almostFull: 'Almost full',
      full: 'Full',
      inPerson: 'Gerente de Alimentos Presencial',
      proctorU: 'Gerente de Alimentos en Línea',
      selectPackageToSeeLearnersList: 'Select a package to load learners list',
      classLanguage: 'Class language',
      year: 'Year',
      package: 'Package',
      assigned: 'assigned',
      assignedSuccessfully: 'Assigned Successfully',
      step1: 'Selecciona Paquetes Disponibles - Paso 1',
      step2: 'Seleccionar Usuarios - Paso 2',
      step3: 'Asignar Asientos - Paso 3',
      assignLearners: 'Assign Learners',
      done: 'Done',
      noLearnerAvailable: 'No learners available',
      selectAtLeastOneLearner: 'You must add at least one learner to assign to the selected package',
      next: 'Next',
      courseRequireDob: 'This course requires the learner’s date of birth to comply with local regulatory authority reporting guidelines. Please make sure you enter the correct date below.',
      importAndAssignComplete: 'Import and assign package to learners complete',
      learnerSelectedExceedQuantity: 'El número de usuarios seleccionados excede el número de paquetes disponibles.',
      selectAvailablePackagesSubtitle: 'Todos los productos en el paquete se asignarán al mismo usuario',
      learners: 'Usuarios',
      success: 'Acción completada con éxito',
      successSubtitle: 'Has asignado con exito los siguientes paquetes a {learnerNumber} usuario(s).',
      packageIncludes: 'Paquete Incluye',
      show: 'Mostrar',
      enroll: 'Registrar',
      states: 'Estado',
      businessZipCode: 'Código Postal del Negocio',
      inactiveLearnersInSelections: 'There are inactive learners in selection list. Please deselect those learners.',
      location: 'Location',
      miles: 'Distancia',
      language: 'Idioma',
      selected: 'Seleccionado',
      select: 'Seleccíonar',
      selectedLearners: 'Usuarios Seleccionados',
      packageSelected: 'Paquete Seleccionado',
      remainingQuantity: '{quantity} paquetes disponibles',
      productList: 'Lista de Productos',
      enrollAndContinue: 'Registrar y Continuar',
      footerNote: 'Todos los productos en el paquete se asignan al mismo usuario.',
      classCancelled: 'Clase Cancelada',
      rescheduleFee: 'Cargo por Reprogramación',
      note: 'Nota',
      rescheduleRegistration: 'Reprogramar Clase',
      skipForNow: 'Completar más Tarde',
      skipForNowNote1: 'Este paquete también incluye una clase presencial.',
      skipForNowNote2: 'Por favor selecciona una fecha para la clase presencial',
      selectExamLanguage: 'Seleccionar Idioma del Examen',
      assign: 'Asignar',
      selectPackage: 'Paquete Seleccionado',
      selectAPackage: 'Seleccionar paquete',
      noPackageAvailable: 'No hay paquetes disponibles',

      rbsInstruction1: 'El Depto. de Control de Bebidas Alcohólicas de California requiere que todos los servidores',
      createRbsAccount: 'abrir una cuenta RBS.',
      rbsInstruction2: ' obtengan un número de identificación o Server ID antes de comenzar el curso de RBS.',
      rbsInstruction3: 'El Depto. de Control de Bebidas Alcohólicas de California requiere que todos los servidores obtengan un Server ID antes de comenzar el curso de RBS.',
      rbsServerIdFee: 'Nota: el ABC cobra una tarifa de $3 para obtener un Server ID.',
      rbsServerId: 'RBS Server ID',
      learnerInfo: 'Información del estudiante',
      serverId: 'Server ID Aquí',
      enter: 'Ingresa',
      rbsDialogStep1: 'Haz click aquí para',
      rbsDialogStep3: 'Verifica que tu información es correcta',

      dob: 'Fecha de Nacimiento',
      shortDob: 'F.N.',
      lastName: 'Apellido',
      seatsLeft: 'Seats Left',
      seatLeft: 'Seat Left',
      noSeatsLeft: 'Class full',
      noClassFound: 'No class found.',
      instantResults: 'Resultados inmediatos',
      instantResultsNote: 'Las clases marcadas con una estrella se ofrecerán con resultados inmediatos. Los usuarios necesitarán una computadora portátil y una cuenta de ServSafe creada con anticipación. Los detalles se enviarán por correo electrónico.',
      instantResultsLegend: 'Resultados inmediatos - Por favor traiga su propia computadora portátil',

      private: 'Private Class',
      employeeId: 'ID de Empleado',

      manage: 'Administrar',
      managePackages: 'Administrar paquetes',
      packageName: 'Nombre del paquete',
      availableQuantity: 'Cantidad disponible',
      deleteAvailablePackages: 'Eliminar paquetes disponibles',
      areYouSureYouWantToDelete: '¿Está seguro de que desea eliminar',
      thisActionCannotBeUndone: 'Esta acción no se puede deshacer.',
      totalAvailablePackages: 'Total de paquetes disponibles de este tipo',
      toConfirmPleaseTypeTheNumberOfAvailable: 'Para confirmar, escriba la cantidad de paquetes disponibles',
      toDelete: 'para eliminar',
      seatRemovedSuccess: '¡Las plazas disponibles se han eliminado correctamente!',
    },
    examResults: {
      save: 'Guardar',
      delete: 'Eliminar',
      quizName: 'Nombre Examen',
      language: 'Idioma',
      correctAnswers: 'Respuestas Correctas',
      totalQuestions: 'Preguntas en Total',
      examScore: 'Puntuación Examen',
      dateStarted: 'Fecha de Inicio',
      dateUpdated: 'Fecha de Actualización',
    },
    addressDialog: {
      requestForLaminatedCard: 'A laminated card has already been bought by your group admin. Enter the mailing address for card delivery.',
    },
    lookup: {
      courses: 'Cursos',
      licenseStatus: 'Estatus de Licencias',
      attendanceStatus: 'Estatus de Asistencia',
      filterBy: 'Filtrar por',
      selected: 'Seleccionado',
      package: 'Paquetes',
      trainingStatuses: 'Estatus del Curso',
      expirationStatuses: 'Estados de Vencimiento',
      visibility: 'Visibilidad',
      packageType: 'Tipo de Paquete',
    },
    printedCopyPaymentDialog: {
      description: 'Order a Hard Copy of Your Certificate for',
    },
    newOrders: {
      selectPackage: 'Seleccionar Paquete',
      orderFreeOfCharge: 'This is order is free of charge. Are you sure to pay for this order?',
      productsIncluded: 'Productos Incluidos',
      quantity: 'Cantidad',
      discount: 'Descuento',
      price: 'Precio',
      newOrder: 'Nuevo Pedido',
      addAdditionalPackages: 'Agregar Paquetes Adicionales',
      guide: 'Selecciona un paquete para ver los productos que incluye.',
      removeDiscount: 'Eliminar Descuento',
      applyDiscount: 'Aplicar Descuento',
      orderTotal: 'Total',
      discountErrorMessage: 'El valor del descuento debe ser menor que el precio del paquete.',
      cannotDelete: 'No puedes eliminar este paquete. Cada pedido debe incluir al menos un paquete.',
      addOrChangeCreditCard: 'Agregar/Hacer Cargo a Tarjeta de Crédito',
      addPayment: 'Agregar Pago',
      payNow: 'Pagar Ahora',
      errorNotification: 'Por favor verifica los errores en cada campo',
      successNotification: 'Un nuevo pedido ha sido creado exitosamente',
    },
    orders: {
      freeFoodHandlerCardNote: 'Gratis con el paquete Premium de Gerente de Alimentos. Transferible a un empleado.',
      paymentType: 'Tipo de Pago',
      balanceDue: 'Saldo Pendiente',
      purchaseOrderGuide: 'Haz click aquí para elegir un paquete y agregarlo a una nueva orden',
      name: 'Nombre',
      productPackages: 'Producto/Paquetes',
      exportOrders: 'Exportar Pedidos',
      exportSelectedOrders: 'Exportar Pedidos Seleccionados',
      exportAllOrders: 'Exportar Todos los Pedidos',
      exportOrdersInSelectedPage: 'Exportar Pedidos en página seleccionada',
      creditCardInfo: 'Informacion Tarjeta de Credito',
      zip: 'Código Postal',
      address: 'Dirección',
      packageId: 'ID de Paquete',
      packageName: 'Nombre del Paquete',
      price: 'Precio',
      markAsPaid: 'Marcar Pagado',
      markAsUnpaid: 'Mark as Unpaid',
      quantity: 'Cantidad',
      status: 'Estatus',
      paymentDate: 'Fecha de Pago',
      appliedCode: 'Code',
      discountAmount: 'Discount Amount',
      perUnit: 'per unit',
      totalDiscount: 'Total Discount',
      totalAmount: 'Monto total',
      expirationDate: 'Fecha de Expiración',
      deleteOrder: 'Eliminar pedido',
      deleteConfirmationText: 'Estás seguro que quieres eliminar este pedido?',
      deleteConfirmedText: 'Sí, eliminar',
      deleteSuccessfullyText: 'Pedido eliminado exitosamente',
      delete: 'Eliminar',
      edit: 'Modificar',
      viewReceiptInvoice: 'Ver Recibo/Factura',
      viewInvoice: 'Ver Recibo',
      cancel: 'Cancelar',
      saveChanges: 'Guardar Cambios',
      order: 'Pedido',
      confirmation: 'Confirmación',
      studentName: 'Nombre del Alumno',
      classDate: 'Fecha de Clase',
      city: 'Ciudad',
      createdDate: 'Fecha de Creación',
      createdBy: 'Creado por',
      orderTotal: 'Total',
      balance: 'Adeudo',
      noOrderText: 'En este momento no cuentas con ningún pedido.',
      notAllowEditAndDelete: 'Paquetes en este pedido han sido asignados antes de recibir el pago. No es posible eliminar o modificar este pedido.',
      buyProducts: 'Comprar Productos',
      check: 'Cheque',
      checkNumber: 'Número de cheque',
      orderNotPaidYet: 'No se ha recibido pago por este pedido. La asignación de paquetes ha sido autorizada.',
      dateOfRefund: 'Fecha de Reembolso',
      totalRefunded: 'Total Reembolsado',
      refundIssued: 'Reembolso Procesado',
      refund: 'Reembolso',
      checkedTotal: '{checkedTotal} Items',
      selectedForRefund: 'Selected for Refund',
      enterRefundAmount: 'Enter Refund Amount',
      enterAmount: 'Enter Amount',
      issueRefund: 'Issue Refund',
      packageColumnName: 'Package',
      assignedToColumnName: 'Assigned to',
      refundSuccess: 'Success!',
      refundSuccessDescription: 'You have successfully refunded the following items',
      products: 'Products',
      unassigned: 'Unassigned',
      remove: 'Remove',
      apply: 'Apply',
      discountCode: 'Discount Code',
      discountTotal: 'Discount Total',
      cannotViewInvoice: 'An invoice/receipt can’t be generated for this order. Please contact us at 800-676-3121 to request a copy of the document, or send an email info&#64;premierfoodsafety.com',
      deleteOrderConfirmation: 'Are you sure to delete this order?',
      instruction: 'Seleccione un curso para ver los detalles.',
      selectedForPay: '{count} pedidos seleccionados',
      paySelected: 'Pagar seleccionados',
      clear: 'Borrar',
      payPalTransactionId: 'ID de Transacción de PayPal',
      payPalCancelConfirmMessage: 'Si cierras la ventana de pago de PayPal, serás redirigido al sistema y podrás completar el pago más tarde.',
      payPalSuccessButPaymentCouldNotBeCompleted: 'El pago con PayPal fue exitoso, pero hubo un pequeño problema con el proceso de pago. Si el pedido no aparece como pagado o nota algo inusual, comuníquese con soporte al 800-676-3121.',
      applePaySuccessButPaymentCouldNotBeCompleted: 'El pago con Apple Pay fue exitoso, pero hubo un pequeño problema con el proceso de pago. Si el pedido no aparece como pagado o nota algo inusual, comuníquese con soporte al 800-676-3121.',
      enterCheckNumber: 'Ingrese el Número de Cheque',
      refundMethod: 'Método de reembolso',
      refundByCard: 'Reembolso por tarjeta',
      refundByCheck: 'Reembolso por cheque',
      refundByPayPal: 'Reembolso por PayPal',
      generateInvoice: 'Generar Factura',
    },
    purchasePackages: {
      purchasePackages: 'Comprar Paquetes',
      total: 'Total',
      promoCode: 'Código de Promoción',
      enterPromoCode: 'Ingresar Código de Promoción',
      applyCode: 'Aplicar Código',
      discountAppliedTo: 'Descuento Aplicado a',
      code: 'Código',
      addAdditionalPackage: 'Agregar Paquetes Adicionales',
      checkout: 'Completar Pago',
      cannotApplyMultipleCodeMessage: 'No es posible aplicar más de un código promocional a un mismo paquete.',
      codeIsAppliedMessage: 'Código {code} ya ha sido aplicado.',
      removeDiscountCode: 'Eliminar código de promoción',
      allergenCta: 'Agregar Capacitación sobre Concientización de Alérgenos Alimentarios',
    },
    unassignedCodes: {
      selectCodes: 'Seleccionar Códigos',
      title: 'Unassigned Codes 4',
      assignCodeButton: 'Asignar Código(s)',
      buyCodeButton: 'Comprar Código(s)',
    },
    unassignedCourses: {
      title: 'Cursos sin Asignar',
      buyLicense: 'Comprar Licencia(s)',
      assignCourses: 'Asignar Curso(s)',
      assignCourse: 'Asignar Curso',
    },
    unassignedLearnersTable: {
      deleteButton: 'Eliminar',
      addNewLearner: 'Agregar Nuevo Usuario',
      markAsActive: 'Desactivar Usuario',
      markAsInactive: 'Reactivar Usuario',
      markAsActiveInactive: 'Mark Learner as Active/Inactive',
      changeStatusGuidance: 'Select learners with the same status to update their status.',

      confirmMarkingInactive: 'Are you sure you want to mark learner(s) as inactive?',
      contentMarkingInactive: 'This will cancel the learner(s) account and also permanently remove all assigned training courses. <br/> To avoid losing any unused training packages, please transfer them to a new learner before proceeding.',
    },
    unassignedSeats: {
      title: 'Asientos No Asignados',
      buySeats: 'Comprar Asiento(s)',
      assignSeats: 'Asignar Asiento(s)',
    },
    unassignedSections: {
      selectLearners: 'Seleccionar Usuarios',
      addNewLearner: 'Agregar Nuevo Usuario',
    },
    addNewLearnerDialog: {
      addNewLearner: 'Agregar Nuevo Usuario',
      firstName: 'Nombre',
      lastName: 'Apellido',
      dob: 'Fecha de Nacimiento',
      emailAddress: 'Correo Electrónico',
      jobTitle: 'Puesto',
    },
    learnersTable: {
      bulkImport: 'Importar Lista de Usuarios',
      importLearnersInstructionDownloadTemplate: 'Para asignar paquetes a un grupo de múltiples usuarios, utiliza la plantilla en formato CSV.',
      importLearnersInstructionUpload: 'Agrega la información de tus usuarios a la plantilla. Una vez terminado, deberás importar el archivo aquí.',
      uploadLearnerList: 'Importar Lista de Usuarios ',
      downloadSample: 'Descargar Plantilla',
    },
    ancillary: {
      needHelp: 'Necesitas Ayuda',
      contactUs: 'Contáctanos',
      text1: 'Estamos disponibles para responder preguntas específicamente relacionadas con las clases, exámenes, cursos en línea y materiales de estudio',
      text2: 'Para preguntas relacionadas con tu negocio, por favor ponte en contacto con tu departamento de salud local',
      callHelpDesk: 'Llamar a Servicio a Clientes',
    },
    appFooter: {
      copyright: `©Copyright 2000-${currentYear} Premier Food Safety. All rights reserved.`,
    },
    coursePlayer: {
      select: 'Seleccionar',
      courseProgress: 'Progreso del Curso',
      frameNotSupported: 'Tu navegador no es compatible con el curso.',
      certificateDialogTitle: 'Notificación',
      certificateDialogMessage: 'Felicidades, su certificado le ha sido enviado por correo electrónico.',
      certificateDialogButtonText: 'OK',
      goToExam: 'Ir al examen final',
      backToCourse: 'Volver al curso',
    },
    courseProgress: {
      purchased: 'Comprado',
      buyLaminatedCard: 'Comprar Tarjeta Laminada',
      expires: 'Vence',
      transfer: 'Transferir',
      download: 'Descargar',
      start: 'Empezar',
      continue: 'Continuar',
      review: 'Repasar Curso',
    },
    courses: {
      myCourses: 'Mis Cursos',
      doNotHaveCoursesAndAssign: 'You currently do not have any courses assigned to you. Click above to assign.',
      doNotHaveCourses: 'Aún no tienes ningún curso asignado. Haz click para asignar.',
      noCompletedCourses: 'Aún no tienes ningún curso completado.',
      instruction: 'Seleccione un curso para ver los detalles.',
    },
    documentGenerationDialog: {
      header: 'Los documentos aparecen aquí',
      note1: 'Por favor vuelve a generar el documento antes de enviarlo',
      note2: 'Este espacio aparece en blanco cuando la pantalla se muestra por primera vez',
      generateDocument: 'Generar Documento',
    },
    headerActions: {
      myPortal: 'Mi Portal',
      publicSite: 'Compras PFS',
      faq: 'Preguntas Frecuentes',
      contactUs: 'Contáctanos',
      myAccount: 'Mi Cuenta',
      logout: 'Cerrar Sesión',
      learners: 'Learners',
      purchase: 'Compra',
      purchaseCourse: 'Compra curso',
      purchaseMore: 'Compra mas',
      purchaseComplete: 'Compra completada',
      orders: 'Orders',
    },
    fmSurvey: {
      title: 'Obtenga una tarjeta de regalo electrónica de Amazon de $20',
      description: 'Complete nuestra encuesta de Gerente de Alimentos y le enviaremos por correo electrónico una tarjeta de regalo electrónica de Amazon de $20 dentro de 1 semana después de completarla.',
      duration: 'Toma aproximadamente 15 minutos',
      eligibilityLead: 'Elegibilidad: solo para quienes tengan',
      eligibilityYears: 'más de 3 años',
      eligibilityTail: 'de experiencia trabajando como Gerente de Alimentos',
      limit: 'Límite de una encuesta por estudiante.',
      takeSurvey: 'Realizar la encuesta',
      giftIconAlt: 'Ícono de regalo',
      clockIconAlt: 'Ícono de reloj',
    },
    dashboardAnnouncement: {
      dismiss: 'Cerrar anuncio',
    },
    logo: {
      title: 'Premier Food Safety',
    },
    profile: {
      registered: 'Registrado',
      by: 'Por',
      userId: 'ID de Usuario',
      editProfile: 'Modificar perfil',
    },
    stats: {
      assignSeats: 'Asignar Asientos',
      assigned: 'Asignado',
      classRegistrations: 'Gerente de Alimentos Presencial',
      proctorURegistrations: 'Gerente de Alimentos en Línea',
      elearningLicense: 'Cursos en Línea',
      assignLicense: 'Asignar Licencia',
      assignCode: 'Asignar Código',
      unassigned: 'Sin Asignar',
      purchased: 'Comprados',
      yourPurchases: 'Tus Paquetes',
      noPurchases: 'Aún no tiene asientos. Los asientos aparecerán aquí cuando se pague un pedido.',
    },
    userInfo: {
      welcome: 'Bienvenido(a)',
    },
    faqs: {
      common: {
        title: 'FAQs',
        1: 'La pantalla está congelada y no puedo comenzar el curso.',
        2: 'Cierra sesión y vuelve a iniciar sesión',
        3: 'Reinicia tu computadora',
        4: 'Este curso no es compatible con el navegador Safari. Por favor asegúrate acceder al curso usando',
        5: 'Se recomiendan para la mejor experiencia de aprendizaje',
        6: 'Borra el caché. Esto es importante si estás usando una computadora compartida, en donde alguien más haya completado el mismo curso previamente',
        7: 'Usa una computadora diferente',
        8: 'No puedo avanzar en el curso.',
        9: 'Haz click en los botones \'Siguiente\' o \'Reproducir\' para continuar',
        10: 'Asegúrate de que estás usando',
        11: 'o',
        12: 'como tu navegador.',
        13: 'Terminé el curso pero no puedo imprimir mi certificado.',
        14: `Para imprimir el certificado debes obtener la puntuación mínima aprobatoria que se indica en el examen final.
        Si no has obtenido esta puntuación, no podrás imprimir tu certificado.
        Puedes ver tu calificación haciendo click en la pestaña Cursos en Línea
        y después click en el curso indicado.`,
        15: 'Imprimí el certificado pero viene con el nombre de otra persona.',
        16: `Asegúrate de que estás iniciando sesión con tus propias credenciales haciendo click en Mi Portal
        y verificando que tu nombre aparezca en la esquina superior izquierda`,
        17: 'Si te registraste con un nombre diferente, no podremos hacer ningún cambio después de que el certificado haya sido expedido',
        18: 'El curso está congelado o tarda demasiado tiempo en cargar.',
      },
      general: {
        title: 'Preguntas Frecuentes Generales',
        createAccount: 'Cómo crear una cuenta',
        login: 'Cómo iniciar sesión en una cuenta existente',
        assignOnlineCourses: 'Cómo asignar cursos en línea a ti mismo',
        selfRegister: 'Cómo registrarte a ti mismo en una clase presencial',
        updateUserInfo: 'Cómo actualizar tu información de usuario',
        accessOnlineGuide: 'Cómo acceder a la guía de estudio en línea',
        resetPassword: 'Cómo restablecer tu contraseña',
      },
      individualTutorial: {
        title: 'Tutoriales para Usuarios Individuales',
        studentPortalFeature: 'Guía completa de las funciones del portal de estudiantes',
        startOnlineCourse: ' Cómo iniciar tu curso de capacitación en línea',
        accessClassInformation: 'Cómo acceder a la información de clases presenciales',
        findExamCode: 'Cómo localizar tu código de examen de ProctorU',
      },
      groupAdminTutorial: {
        title: 'Tutoriales para Administradores de Grupo',
        completeGuide: 'Guía completa de las características del portal de administradores de grupo',
        addNewLearner: 'Cómo agregar un nuevo alumno',
        addGroupLearners: 'Cómo agregar una lista con múltiples alumnos',
        removeLearner: 'Cómo eliminar un alumno de la cuenta',
        markLearnerInactive: 'Cómo marcar alumnos como inactivos',
        assignPackage: 'Cómo asignar paquetes de capacitación presenciales y en línea a ti mismo y a otros',
        emailLearnersGroup: 'Cómo enviar un correo electrónico a un grupo de alumnos inscritos en un curso en línea',
        resendExam: 'Cómo reenviar códigos de examen de ProctorU e instrucciones a un alumno',
        accessDownLoadCards: 'Cómo acceder y descargar tarjetas y/o certificados para alumnos que toman un curso en línea',
        transferUnusedCourse: 'Cómo transferir un curso en línea no usado a un nuevo alumno',
        generateLeanerReports: 'Cómo generar reportes de alumnos',
        updateLearnerEmail: ' Cómo actualizar la dirección de correo electrónico de un alumno',
        resendPassword: 'Cómo reenviar la contraseña a un alumno',
        updatePassword: 'Cómo actualizar tu contraseña de administrador',
        addSavePayment: ' Cómo agregar y guardar métodos de pago en tu cuenta',
        shopMainSite: 'Cómo comprar en la página principal de PFS',
        purchaseTrainingPackage: 'Cómo comprar paquetes de capacitación desde el panel de administrador de grupo',
      },
    },
    myAccount: {
      title: 'Mi Cuenta',
      resetPassword: 'Restablecer contraseña',
      deactivate: 'Desactivar cuenta',
      activate: 'Activar cuenta',
      saveChanges: 'Guardar Cambios',
      changeUsername: 'Cambiar nombre de usuario',
      resetPasswordSuccessfully: 'Contraseña restablecida exitosamente.',
      changeUsernameSuccessfully: 'Nombre de usuario actualizado con exito.',
      deactivateAccountConfirmation: '¿Estás seguro de que deseas desactivar tu cuenta?',
      reminderSettings: 'Configuración de Recordatorios',
      certificateRenewalReminder: 'Recordatorio de renovación de certificado',
      certificateRenewalReminderNote: 'Reciba un recordatorio por correo electrónico a medida que se acerque la fecha de vencimiento de su certificado.',
      inPersonClassReminder: 'Recordatorio de clase Presencial de Administrador de Alimentos',
      inPersonClassReminderNote: 'Reciba un recordatorio por correo electrónico sobre las próximas clases Presenciales de certificación de Administrador de Alimentos.',
      smsCertificateRenewalReminder: 'Recordatorio de renovación de certificado por SMS',
      smsCertificateRenewalReminderNote: 'Reciba un recordatorio por mensaje de texto a medida que se acerque la fecha de vencimiento de su certificado.',
      saveReminderSettings: 'Guardar configuración de recordatorios',
    },
    contactUs: {
      name: 'Nombre',
      emailAddress: 'Dirección de Correo Electrónico',
      phoneNumber: 'Teléfono',
      subject: 'Asunto',
      comment: 'Comentarios',
      submit: 'Enviar',
      submitting: 'Enviando...',
    },
    eLearning: {
      emailLearners: 'Enviar Correo a Usuarios',
      hideStudent: 'Ocultar Usuario',
      unhideStudent: 'Mostrar Usuario',
      noAssignedCourses: 'En este momento no cuentas con ningún registro.',
      buyLicenses: 'Comprar Licencias',
      restartTraining: 'Reiniciar Curso',
      newELearningLicenses: 'Nuevas Licencias de Cursos',
      orderLaminatedCard: 'Comprar Tarjeta Laminada',
      congratulateOnExam: 'Felicidades por haber aprobado tu examen',
      style: 'Estilo',
      buyACreditCard: 'Compra tu Tarjeta Laminada',
      preBoughtCreditCard: 'Pre-pagaste una tarjeta laminada',
      laminatedCardDescription1: 'Tarjeta de Crédito por',
      laminatedCardDescription2: 'La recibiras en 7-10 días hábiles.',
      buyNow: 'Comprar Ahora',
      continue: 'Continuar',
      purchaseSuccess: 'Gracias por tu compra.',
      purchaseLaminatedCardSuccessInfo: 'Tu orden está siendo procesada. Recibirás tu tarjeta por correo en un plazo de 7-10 días hábiles.',
      mailingNote: 'Ingresa la',
      mailingAddress: 'Dirección de correo',
      mailingNote2: 'a donde quieres que se envíe tu tarjeta.',
      laminatedCardNameNote: 'El siguiente nombre aparecerá en tu tarjeta. Si el nombre es incorrecto, por favor contáctanos al 800-676-3121',
    },
    noteDrawer: {
      notes: 'Notas',
      addNote: 'Agregar Nota',
      system: 'PFS System',
    },
    dashboard: {
      adminViewTitle: 'PFS Admin View',
      adminViewSubtitle: 'Home - User information',
      editUserInfo: 'edit-user-info-element',
      noGroupAdminWarning: 'Please select 1 Group Admin.',
      invalidUser: 'User ID is invalid. Please check it again.',
      unpaidOrders: {
        title: 'Pedidos Pendientes de Pago',
        description: 'Estos pedidos están pendientes de pago. Los asientos estarán disponibles una vez recibido el pago.',
        orderNumber: 'Pedido #',
        createdDate: 'Fecha de Creación',
        total: 'Total',
        balance: 'Saldo Pendiente',
        quickActions: 'Acciones Rápidas',
        viewAllOrders: 'Ver todos los pedidos',
        latestNote: 'Mostrando los {count} pedidos pendientes de pago más recientes.',
      },
    },
    classRegistrations: {
      instructor: 'Instructor',
      onlyAllow1Class: 'Please choose only 1 class',
      notAllowOrderPrintedCopy: 'A printed copy is only available once students have taken and passed the ServSafe exam. This registration does not yet meet that criteria.',
      classMaterialsAndDocs: 'Materiales de Estudio y Documentos',
      forUser: 'for user',
      selectClassForRetest: 'Select Class for Retest',
      selectClassForReschedule: 'Select Class for Reschedule',
      notAllowReschedule: 'This registration seems too late to be RESCHEDULED. Only allowing the following status to be rescheduled: Approved, No-Show.',
      notAllowRetest: 'Only following registration statuses accepted for retest: Attended, Completed-Fail.',
      notAllowDownloadCertificate: 'Only the following registration statuses accepted for downloading certificate: Completed-Pass.',
      certificateInProgress: 'Certificate is still in progress, please wait a little while.',
      studentPortal: 'Portal de Alumno',
      yes: 'Y',
      no: 'N',
      generalSettings: 'General Settings',
      actions: 'Actions',
      documents: 'Documents',
      reschedule: 'Reschedule',
      transfer: 'Transfer',
      retest: 'Retest',
      cancel: 'Cancel',
      emailCertificate: 'Descargar Certificado',
      setFlag: 'Set Flag',
      unsetFlag: 'Unset Flag',
      discount: 'Discount',
      classCancelled: 'Class Cancelled',
      package: 'Package',
      // Columns name here.
      confirmation: 'Conf',
      order: 'Orden',
      regBy: 'Reg. por',
      coName: 'Nombre Negocio',
      regDate: 'Fecha de Registro',
      classDate: 'Fecha de Clase',
      classLocation: 'Ubicación de Clase',
      compStatus: 'Estatus de Finalización',
      paid: 'Pagado',
      attendStatus: 'Estatus de Asistencia',
      balance: 'Adeudo',
    },
    restartTraining: {
      confirmationText: 'Are you sure you want to restart training?',
      title: 'Restart Training',
    },
    registration: {
      descriptionForOrderFromApex: 'This registration is from APEX, please click confirm button to process to APEX site.',
    },
    paymentInformation: {
      text: 'Payment Information',
      useNewCreditCard: 'Usar una nueva tarjeta',
      removeSelectedCard: 'Remove Selected Card',
      pleaseChooseCard: 'Please select a card.',
      proceedToPayPal: 'Proceed to PayPal',
      proceedToPayPalNote: '* You will complete your payment in PayPal (a new window or a redirect may open depending on your browser).',
    },
    paymentOptions: {
      payByCreditCard: 'Pagar con Tarjeta',
      payByCheck: 'Pagar con Cheque',
      payByApplePay: 'Pagar con Apple Pay',
      payByPayPal: 'Pagar con PayPal',
    },
    paymentInformationForm: {
      addAndChargeCreditCard: 'Agregar y Hacer Cargo a Tarjeta',
      addCreditCard: 'Agregar Tarjeta de Crédito',
      type: 'Tipo',
      typePlaceholder: 'Tarjeta de Crédito',
      nameOnCard: 'Nombre en la Tarjeta',
      enterPlaceholder: 'Ingresar información',
      creditCardNumber: 'Número de Tarjeta de Crédito',
      expiration: 'Fecha de Vencimiento',
      monthPlaceholder: 'Mes',
      yearPlaceholder: 'Año',
      billingAddress: 'Dirección de Facturación',
      billingZip: 'Código Postal',
      CC2Sev: 'Código de Seguridad',
      saveForFutureUse: 'Guardar para uso futuro',
    },
    creditCard: {
      readableVisa: 'Tarjeta Visa',
      readableMasterCard: 'Tarjeta Master Card',
      readableAmEx: 'Tarjeta American Express',
      readableDiscover: 'Discover Card',
      endingIn: 'terminación en',
      unknown: 'Unknown',
    },
    paymentStatus: {
      paid: 'Pagado',
      unpaid: 'Pago Pendiente',
    },
    userTypeReadable: {
      client: 'Client',
      instructor: 'Instructor',
      staff: 'Staff',
      manager: 'Manager',
      admin: 'Admin',
      elearningManager: 'Administrador de Cursos',
      elearningStudent: 'Alumno',
      student: 'Alumno',
    },
    readableMyAccountTabs: {
      myPortal: 'Mi Portal',
      accountSettings: 'Configuración de Cuenta',
      userInformation: 'Información de Usuario',
      paymentInformation: 'Información de Pago',
    },
    notificationMessage: {
      default: 'Algo salió mal!',
      commonSuccess: 'Acción completada con exito',
    },
    ordersService: {
      addOrChangeCreditCard: 'Agregar/Hacer Cargo a Tarjeta de Crédito',
      addPayment: 'Agregar Pago',
      payNow: 'Pagar Ahora',
    },
    cancelRegistrationDialog: {
      title: 'Cancel Registration',
      formTitle: '**** {days} days past class date ****',
      transactions: 'Transactions:',
      transactionsDescription: 'No payments found for this registration.',
      totalPaid: 'Total Paid:',
      proceedWithCancelation: 'Proceed with cancelation',
      refundRequested: 'Refund Requested',
      reason: 'Reason',
      type: 'Type',
      name: 'Name',
      amount: 'Amount',
      approve: 'Approve',
    },
    returnLicenseDialog: {
      return: 'Devolver',
      title: 'Devolver Licencia',
      content: '¿Devolver la licencia de {course} asignada a {learner} a las licencias disponibles? Esto cancela la asignación y la licencia podrá asignarse a cualquier persona del grupo.',
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
    },
    transferCourseDialog: {
      title: 'Transferir Curso',
      assign: 'Asignar',
      transfer: 'Transfer',
    },
    transferClassRegistrationDialog: {
      title: 'Transferir Clase',
      assign: 'Asignar',
      note: 'Nota',
    },
    generalSetting: {
      updateGeneralSettings: 'Update General Settings',
    },
    packageBenefits: {
      freeFoodHandlerCard: 'Tarjeta de Manipulador de Alimentos Gratis',
      freeFoodHandlerCardTooltip: 'Transferible a un empleado',
      limitedTimeOffer: 'Oferta por Tiempo Limitado',
    },
    checkout: {
      orderSummary: 'Información de Pedido',
      apply: 'Aplicar',
      total: 'Total',
      continueToCheckout: 'Continuar al Pago',
      removePackage: 'Eliminar Paquete',
      removePackageDialogContent: 'Estás seguro de que quieres eliminar este paquete y todos los descuentos asociados con el?',
      foodHandlerCardIncludedTitle: 'Tarjeta de Manipulador de Alimentos Incluida',
      foodHandlerCardIncludedContent: 'Una Tarjeta de Manipulador de Alimentos ya está incluida en su paquete. ¿Aún desea comprar el complemento?',
      freeFoodHandlerCardNote: 'Gratis con su paquete Premium. Transferible a un empleado.',
      confirm: 'Sí',
      cancel: 'No',
      removeDiscount: 'Eliminar Descuento',
      removeDiscountDialogContent: 'Estás seguro que quieres eliminar este descuento?',
      licenses: 'Licencias',
      includes: 'Incluye',
      discountAppliedTo: 'Descuento aplicado a',
      code: 'Código',
      purchase: 'Compra',
      selectPackageForInformation: 'Por favor selecciona un paquete para ver más información',
      buyPackages: 'Comprar Paquetes',
      startShopping: 'Iniciar una Compra',
      currentCartEmpty: 'Tu carrito de compras está vacío',
    },
    createPaymentInformation: {
      unsupportedCardType: 'Solo aceptamos Visa, Amex y MasterCard.',
    },
    userStatus: {
      active: 'Activo',
      inactive: 'Inactivo',
      activeInactive: 'Activo/Inactivo',
      all: 'Todos',
    },
    search: 'Buscar',
    searchExtendedCourses: 'Buscar por ID de usuario, ID de pedido o # de confirmación',
    documentGenerationForm: {
      type: 'Tipo de Documento',
      to: 'Para',
      from: 'De',
      cc: 'CC',
      additionalDocumentToAttach: 'Documentos Adicionales a Incluir',
      addRegistrationNote: 'Add Registration Note (Optional)',
    },
    licenseStatus: {
      approved: 'Confirmada',
      attended: 'Asistió',
      noShow: 'No Asistió',
      completedPass: 'Completado-Aprobó',
      completedFail: 'Completado-No Aprobó',
      cancelled: 'Cancelada',
      retestScheduled: 'Reexamen programado',
      chargeback: 'Contracargo',

      // Additional license status for online course.
      new: 'Nueva',
      allocated: 'Asignada',
    },
    table: {
      viewing: 'Ver',
      total: 'Total',
      noDataText: 'No hay registros disponibles',
      viewInfo: 'Ver información',
    },
    time: {
      hours: 'horas',
      minutes: 'minutos',
      hour: 'hora',
      minute: 'minuto',
    },
    packageType: {
      elearning: 'Cursos en Línea',
      inPerson: 'Gerente de Alimentos Presencial',
      proctoru: 'Gerente de Alimentos en Línea',
    },
    languages: {
      english: 'Inglés',
      spanish: 'Español',
      chinese: 'Chino',
      korean: 'Coreano',
    },
    transferPackage: {
      information: 'This list only shows eligible learners. Learners who have been assigned a package in this same category, or learners assigned an equivalent package in another category will not appear on this list.',
    },
    distances: {
      anyDistance: 'Any distance',
      miles: 'millas',
    },
    emailLearnersDialog: {
      emailLearner: 'Email Learners',
      subject: 'Subject',
      body: 'Body',
      from: 'From',
    },
    requireContactInfoDialog: {
      description: 'A mailing address and phone number are required to process the printed certificate. Please update your information in the My Account tab.',
      goToMyAccountTab: 'Go to My Account tab',
      useBillingAddress: 'Use the same as billing address',
    },
    registrationSuccessModal: {
      title: '¡Bienvenido! Su cuenta está lista',
      subTitle: '¡Registro completado!',
      info1: 'Su nombre de usuario y contraseña han sido enviados por correo electrónico',
      info2: 'Por favor, guarde su información de inicio de sesión:',
    },
    copied: '¡Copiado !',
    loading: 'Cargando...',
    folderManager: {
      title: 'Gestor de Carga SCORM',
      uploadingLabel: 'Cargando Paquete SCORM:',
      uploadingDesc: 'Este proceso puede tardar unos minutos dependiendo del tamaño del archivo. Por favor, no cierre esta ventana.',
      infoAlert: 'Cargue paquetes SCORM a S3. Las carpetas existentes serán reemplazadas.',
      labels: {
        language: 'Idioma',
        s3Folder: 'Carpeta S3',
        scormPackage: 'Paquete SCORM',
        targetFolder: 'Carpeta de Destino',
        warning: 'Advertencia:',
        uploadSuccess: 'Carga Exitosa',
        uploadError: 'Error de Carga',
      },
      messages: {
        confirmUploadFor: '¿Desea cargar el paquete SCORM para',
        folderReplacedWarning: 'Esta acción reemplazará permanentemente todos los archivos existentes en la carpeta S3 de destino. Esto no se puede deshacer.',
        uploadSuccess: 'Carpeta cargada con éxito en S3.',
        uploadFailed: 'La carga falló.',
        connectionError: 'Por favor, compruebe su conexión e inténtelo de nuevo.',
      },
      buttons: {
        upload: 'Cargar a S3',
        confirmUpload: 'Confirmar Carga',
        cancel: 'Cancelar',
        close: 'Cerrar',
      },
    },
    externalLmsClientKeys: {
      title: 'Claves de Cliente LMS Externas',
      createButton: 'Crear Nueva Clave de Cliente',
      editHeader: 'Editar Nueva Clave de Cliente',
      clientName: 'Nombre del Cliente',
      clientKey: 'Clave del Cliente',
      active: 'Activo',
      action: 'Acción',
      createdDate: 'Fecha de Creación',
      courseIds: 'IDs de Cursos',
      leaveEmptyForAll: 'Dejar en blanco para todos',
      allCourses: '(Todos los Cursos)',
      domains: 'Dominios',
      clientKeyHint: 'Mínimo 10 caracteres, ej. PANDA_12345',
      messages: {
        fetchFailed: 'Error al obtener las claves de cliente.',
        updateSuccess: 'Clave de cliente LMS externa actualizada con éxito.',
        updateFailed: 'Error al actualizar la clave de cliente.',
        createSuccess: 'Clave de cliente LMS externa creada con éxito.',
        createFailed: 'Error al crear la clave de cliente.',
        nameRequired: 'El nombre del cliente es obligatorio.',
        keyRequired: 'La clave del cliente es obligatoria.',
        keyMinLength: 'La clave del cliente debe tener al menos 10 caracteres.',
        domainsRequired: 'Se requiere al menos un dominio.',
        invalidDomain: 'Formato de dominio inválido (ej. ejemplo.com).',
        clientKeyAlreadyExists: 'Esta clave de cliente ya existe.',
      },
    },
    dashboardAnnouncementAdmin: {
      title: 'Título',
      message: 'Mensaje',
      plainTextHint: 'Solo texto sin formato. Se conservan los saltos de línea.',
      startTime: 'Hora de inicio',
      endTime: 'Hora de finalización',
      enabled: 'Habilitado',
      dateTimePlaceholder: 'mm/dd/aaaa hh:mm AM',
      createdBy: 'Creado por {name} el {date}',
      updatedBy: 'Última actualización por {name} el {date}',
      unknownUser: 'Usuario #{id}',
      messages: {
        required: 'Este campo es obligatorio.',
        invalidDateTime: 'Introduzca la fecha y la hora como mm/dd/aaaa hh:mm AM/PM.',
        endAfterStart: 'La hora de finalización debe ser posterior a la hora de inicio.',
        saveSuccess: 'Anuncio guardado.',
        saveFailed: 'No se pudo guardar el anuncio.',
        fetchFailed: 'No se pudo cargar el anuncio.',
      },
    },
    externalLmsRegistrations: {
      title: 'Registros de LMS Externo',
      confirmation: 'Conf #',
      occurrence: 'Ocurrencia',
      externalLearnerId: 'ID de Alumno Externo',
      trainingStatus: 'Estado de Capacitación',
      searchPlaceholder: 'Buscar por Clave de Cliente, ID de Usuario, Confirmación #',
      status: {
        notStarted: 'No Empezado',
        inProgress: 'En Progreso',
        completedPassed: 'Completado Aprobado',
        completedFailed: 'Completado Reprobado',
      },
      completedDate: 'Fecha de Finalización',
      startDate: 'Fecha de Inicio',
      endDate: 'Fecha de Fin',
      exportExcel: 'Exportar Excel',
      exportSuccess: 'La exportación está lista.',
      exportFailed: 'Error al exportar los registros.',
      exportStartDateRequired: 'Por favor seleccione una fecha de inicio.',
      exportEndDateBeforeStart: 'La fecha de fin debe ser igual o posterior a la fecha de inicio.',
    },
    handlerTopPane: {
      foodHandlersCard: 'Tarjeta de Manipulador de Alimentos',
      startOnlineTraining: 'Iniciar capacitación en línea',
      groupDiscountsAvailable: 'Descuentos grupales disponibles',
      contactUs: 'Contáctanos',
      features: [
        'Acreditado por ANAB',
        'Aprobado por el Departamento de Salud de California',
        'Descarga e Imprime tu Tarjeta al Instante',
      ],
    },
    ctaForm: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      whichCounty: '¿En qué condado trabajas?',
      selectYourCounty: 'Selecciona tu condado',
      continue: 'Continuar',
      sanDiegoNotice: 'Las tarjetas de manipulador de alimentos de CA no son válidas en el condado de San Diego. Si trabajas en el condado de San Diego,',
      sanBernardinoNotice: 'La tarjeta de manipulador de alimentos de CA no es válida en el condado de San Bernardino. Para más información,',
      riversideNotice: 'La tarjeta de manipulador de alimentos de CA no es válida en el condado de Riverside. Para más información,',
      clickHere: 'haz click aquí',
    },
    customerStats: {
      over45Years: 'Más de 45 años',
      ofExperience: 'de experiencia',
      over3Million: 'Más de 3 millones',
      clientsTrained: 'de clientes capacitados',
      moneyGuarantee: 'Garantía de devolución de dinero',
    },
    customerTestimonials: {
      addToCart: 'Agregar al Carrito',
    },
    faqSection: {
      title: 'Preguntas Frecuentes',
      ca: {
        q1: '¿Qué es la ley de la Tarjeta de Manipulador de Alimentos de California?',
        a1: 'La Ley de la Tarjeta de Manipulador de Alimentos de California (basada en SB303) requiere que todos los manipuladores de alimentos (a menos que estén exentos) obtengan una tarjeta de manipulador de alimentos dentro de los 30 días posteriores a la fecha de contratación y la renueven cada 3 años.',
        q2: '¿Cómo puedo obtener una ',
        q2_link: 'Tarjeta de Manipulador de Alimentos de California?',
        q2_href: '/food-handlers-card/california-espanol',
        a2_start: 'La tarjeta se emite al completar con éxito un programa de seguridad alimentaria acreditado por ANAB, como ',
        a2_link: 'Premier Food Safety',
        a2_end: ', y un examen de 40 preguntas con una puntuación mínima del 70%.',
        q3: '¿Quién es considerado un manipulador de alimentos?',
        a3: 'Un manipulador de alimentos es cualquier individuo que participa en la preparación, almacenamiento o servicio de alimentos en un establecimiento de comida.',
        q4: '¿Existen excepciones a la ley de la Tarjeta de Manipulador de Alimentos de California?',
        a4_title: 'Los manipuladores de alimentos que trabajan en cualquiera de los siguientes establecimientos están exentos de cumplir con esta ley:',
        a4_list: [
          'Establecimientos de comida temporales (food booths),',
          'Farmer\'s markets certificados,',
          'Cocinas fijas (commissaries), supermercados (incluyendo tiendas de conveniencia),',
          'Establecimientos de salud con licencia,',
          'Unidades de soporte móvil,',
          'Cafeterías de escuelas públicas o privadas,',
          'Establecimientos de servicio de comida restringido,',
          'Tiendas de menudeo en donde la mayoría de las ventas provienen de la farmacia,',
          'Lugares para eventos con servicios de snack bar en donde la mayor parte de las ventas provienen de los boletos de entrada,',
          'Ciertos establecimientos de comida que cuentan con un programa de entrenamiento en manejo seguro de alimentos aprobado para uso interno,',
          'Establecimientos de comida sujetos a un contrato colectivo (sindicato),',
          'Cualquier establecimiento de la ciudad, condado, ciudad y condado, estatal o regional utilizado para el confinamiento de adultos o menores de edad, incluyendo pero no limitado a cárceles de condado, correccionales para menores, campamentos, ranchos u otros establecimientos residenciales,',
          'Programas de nutrición para adultos mayores administrados por el Departamento de Envejecimiento de California, y',
          'Manipuladores de alimentos que trabajan en los condados de Riverside, San Bernardino y San Diego y manipuladores de alimentos que cuenten con un Certificado válido de Gerente de Protección de Alimentos.',
        ],
        q5: 'Trabajo como voluntario en un comedor popular, banco de alimentos o un restaurante dirigido por voluntarios. ¿Necesito una Tarjeta de Manipulador de Alimentos?',
        a5: 'No, los voluntarios están exentos. La ley solo se aplica a los empleados que han sido contratados por establecimientos de servicio de comida.',
        q6: '¿Se requiere que los empleados de los supermercados obtengan una tarjeta de manipulador de alimentos?',
        a6: 'No, los supermercados están exentos de la ',
        a6_link: 'Ley de la Tarjeta de Manipulador de Alimentos de California.',
        a6_href: '/food-handlers-card/california-espanol',
        q7: 'Trabajo en un puesto de demostración sirviendo muestras de alimentos en un supermercado. ¿Se requiere que obtenga una Tarjeta de Manipulador de Alimentos de California?',
        a7: 'No. Los empleados de los supermercados están exentos y las empresas de demostración no están permitidas como establecimientos de comida.',
        q8: 'Actualmente tengo una Certificación de Seguridad Alimentaria de Gerente válida. ¿Necesito una Tarjeta de Manipulador de Alimentos de California?',
        a8: 'No. La Certificación de Gerente de Alimentos es una capacitación de certificación más alta y completa que cumple y supera los requisitos de la ley de la Tarjeta de Manipulador de Alimentos; por lo tanto, no se requiere que obtenga la Tarjeta de Manipulador de Alimentos.',
        q9: 'Soy un empleado de medio tiempo o temporal. ¿Se requiere que obtenga una Tarjeta de Manipulador de Alimentos?',
        a9: 'Sí, todos los manipuladores de alimentos, independientemente de cuántas horas trabajen, deben obtener una tarjeta de manipulador de alimentos, a menos que estén exentos.',
        q10: '¿Cuándo obtendré mi Tarjeta de Manipulador de Alimentos?',
        a10: 'Podrá descargar e imprimir su tarjeta de manipulador de alimentos tan pronto como termine la capacitación en línea y apruebe el examen final.',
        q11: '¿Tengo que completar la capacitación de una sola vez?',
        a11: 'No, puede completar la capacitación en varias sesiones. Cada vez que cierra la sesión de su cuenta, su progreso se guarda, lo que le permite reanudar la capacitación más tarde desde la misma sección donde la dejó.',
        q12: '¿Qué pasa si no tengo una impresora en casa para imprimir mi Tarjeta de Manipulador de Alimentos?',
        a12: 'Si no tiene acceso a una computadora con impresora, aún puede realizar la capacitación en línea y, una vez que haya aprobado el examen, podemos enviarle por correo una copia impresa de su Tarjeta de Manipulador de Alimentos de California por un cargo adicional de $9.99.',
        q13: '¿Es mi empleador responsable de pagar mi capacitación y la Tarjeta de Manipulador de Alimentos?',
        a13: 'Sí. A partir del 1 de enero de 2024, los empleadores de California estarán obligados a cubrir el costo de la capacitación de la tarjeta de manipulador de alimentos para todos los empleados. Para más información sobre la ley SB476, por favor ',
        a13_link: 'haz click aquí',
        a13_href: '/food-handlers-card/california/sb476-law',
        q14: '¿Cuándo vencerá mi tarjeta de manipulador de alimentos?',
        a14: 'La tarjeta de manipulador de alimentos es válida por 3 años antes de que necesite renovarla.',
        q15: '¿Es mi tarjeta válida en cualquier lugar de California?',
        a15_start: 'Su ',
        a15: ' es válida para trabajar en cualquier establecimiento de comida en California, con la excepción de aquellos ubicados en los condados de San Bernardino, Riverside y San Diego. Estos condados emiten sus propias Tarjetas de Manipulador de Alimentos.',
        a15_link: 'Tarjeta de Manipulador de Alimentos de California',
        a15_href: '/food-handlers-card/california-espanol',
        q16: 'Necesito obtener mi Tarjeta de Manipulador de Alimentos pero no tengo una computadora, tableta o teléfono inteligente, ¿qué puedo hacer?',
        a16_title: 'Si no tienes acceso a una computadora o dispositivo móvil, tenemos algunas sugerencias:',
        a16_list: [
          'Acude a tu biblioteca local – ahí hay computadoras disponibles para uso público',
          'Pide a un amigo si te puede prestar su computadora por unas horas',
          'Pregunta a tu supervisor si puedes usar la computadora en tu lugar de trabajo',
        ],
        q17: 'Trabajo para múltiples establecimientos. ¿Necesito una Tarjeta de Manipulador de Alimentos para cada uno de ellos?',
        a17: 'Generalmente, no. Su tarjeta de manipulador de alimentos se emitirá a su nombre y será válida por 3 años, incluso si comienza a trabajar para un empleador diferente o trabaja para dos o más restaurantes. Sin embargo, si alguno de los establecimientos para los que trabaja se encuentra en el condado de San Bernardino, San Diego o Riverside, deberá obtener una tarjeta de manipulador de alimentos para trabajar allí. Estos condados emiten su propia tarjeta de manipulador de alimentos.',
        q18: 'Actualmente trabajo en un restaurante en San Diego y cuento con una ',
        q18_link1: 'Tarjeta de Manipulador de Alimentos de San Diego.',
        q18_href1: '/food-handlers-card/san-diego-county-espanol',
        q18_mid: ' ¿La ley requiere que también obtenga una ',
        q18_link2: 'Tarjeta de Manipulador de Alimentos de California',
        q18_href2: '/food-handlers-card/california-espanol',
        q18_end: ' también?',
        a18: 'Sí, si trabaja para un restaurante fuera del condado de San Diego, como el condado de Orange, debe obtener una tarjeta de manipulador de alimentos de California. Esta misma regla se aplica si trabaja actualmente para un restaurante en el condado de San Bernardino o Riverside.',
        q19: '¿Qué documentación deben conservar los empleadores?',
        a19: 'Los empleadores son responsables de mantener registros precisos de que todos los manipuladores de alimentos empleados por el establecimiento poseen una tarjeta de manipulador de alimentos de California válida. Un ejemplo de documentación adecuada sería conservar una copia de la tarjeta de cada manipulador de alimentos en el archivo, para que esté disponible a pedido del próximo inspector de salud.',
        q20: 'Si tiene un grupo de 100 o más empleados que necesitan capacitación, llámenos para recibir un descuento especial por grupo.',
        a20: 'Para más información, llámanos al ',
        a20_phone: '800-676-3121',
        a20_phone_href: 'tel:+18006763121',
        a20_mid: ' o ',
        a20_link: 'solicita una cotización',
        a20_href: '/food-handlers-card/california-espanol',
      },
    },
    estimateTime: {
      text: '90 minutos',
      description: 'Tiempo estimado para completar el curso + examen',
    },
    easyProcessVideo: {
      alt: 'Cómo obtener una Tarjeta de Manipulador de Alimentos de California',
      title: 'Cómo obtener una Tarjeta de Manipulador de Alimentos de California',
    },
    onlineProgram: {
      title: 'Únete a más de 3 millones de profesionales de servicios de alimentos satisfechos',
      subTitle: 'Obtén tu tarjeta de manipulador de alimentos con este programa de certificación en línea de 90 minutos',
      startedToday: 'Comienza hoy mismo',
    },
    aboutPfs: {
      subTitle: 'Líder de la industria en capacitación alimentaria',
      title: 'Acerca de Premier Food Safety',
      description: 'Con más de 45 años de experiencia, somos los principales proveedores de soluciones de capacitación y certificación en seguridad alimentaria para la industria de servicios de alimentos. Nuestros programas acreditados están aprobados por los departamentos de salud locales y diseñados para brindarte la máxima flexibilidad al elegir la capacitación para ti o tu personal.',
      programs: 'Ofrecemos la Certificación de Gerente de Alimentos ServSafe en todo el país y programas de Tarjetas de Manipulador de Alimentos específicos de cada estado para ayudarte a cumplir con los requisitos reglamentarios de manera fácil y económica.',
    },
    howItWorks: {
      caTitle: 'Cómo obtener una tarjeta de manipulador de alimentos de CA',
      caDescription: 'Para obtener tu tarjeta hoy, todo lo que tienes que hacer es registrarte, realizar el curso en línea y aprobar el examen. Tu tarjeta estará lista para que la descargues inmediatamente después. Mira el video para obtener una guía paso a paso sobre el proceso.',
      easyProcess: 'Nuestro proceso sencillo',
      step1: 'PASO 1',
      step2: 'PASO 2',
      step3: 'PASO 3',
    },
    steps: {
      step1: {
        title: 'Regístrate y Capacítate',
        languages: 'Idiomas: Inglés, Español (Español), Chino (中文) y Coreano (한국어)',
        onlineCourseLength: 'Duración del curso 100% en línea: 90 minutos (incluido el examen)',
        startAndStop: 'Inicia y detén según sea necesario',
        features: 'El curso cuenta con transcripción de texto completo y subtítulos',
      },
      step2: {
        title: 'Toma el examen',
        attempts: 'Número de intentos de examen: Ilimitados (después de 2 intentos fallidos, el curso debe verse desde el principio)',
        passingScore: 'Puntuación mínima de aprobación: 70%',
        onlineAndMobile: '100% en línea y compatible con dispositivos móviles',
      },
      step3: {
        title: 'Imprime la tarjeta y el certificado',
        downloadAndPrint: 'Descarga e imprime desde casa',
        validFor3Years: 'Tarjeta válida por 3 años',
        acceptedThroughout: 'Aceptado en todo California, excepto en los condados de Riverside, San Bernardino y San Diego',
        accessFor1Year: 'Acceso a la capacitación por 1 año',
      },
    },
    contactSection: {
      groupDiscount: '¿Buscas un descuento grupal?',
      contactUs: 'Contáctanos',
    },
    certifications: {
      alcohol: {
        location: 'Cursos de California AB1825 y SB1343',
        title: 'Capacitación para la prevención del acoso en el lugar de trabajo en California para empleados',
        items: [
          'Regístrate para la capacitación en línea',
          'Completa el curso e imprime el certificado de finalización',
        ],
        learnMore: 'Más información',
      },
      foodManager: {
        location: 'Certificación de Gerente de Alimentos de California',
        title: 'Curso en línea ServSafe® + Examen en línea',
        items: [
          'Regístrate para la clase presencial o el curso en línea de ServSafe',
          'Elige el examen ServSafe en papel o en línea',
        ],
        selectPackage: 'Selecciona un paquete',
      },
    },
    resources: {
      title: 'Recursos',
      items: {
        regulations: 'Regulaciones de California',
        retailFoodCode: 'Código de Alimentos Minoristas de California',
        practiceTest: 'Examen de práctica gratuito para manipuladores de alimentos',
        aboutCard: 'Acerca de la Tarjeta de Manipulador de Alimentos',
        handwashing: 'Pautas de lavado de manos',
        readyToEat: 'Pautas para preparar alimentos listos para comer',
      },
    },
    handlerTopPane: {
      foodHandlersCard: 'Tarjeta de Manipulador de Alimentos',
      startOnlineTraining: 'Iniciar capacitación en línea',
      groupDiscountsAvailable: 'Descuentos grupales disponibles',
      contactUs: 'Contáctanos',
      features: [
        'Acreditado por ANAB',
        'Aprobado por el Departamento de Salud de California',
        'Descarga e Imprime tu Tarjeta al Instante',
      ],
    },
    ctaForm: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      whichCounty: '¿En qué condado trabajas?',
      selectYourCounty: 'Selecciona tu condado',
      continue: 'Continuar',
      sanDiegoNotice: 'Las tarjetas de manipulador de alimentos de CA no son válidas en el condado de San Diego. Si trabajas en el condado de San Diego,',
      sanBernardinoNotice: 'La tarjeta de manipulador de alimentos de CA no es válida en el condado de San Bernardino. Para más información,',
      riversideNotice: 'La tarjeta de manipulador de alimentos de CA no es válida en el condado de Riverside. Para más información,',
      clickHere: 'haz click aquí',
    },
    customerStats: {
      over45Years: 'Más de 45 años',
      ofExperience: 'de experiencia',
      over3Million: 'Más de 3 millones',
      clientsTrained: 'de clientes capacitados',
      moneyGuarantee: 'Garantía de devolución de dinero',
    },
    customerTestimonials: {
      addToCart: 'Agregar al Carrito',
    },
    faqSection: {
      title: 'Preguntas Frecuentes',
      ca: {
        q1: '¿Qué es la ley de la Tarjeta de Manipulador de Alimentos de California?',
        a1: 'La Ley de la Tarjeta de Manipulador de Alimentos de California (basada en SB303) requiere que todos los manipuladores de alimentos (a menos que estén exentos) obtengan una tarjeta de manipulador de alimentos dentro de los 30 días posteriores a la fecha de contratación y la renueven cada 3 años.',
        q2: '¿Cómo puedo obtener una ',
        q2_link: 'Tarjeta de Manipulador de Alimentos de California?',
        q2_href: '/food-handlers-card/california-espanol',
        a2_start: 'La tarjeta se emite al completar con éxito un programa de seguridad alimentaria acreditado por ANAB, como ',
        a2_link: 'Premier Food Safety',
        a2_end: ', y un examen de 40 preguntas con una puntuación mínima del 70%.',
        q3: '¿Quién es considerado un manipulador de alimentos?',
        a3: 'Un manipulador de alimentos es cualquier individuo que participa en la preparación, almacenamiento o servicio de alimentos en un establecimiento de comida.',
        q4: '¿Existen excepciones a la ley de la Tarjeta de Manipulador de Alimentos de California?',
        a4_title: 'Los manipuladores de alimentos que trabajan en cualquiera de los siguientes establecimientos están exentos de cumplir con esta ley:',
        a4_list: [
          'Establecimientos de comida temporales (food booths),',
          'Farmer\'s markets certificados,',
          'Cocinas fijas (commissaries), supermercados (incluyendo tiendas de conveniencia),',
          'Establecimientos de salud con licencia,',
          'Unidades de soporte móvil,',
          'Cafeterías de escuelas públicas o privadas,',
          'Establecimientos de servicio de comida restringido,',
          'Tiendas de menudeo en donde la mayoría de las ventas provienen de la farmacia,',
          'Lugares para eventos con servicios de snack bar en donde la mayor parte de las ventas provienen de los boletos de entrada,',
          'Ciertos establecimientos de comida que cuentan con un programa de entrenamiento en manejo seguro de alimentos aprobado para uso interno,',
          'Establecimientos de comida sujetos a un contrato colectivo (sindicato),',
          'Cualquier establecimiento de la ciudad, condado, ciudad y condado, estatal o regional utilizado para el confinamiento de adultos o menores de edad, incluyendo pero no limitado a cárceles de condado, correccionales para menores, campamentos, ranchos u otros establecimientos residenciales,',
          'Programas de nutrición para adultos mayores administrados por el Departamento de Envejecimiento de California, y',
          'Manipuladores de alimentos que trabajan en los condados de Riverside, San Bernardino y San Diego y manipuladores de alimentos que cuenten con un Certificado válido de Gerente de Protección de Alimentos.',
        ],
        q5: 'Trabajo como voluntario en un comedor popular, banco de alimentos o un restaurante dirigido por voluntarios. ¿Necesito una Tarjeta de Manipulador de Alimentos?',
        a5: 'No, los voluntarios están exentos. La ley solo se aplica a los empleados que han sido contratados por establecimientos de servicio de comida.',
        q6: '¿Se requiere que los empleados de los supermercados obtengan una tarjeta de manipulador de alimentos?',
        a6: 'No, los supermercados están exentos de la ',
        a6_link: 'Ley de la Tarjeta de Manipulador de Alimentos de California.',
        a6_href: '/food-handlers-card/california-espanol',
        q7: 'Trabajo en un puesto de demostración sirviendo muestras de alimentos en un supermercado. ¿Se requiere que obtenga una Tarjeta de Manipulador de Alimentos de California?',
        a7: 'No. Los empleados de los supermercados están exentos y las empresas de demostración no están permitidas como establecimientos de comida.',
        q8: 'Actualmente tengo una Certificación de Seguridad Alimentaria de Gerente válida. ¿Necesito una Tarjeta de Manipulador de Alimentos de California?',
        a8: 'No. La Certificación de Gerente de Alimentos es una capacitación de certificación más alta y completa que cumple y supera los requisitos de la ley de la Tarjeta de Manipulador de Alimentos; por lo tanto, no se requiere que obtenga la Tarjeta de Manipulador de Alimentos.',
        q9: 'Soy un empleado de medio tiempo o temporal. ¿Se requiere que obtenga una Tarjeta de Manipulador de Alimentos?',
        a9: 'Sí, todos los manipuladores de alimentos, independientemente de cuántas horas trabajen, deben obtener una tarjeta de manipulador de alimentos, a menos que estén exentos.',
        q10: '¿Cuándo obtendré mi Tarjeta de Manipulador de Alimentos?',
        a10: 'Podrá descargar e imprimir su tarjeta de manipulador de alimentos tan pronto como termine la capacitación en línea y apruebe el examen final.',
        q11: '¿Tengo que completar la capacitación de una sola vez?',
        a11: 'No, puede completar la capacitación en varias sesiones. Cada vez que cierra la sesión de su cuenta, su progreso se guarda, lo que le permite reanudar la capacitación más tarde desde la misma sección donde la dejó.',
        q12: '¿Qué pasa si no tengo una impresora en casa para imprimir mi Tarjeta de Manipulador de Alimentos?',
        a12: 'Si no tiene acceso a una computadora con impresora, aún puede realizar la capacitación en línea y, una vez que haya aprobado el examen, podemos enviarle por correo una copia impresa de su Tarjeta de Manipulador de Alimentos de California por un cargo adicional de $9.99.',
        q13: '¿Es mi empleador responsable de pagar mi capacitación y la Tarjeta de Manipulador de Alimentos?',
        a13: 'Sí. A partir del 1 de enero de 2024, los empleadores de California estarán obligados a cubrir el costo de la capacitación de la tarjeta de manipulador de alimentos para todos los empleados. Para más información sobre la ley SB476, por favor ',
        a13_link: 'haz click aquí',
        a13_href: '/food-handlers-card/california/sb476-law',
        q14: '¿Cuándo vencerá mi tarjeta de manipulador de alimentos?',
        a14: 'La tarjeta de manipulador de alimentos es válida por 3 años antes de que necesite renovarla.',
        q15: '¿Es mi tarjeta válida en cualquier lugar de California?',
        a15_start: 'Su ',
        a15: ' es válida para trabajar en cualquier establecimiento de comida en California, con la excepción de aquellos ubicados en los condados de San Bernardino, Riverside y San Diego. Estos condados emiten sus propias Tarjetas de Manipulador de Alimentos.',
        a15_link: 'Tarjeta de Manipulador de Alimentos de California',
        a15_href: '/food-handlers-card/california-espanol',
        q16: 'Necesito obtener mi Tarjeta de Manipulador de Alimentos pero no tengo una computadora, tableta o teléfono inteligente, ¿qué puedo hacer?',
        a16_title: 'Si no tienes acceso a una computadora o dispositivo móvil, tenemos algunas sugerencias:',
        a16_list: [
          'Acude a tu biblioteca local – ahí hay computadoras disponibles para uso público',
          'Pide a un amigo si te puede prestar su computadora por unas horas',
          'Pregunta a tu supervisor si puedes usar la computadora en tu lugar de trabajo',
        ],
        q17: 'Trabajo para múltiples establecimientos. ¿Necesito una Tarjeta de Manipulador de Alimentos para cada uno de ellos?',
        a17: 'Generalmente, no. Su tarjeta de manipulador de alimentos se emitirá a su nombre y será válida por 3 años, incluso si comienza a trabajar para un empleador diferente o trabaja para dos o más restaurantes. Sin embargo, si alguno de los establecimientos para los que trabaja se encuentra en el condado de San Bernardino, San Diego o Riverside, deberá obtener una tarjeta de manipulador de alimentos para trabajar allí. Estos condados emiten su propia tarjeta de manipulador de alimentos.',
        q18: 'Actualmente trabajo en un restaurante en San Diego y cuento con una ',
        q18_link1: 'Tarjeta de Manipulador de Alimentos de San Diego.',
        q18_href1: '/food-handlers-card/san-diego-county-espanol',
        q18_mid: ' ¿La ley requiere que también obtenga una ',
        q18_link2: 'Tarjeta de Manipulador de Alimentos de California',
        q18_href2: '/food-handlers-card/california-espanol',
        q18_end: ' también?',
        a18: 'Sí, si trabaja para un restaurante fuera del condado de San Diego, como el condado de Orange, debe obtener una tarjeta de manipulador de alimentos de California. Esta misma regla se aplica si trabaja actualmente para un restaurante en el condado de San Bernardino o Riverside.',
        q19: '¿Qué documentación deben conservar los empleadores?',
        a19: 'Los empleadores son responsables de mantener registros precisos de que todos los manipuladores de alimentos empleados por el establecimiento poseen una tarjeta de manipulador de alimentos de California válida. Un ejemplo de documentación adecuada sería conservar una copia de la tarjeta de cada manipulador de alimentos en el archivo, para que esté disponible a pedido del próximo inspector de salud.',
        q20: 'Si tiene un grupo de 100 o más empleados que necesitan capacitación, llámenos para recibir un descuento especial por grupo.',
        a20: 'Para más información, llámanos al ',
        a20_phone: '800-676-3121',
        a20_phone_href: 'tel:+18006763121',
        a20_mid: ' o ',
        a20_link: 'solicita una cotización',
        a20_href: '/food-handlers-card/california-espanol',
      },
    },
    estimateTime: {
      text: '90 minutos',
      description: 'Tiempo estimado para completar el curso + examen',
    },
    easyProcessVideo: {
      alt: 'Cómo obtener una Tarjeta de Manipulador de Alimentos de California',
      title: 'Cómo obtener una Tarjeta de Manipulador de Alimentos de California',
    },
    onlineProgram: {
      title: 'Únete a más de 3 millones de profesionales de servicios de alimentos satisfechos',
      subTitle: 'Obtén tu tarjeta de manipulador de alimentos con este programa de certificación en línea de 90 minutos',
      startedToday: 'Comienza hoy mismo',
    },
    aboutPfs: {
      subTitle: 'Líder de la industria en capacitación alimentaria',
      title: 'Acerca de Premier Food Safety',
      description: 'Con más de 45 años de experiencia, somos los principales proveedores de soluciones de capacitación y certificación en seguridad alimentaria para la industria de servicios de alimentos. Nuestros programas acreditados están aprobados por los departamentos de salud locales y diseñados para brindarte la máxima flexibilidad al elegir la capacitación para ti o tu personal.',
      programs: 'Ofrecemos la Certificación de Gerente de Alimentos ServSafe en todo el país y programas de Tarjetas de Manipulador de Alimentos específicos de cada estado para ayudarte a cumplir con los requisitos reglamentarios de manera fácil y económica.',
    },
    howItWorks: {
      caTitle: 'Cómo obtener una tarjeta de manipulador de alimentos de CA',
      caDescription: 'Para obtener tu tarjeta hoy, todo lo que tienes que hacer es registrarte, realizar el curso en línea y aprobar el examen. Tu tarjeta estará lista para que la descargues inmediatamente después. Mira el video para obtener una guía paso a paso sobre el proceso.',
      easyProcess: 'Nuestro proceso sencillo',
      step1: 'PASO 1',
      step2: 'PASO 2',
      step3: 'PASO 3',
    },
    steps: {
      step1: {
        title: 'Regístrate y Capacítate',
        languages: 'Idiomas: Inglés, Español (Español), Chino (中文) y Coreano (한국어)',
        onlineCourseLength: 'Duración del curso 100% en línea: 90 minutos (incluido el examen)',
        startAndStop: 'Inicia y detén según sea necesario',
        features: 'El curso cuenta con transcripción de texto completo y subtítulos',
      },
      step2: {
        title: 'Toma el examen',
        attempts: 'Número de intentos de examen: Ilimitados (después de 2 intentos fallidos, el curso debe verse desde el principio)',
        passingScore: 'Puntuación mínima de aprobación: 70%',
        onlineAndMobile: '100% en línea y compatible con dispositivos móviles',
      },
      step3: {
        title: 'Imprime la tarjeta y el certificado',
        downloadAndPrint: 'Descarga e imprime desde casa',
        validFor3Years: 'Tarjeta válida por 3 años',
        acceptedThroughout: 'Aceptado en todo California, excepto en los condados de Riverside, San Bernardino y San Diego',
        accessFor1Year: 'Acceso a la capacitación por 1 año',
      },
    },
    contactSection: {
      groupDiscount: '¿Buscas un descuento grupal?',
      contactUs: 'Contáctanos',
    },
    certifications: {
      alcohol: {
        location: 'Cursos de California AB1825 y SB1343',
        title: 'Capacitación para la prevención del acoso en el lugar de trabajo en California para empleados',
        items: [
          'Regístrate para la capacitación en línea',
          'Completa el curso e imprime el certificado de finalización',
        ],
        learnMore: 'Más información',
      },
      foodManager: {
        location: 'Certificación de Gerente de Alimentos de California',
        title: 'Curso en línea ServSafe® + Examen en línea',
        items: [
          'Regístrate para la clase presencial o el curso en línea de ServSafe',
          'Elige el examen ServSafe en papel o en línea',
        ],
        selectPackage: 'Selecciona un paquete',
      },
    },
    resources: {
      title: 'Recursos',
      items: {
        regulations: 'Regulaciones de California',
        retailFoodCode: 'Código de Alimentos Minoristas de California',
        practiceTest: 'Examen de práctica gratuito para manipuladores de alimentos',
        aboutCard: 'Acerca de la Tarjeta de Manipulador de Alimentos',
        handwashing: 'Pautas de lavado de manos',
        readyToEat: 'Pautas para preparar alimentos listos para comer',
      },
    },
    handlerTopPane: {
      foodHandlersCard: 'Tarjeta de Manipulador de Alimentos',
      startOnlineTraining: 'Iniciar capacitación en línea',
      groupDiscountsAvailable: 'Descuentos grupales disponibles',
      contactUs: 'Contáctanos',
      features: [
        'Acreditado por ANAB',
        'Aprobado por el Departamento de Salud de California',
        'Descarga e Imprime tu Tarjeta al Instante',
      ],
    },
    ctaForm: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      whichCounty: '¿En qué condado trabajas?',
      selectYourCounty: 'Selecciona tu condado',
      continue: 'Continuar',
      sanDiegoNotice: 'Las tarjetas de manipulador de alimentos de CA no son válidas en el condado de San Diego. Si trabajas en el condado de San Diego,',
      sanBernardinoNotice: 'La tarjeta de manipulador de alimentos de CA no es válida en el condado de San Bernardino. Para más información,',
      riversideNotice: 'La tarjeta de manipulador de alimentos de CA no es válida en el condado de Riverside. Para más información,',
      clickHere: 'haz click aquí',
    },
    customerStats: {
      over45Years: 'Más de 45 años',
      ofExperience: 'de experiencia',
      over3Million: 'Más de 3 millones',
      clientsTrained: 'de clientes capacitados',
      moneyGuarantee: 'Garantía de devolución de dinero',
    },
    customerTestimonials: {
      addToCart: 'Agregar al Carrito',
    },
    faqSection: {
      title: 'Preguntas Frecuentes',
      ca: {
        q1: '¿Qué es la ley de la Tarjeta de Manipulador de Alimentos de California?',
        a1: 'La Ley de la Tarjeta de Manipulador de Alimentos de California (basada en SB303) requiere que todos los manipuladores de alimentos (a menos que estén exentos) obtengan una tarjeta de manipulador de alimentos dentro de los 30 días posteriores a la fecha de contratación y la renueven cada 3 años.',
        q2: '¿Cómo puedo obtener una ',
        q2_link: 'Tarjeta de Manipulador de Alimentos de California?',
        q2_href: '/food-handlers-card/california-espanol',
        a2_start: 'La tarjeta se emite al completar con éxito un programa de seguridad alimentaria acreditado por ANAB, como ',
        a2_link: 'Premier Food Safety',
        a2_end: ', y un examen de 40 preguntas con una puntuación mínima del 70%.',
        q3: '¿Quién es considerado un manipulador de alimentos?',
        a3: 'Un manipulador de alimentos es cualquier individuo que participa en la preparación, almacenamiento o servicio de alimentos en un establecimiento de comida.',
        q4: '¿Existen excepciones a la ley de la Tarjeta de Manipulador de Alimentos de California?',
        a4_title: 'Los manipuladores de alimentos que trabajan en cualquiera de los siguientes establecimientos están exentos de cumplir con esta ley:',
        a4_list: [
          'Establecimientos de comida temporales (food booths),',
          'Farmer\'s markets certificados,',
          'Cocinas fijas (commissaries), supermercados (incluyendo tiendas de conveniencia),',
          'Establecimientos de salud con licencia,',
          'Unidades de soporte móvil,',
          'Cafeterías de escuelas públicas o privadas,',
          'Establecimientos de servicio de comida restringido,',
          'Tiendas de menudeo en donde la mayoría de las ventas provienen de la farmacia,',
          'Lugares para eventos con servicios de snack bar en donde la mayor parte de las ventas provienen de los boletos de entrada,',
          'Ciertos establecimientos de comida que cuentan con un programa de entrenamiento en manejo seguro de alimentos aprobado para uso interno,',
          'Establecimientos de comida sujetos a un contrato colectivo (sindicato),',
          'Cualquier establecimiento de la ciudad, condado, ciudad y condado, estatal o regional utilizado para el confinamiento de adultos o menores de edad, incluyendo pero no limitado a cárceles de condado, correccionales para menores, campamentos, ranchos u otros establecimientos residenciales,',
          'Programas de nutrición para adultos mayores administrados por el Departamento de Envejecimiento de California, y',
          'Manipuladores de alimentos que trabajan en los condados de Riverside, San Bernardino y San Diego y manipuladores de alimentos que cuenten con un Certificado válido de Gerente de Protección de Alimentos.',
        ],
        q5: 'Trabajo como voluntario en un comedor popular, banco de alimentos o un restaurante dirigido por voluntarios. ¿Necesito una Tarjeta de Manipulador de Alimentos?',
        a5: 'No, los voluntarios están exentos. La ley solo se aplica a los empleados que han sido contratados por establecimientos de servicio de comida.',
        q6: '¿Se requiere que los empleados de los supermercados obtengan una tarjeta de manipulador de alimentos?',
        a6: 'No, los supermercados están exentos de la ',
        a6_link: 'Ley de la Tarjeta de Manipulador de Alimentos de California.',
        a6_href: '/food-handlers-card/california-espanol',
        q7: 'Trabajo en un puesto de demostración sirviendo muestras de alimentos en un supermercado. ¿Se requiere que obtenga una Tarjeta de Manipulador de Alimentos de California?',
        a7: 'No. Los empleados de los supermercados están exentos y las empresas de demostración no están permitidas como establecimientos de comida.',
        q8: 'Actualmente tengo una Certificación de Seguridad Alimentaria de Gerente válida. ¿Necesito una Tarjeta de Manipulador de Alimentos de California?',
        a8: 'No. La Certificación de Gerente de Alimentos es una capacitación de certificación más alta y completa que cumple y supera los requisitos de la ley de la Tarjeta de Manipulador de Alimentos; por lo tanto, no se requiere que obtenga la Tarjeta de Manipulador de Alimentos.',
        q9: 'Soy un empleado de medio tiempo o temporal. ¿Se requiere que obtenga una Tarjeta de Manipulador de Alimentos?',
        a9: 'Sí, todos los manipuladores de alimentos, independientemente de cuántas horas trabajen, deben obtener una tarjeta de manipulador de alimentos, a menos que estén exentos.',
        q10: '¿Cuándo obtendré mi Tarjeta de Manipulador de Alimentos?',
        a10: 'Podrá descargar e imprimir su tarjeta de manipulador de alimentos tan pronto como termine la capacitación en línea y apruebe el examen final.',
        q11: '¿Tengo que completar la capacitación de una sola vez?',
        a11: 'No, puede completar la capacitación en varias sesiones. Cada vez que cierra la sesión de su cuenta, su progreso se guarda, lo que le permite reanudar la capacitación más tarde desde la misma sección donde la dejó.',
        q12: '¿Qué pasa si no tengo una impresora en casa para imprimir mi Tarjeta de Manipulador de Alimentos?',
        a12: 'Si no tiene acceso a una computadora con impresora, aún puede realizar la capacitación en línea y, una vez que haya aprobado el examen, podemos enviarle por correo una copia impresa de su Tarjeta de Manipulador de Alimentos de California por un cargo adicional de $9.99.',
        q13: '¿Es mi empleador responsable de pagar mi capacitación y la Tarjeta de Manipulador de Alimentos?',
        a13: 'Sí. A partir del 1 de enero de 2024, los empleadores de California estarán obligados a cubrir el costo de la capacitación de la tarjeta de manipulador de alimentos para todos los empleados. Para más información sobre la ley SB476, por favor ',
        a13_link: 'haz click aquí',
        a13_href: '/food-handlers-card/california/sb476-law',
        q14: '¿Cuándo vencerá mi tarjeta de manipulador de alimentos?',
        a14: 'La tarjeta de manipulador de alimentos es válida por 3 años antes de que necesite renovarla.',
        q15: '¿Es mi tarjeta válida en cualquier lugar de California?',
        a15_start: 'Su ',
        a15: ' es válida para trabajar en cualquier establecimiento de comida en California, con la excepción de aquellos ubicados en los condados de San Bernardino, Riverside y San Diego. Estos condados emiten sus propias Tarjetas de Manipulador de Alimentos.',
        a15_link: 'Tarjeta de Manipulador de Alimentos de California',
        a15_href: '/food-handlers-card/california-espanol',
        q16: 'Necesito obtener mi Tarjeta de Manipulador de Alimentos pero no tengo una computadora, tableta o teléfono inteligente, ¿qué puedo hacer?',
        a16_title: 'Si no tienes acceso a una computadora o dispositivo móvil, tenemos algunas sugerencias:',
        a16_list: [
          'Acude a tu biblioteca local – ahí hay computadoras disponibles para uso público',
          'Pide a un amigo si te puede prestar su computadora por unas horas',
          'Pregunta a tu supervisor si puedes usar la computadora en tu lugar de trabajo',
        ],
        q17: 'Trabajo para múltiples establecimientos. ¿Necesito una Tarjeta de Manipulador de Alimentos para cada uno de ellos?',
        a17: 'Generalmente, no. Su tarjeta de manipulador de alimentos se emitirá a su nombre y será válida por 3 años, incluso si comienza a trabajar para un empleador diferente o trabaja para dos o más restaurantes. Sin embargo, si alguno de los establecimientos para los que trabaja se encuentra en el condado de San Bernardino, San Diego o Riverside, deberá obtener una tarjeta de manipulador de alimentos para trabajar allí. Estos condados emiten su propia tarjeta de manipulador de alimentos.',
        q18: 'Actualmente trabajo en un restaurante en San Diego y cuento con una ',
        q18_link1: 'Tarjeta de Manipulador de Alimentos de San Diego.',
        q18_href1: '/food-handlers-card/san-diego-county-espanol',
        q18_mid: ' ¿La ley requiere que también obtenga una ',
        q18_link2: 'Tarjeta de Manipulador de Alimentos de California',
        q18_href2: '/food-handlers-card/california-espanol',
        q18_end: ' también?',
        a18: 'Sí, si trabaja para un restaurante fuera del condado de San Diego, como el condado de Orange, debe obtener una tarjeta de manipulador de alimentos de California. Esta misma regla se aplica si trabaja actualmente para un restaurante en el condado de San Bernardino o Riverside.',
        q19: '¿Qué documentación deben conservar los empleadores?',
        a19: 'Los empleadores son responsables de mantener registros precisos de que todos los manipuladores de alimentos empleados por el establecimiento poseen una tarjeta de manipulador de alimentos de California válida. Un ejemplo de documentación adecuada sería conservar una copia de la tarjeta de cada manipulador de alimentos en el archivo, para que esté disponible a pedido del próximo inspector de salud.',
        q20: 'Si tiene un grupo de 100 o más empleados que necesitan capacitación, llámenos para recibir un descuento especial por grupo.',
        a20: 'Para más información, llámanos al ',
        a20_phone: '800-676-3121',
        a20_phone_href: 'tel:+18006763121',
        a20_mid: ' o ',
        a20_link: 'solicita una cotización',
        a20_href: '/food-handlers-card/california-espanol',
      },
    },
    estimateTime: {
      text: '90 minutos',
      description: 'Tiempo estimado para completar el curso + examen',
    },
    easyProcessVideo: {
      alt: 'Cómo obtener una Tarjeta de Manipulador de Alimentos de California',
      title: 'Cómo obtener una Tarjeta de Manipulador de Alimentos de California',
    },
    onlineProgram: {
      title: 'Únete a más de 3 millones de profesionales de servicios de alimentos satisfechos',
      subTitle: 'Obtén tu tarjeta de manipulador de alimentos con este programa de certificación en línea de 90 minutos',
      startedToday: 'Comienza hoy mismo',
    },
    aboutPfs: {
      subTitle: 'Líder de la industria en capacitación alimentaria',
      title: 'Acerca de Premier Food Safety',
      description: 'Con más de 45 años de experiencia, somos los principales proveedores de soluciones de capacitación y certificación en seguridad alimentaria para la industria de servicios de alimentos. Nuestros programas acreditados están aprobados por los departamentos de salud locales y diseñados para brindarte la máxima flexibilidad al elegir la capacitación para ti o tu personal.',
      programs: 'Ofrecemos la Certificación de Gerente de Alimentos ServSafe en todo el país y programas de Tarjetas de Manipulador de Alimentos específicos de cada estado para ayudarte a cumplir con los requisitos reglamentarios de manera fácil y económica.',
    },
    howItWorks: {
      caTitle: 'Cómo obtener una tarjeta de manipulador de alimentos de CA',
      caDescription: 'Para obtener tu tarjeta hoy, todo lo que tienes que hacer es registrarte, realizar el curso en línea y aprobar el examen. Tu tarjeta estará lista para que la descargues inmediatamente después. Mira el video para obtener una guía paso a paso sobre el proceso.',
      easyProcess: 'Nuestro proceso sencillo',
      step1: 'PASO 1',
      step2: 'PASO 2',
      step3: 'PASO 3',
    },
    steps: {
      step1: {
        title: 'Regístrate y Capacítate',
        languages: 'Idiomas: Inglés, Español (Español), Chino (中文) y Coreano (한국어)',
        onlineCourseLength: 'Duración del curso 100% en línea: 90 minutos (incluido el examen)',
        startAndStop: 'Inicia y detén según sea necesario',
        features: 'El curso cuenta con transcripción de texto completo y subtítulos',
      },
      step2: {
        title: 'Toma el examen',
        attempts: 'Número de intentos de examen: Ilimitados (después de 2 intentos fallidos, el curso debe verse desde el principio)',
        passingScore: 'Puntuación mínima de aprobación: 70%',
        onlineAndMobile: '100% en línea y compatible con dispositivos móviles',
      },
      step3: {
        title: 'Imprime la tarjeta y el certificado',
        downloadAndPrint: 'Descarga e imprime desde casa',
        validFor3Years: 'Tarjeta válida por 3 años',
        acceptedThroughout: 'Aceptado en todo California, excepto en los condados de Riverside, San Bernardino y San Diego',
        accessFor1Year: 'Acceso a la capacitación por 1 año',
      },
    },
    contactSection: {
      groupDiscount: '¿Buscas un descuento grupal?',
      contactUs: 'Contáctanos',
    },
    certifications: {
      alcohol: {
        location: 'Cursos de California AB1825 y SB1343',
        title: 'Capacitación para la prevención del acoso en el lugar de trabajo en California para empleados',
        items: [
          'Regístrate para la capacitación en línea',
          'Completa el curso e imprime el certificado de finalización',
        ],
        learnMore: 'Más información',
      },
      foodManager: {
        location: 'Certificación de Gerente de Alimentos de California',
        title: 'Curso en línea ServSafe® + Examen en línea',
        items: [
          'Regístrate para la clase presencial o el curso en línea de ServSafe',
          'Elige el examen ServSafe en papel o en línea',
        ],
        selectPackage: 'Selecciona un paquete',
      },
    },
    resources: {
      title: 'Recursos',
      items: {
        regulations: 'Regulaciones de California',
        retailFoodCode: 'Código de Alimentos Minoristas de California',
        practiceTest: 'Examen de práctica gratuito para manipuladores de alimentos',
        aboutCard: 'Acerca de la Tarjeta de Manipulador de Alimentos',
        handwashing: 'Pautas de lavado de manos',
        readyToEat: 'Pautas para preparar alimentos listos para comer',
      },
    },
    ...examPlayerI18nEs,
    ...itemBankAdminI18nEs,
    ...itemBankContentI18nEs,
    ...itemBankSetupI18nEs,
    ...itemBankExamsI18nEs,
    ...itemBankExamStatsI18nEs,
    ...smeWorkspaceI18nEs,
  },

  // Chinese
  zh: {
    confirmDialog: {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    },
    commonConfirmDialog: {
      title: 'Confirmation',
      content: 'Do you agree to continue this action?',
      unsavedChange: 'Do you want to close the dialog?',
      confirmation: 'Confirmation',
    },
    commonDeleteDialog: {
      title: 'Delete',
      content: 'Are you sure deleting this?',
    },
    editProfile: {
      userId: 'User ID',
      firstName: 'First Name',
      lastName: 'Last Name',
      middleName: 'Middle Name',
      company: 'Company',
      jobTitle: 'Job Title',
      address: 'Address',
      unitSuitApt: 'Unit/Suite/Apt #',
      dob: 'Date of Birth',
      language: 'Language',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      additionalPhoneNumber: 'Additional Phone Number',
      updateProfileSuccess: 'Update your information successfully',

      addDateOfBirth: 'Add date of birth',
      courseRequireDob: 'This course require date of birth to proceed. Please input your date of birth.',
    },
    viewLearnerDetail: {
      apexRegistration: 'This registration is belong to Apex site. Please log in on Apex site to see detail',
      view: 'View',
    },
    accountSetting: {
      status: 'Status',
      userName: 'Username',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
    },
    paymentDialog: {
      addOrChargeCreditCard: 'Add/Charge Credit Card',
      payment: 'Payment',
      choosePaymentMethods: 'Choose payment methods',
      chargeSelectedCard: 'Charge selected card',
      checkName: 'Check name',
      checkNumber: 'Check number',
      amount: 'Amount ($)',
      payWithoutCheck: 'Pay without check',
      proceedWithoutCheck: 'Proceed without check',
      checkInfoNotRequired: 'Check info not required',
      allowSeatAssignmentsWithoutCheck: 'Allow seat assignments without check',
      pleaseMailYourCheckTo: 'Please mail your check to',
      groupAdminNoticeMessage: 'TRAINING PACKAGES WILL NOT BECOME ACTIVE UNTIL PAYMENT IS RECEIVED',
    },
    title: {
      assignedSeats: 'Assigned Seats',
      assigned: 'Assigned',
      classRegistrations: 'In-Person Food Manager',
      proctorURegistrations: 'Online Food Manager',
      actions: 'Actions',
      orders: 'Orders',
      adminELearning: 'Admin e-Learning',
      studentELearning: 'Student e-Learning',
      learners: 'Learners',
      accountSettings: 'Account Settings',
    },
    button: {
      getStarted: 'Get started',
      excelReport: 'Excel Report',
      hideUnhideRegistrations: 'Hide/Unhide Registrations',
      hideRegistrations: 'Hide Registrations',
      unhideRegistrations: 'Unhide Registrations',
      emailCertificate: 'Email Certificate',
      downloadCertificates: 'Download Certificates',
      resendPassword: 'Resend Password',
      submit: 'Submit',
      generate: 'Generate',
      send: 'Send',
      orderPrintedCopy: 'Order Printed Copy',
      downloadCertificate: 'Download Certificate',
      downloadCert: 'Download Certificate',
      save: 'Save',
      edit: 'Edit',
      continueToCheckout: 'Continue to Checkout',
      documents: 'Documents',
      back: 'Back',
      markAsPaid: 'Mark as Paid',
      pay: 'Pay',
      remove: 'Remove',
      cancel: 'Cancel',
      close: 'Close',
      refund: 'Refund',
      refunded: 'Refunded',
      classRegistrationRefunded: 'This class was refunded',
      proctorURefunded: 'This code was refunded',
      eLearningRefunded: 'This training was refunded',
      notSupportRefundByCheck: 'Refunds by check are not supported',
      notSupportRefundByPaymentMethod: 'El sistema no acepta reembolsos si el pago es con {paymentMethod}',
      applyToSelected: 'Apply to Selected',
      create: 'Create',
      download: 'Download',
      expandMore: 'Expand More',
    },
    header: {
      firstName: 'First Name',
      lastName: 'Last Name',
      serverId: 'Server ID',
      emailAddress: 'Email Address',
      email: 'Email',
      status: 'Status',
      userId: 'User ID',
      instructorNotes: 'Instructor notes',
    },
    deleteLearnerDialog: {
      title: 'Delete learner',
      content: 'Are you sure you want to delete this learner?',
      pfsAdminContent: 'This action will permanently unassign learner from all assigned training courses.',
    },
    updateLearnerPosition: {
      update: 'Update',
    },
    updateLearnerProgress: {
      update: 'Update',
    },
    form: {
      requiredField: 'Required field',
    },

    // Components start from here.
    addQuizForm: {
      addAttempt: 'Add Attempt',
      addAttemptPlaceholder: 'Select Exam',
      add: 'Add',
    },
    assignedCourseDetail: {
      generalSettings: 'General Settings',
      examResults: 'Results',
      actions: 'Actions',
      updateLearnerPosition: 'Update Learner\'s Position',
      currentProgress: 'Current Progress',
      studentInfo: 'Student Info',
      studentCourses: 'Student Courses',
      close: 'Close',
      saveCurrentProgressAs: 'Save current position as',
    },
    assignedCourse: {
      course: 'Course',
      packageInfo: 'Package Info',
      createdDate: 'Create Date',
      courseExpiration: 'Course Expiration',
      courseStatus: 'Course Status',
      hide: 'Hide Learners',
      unhide: 'Unhide Learners',
      hideUnhideLearners: 'Hide/Unhide Learners',
      changeVisibilityGuidance: 'Select learners to update visibility',
      hiddenUnhidden: 'Hidden/Unhidden',
    },
    visibility: {
      hidden: 'Hidden',
      unhidden: 'Unhidden',
    },
    courseStatus: {
      notStarted: 'Not Started',
      inProgress: 'In Progress',
      completed: 'Completed',
      active: 'Active',
      expired: 'Expired',
      notExpired: 'Not Expired',
    },
    assignedCourseTable: {
      userId: 'User ID',
      confirmation: 'Confirmation',
      assignedDate: 'Registered On',
      expiredDate: 'Expires On',
      course: 'Course',
      order: 'Order',
      serverId: 'Server ID',
      licenseStatus: 'License Status',
      quickActions: 'Quick Actions',
      trainingStatus: 'Training Status',
      courseProgress: 'Course Progress',
      completed: 'Completed',
      verificationCode: 'Verification Code #',
      studentName: 'Student Name',
      admin: 'Admin',
    },
    assignedProctorU: {
      assigned: 'Assigned',
      sent: 'Sent',
      transferPackage: 'Transfer Package',
      notSentYet: 'Not sent yet',
      unassigned: 'Unassigned',
      resendExamCode: 'Resend Exam Code',
      confirmation: 'Confirmation',
      studentName: 'Student Name',
      purchaseDate: 'Purchase Date',
      assignDate: 'Assign Date',
      examCode: 'Exam Code',
      packageInfo: 'Package Info',
      packageName: 'Package Name',
      order: 'Order',
      resendCodeSuccessfully: 'The code has been sent successfully',
      resendCodesSuccessfully: 'All codes have been sent successfully.',
      actions: 'Actions',
      documents: 'Documents',
      proctorURegistrations: 'ProctorU Registrations',
      dateSent: 'Date Sent',
      restartTraining: 'Restart Training',
      buyExamCodes: 'Buy Exam Codes',
      noAssignedRegistrations: 'You currently do not have any registrations.',
      code: 'Code',
      willBeTransferredFrom: 'will be transferred from',
      to: 'to',
    },
    proctorUColumns: {
      conf: 'Conf',
      order: 'Order',
      regDate: 'Reg. Date',
      paid: 'Paid',
      balance: 'Balance',
      registeredBy: 'Registered By',
      companyName: 'Company Name',
      status: 'Status',
      examCode: 'Exam Code',
    },
    assignedSeats: {
      confirmation: 'Confirmation',
      studentName: 'Student Name',
      order: 'Order',
      createdDate: 'Created Date',
      state: 'State',
      classInfo: 'Class Info',
      packageInfo: 'Package Info',
      packageName: 'Package Name',
      attendStatus: 'Status',
      balance: 'Balance',
      websiteOrLinks: 'Website / Links',
      studentPortal: 'Student Portal',
      classLocation: 'Class Location',
      classDate: 'Class Date',
      schedule: 'Schedule',
      noDataText: 'No registration found.',
      haveNoRegistrations: 'You currently do not have any registrations',
      buySeats: 'Buy Seats',
      newClassRegistration: 'New Class Registration',
      expirationDate: 'Exp. Date',
      selectDate: 'Select Date',
    },
    assignment: {
      state: 'State',
      addLine: 'Add line',
      online: 'Online Courses',
      almostFull: 'Almost full',
      full: 'Full',
      inPerson: 'In-Person Food Manager',
      proctorU: 'Online Food Manager',
      selectPackageToSeeLearnersList: 'Select a package to load learners list',
      classLanguage: 'Class language',
      year: 'Year',
      package: 'Package',
      assigned: 'assigned',
      assignedSuccessfully: 'Assigned Successfully',
      step1: 'Select Available Packages - Step 1',
      step2: 'Select Learners - Step 2',
      step3: 'Assign Seats - Step 3',
      assignLearners: 'Assign Learners',
      done: 'Done',
      noLearnerAvailable: 'No learners available',
      selectAtLeastOneLearner: 'You must add at least one learner to assign to the selected package',
      next: 'Next',
      courseRequireDob: 'This course requires the learner’s date of birth to comply with local regulatory authority reporting guidelines. Please make sure you enter the correct date below.',
      importAndAssignComplete: 'Import and assign package to learners complete',
      learnerSelectedExceedQuantity: 'The number of new learners selected exceeds the number of available packages.',
      selectAvailablePackagesSubtitle: 'All contents of packages will be assigned to a single learner',
      learners: 'Learners',
      success: 'Success',
      successSubtitle: 'You have successfully assigned the following to {learnerNumber} learners.',
      packageIncludes: 'Package Includes',
      show: 'Show',
      enroll: 'Enroll',
      states: 'States',
      businessZipCode: 'Business Zip Code',
      inactiveLearnersInSelections: 'There are inactive learners in selection list. Please deselect those learners.',
      location: 'Location',
      miles: 'Miles',
      language: 'Language',
      selected: 'Selected',
      select: 'Select',
      selectedLearners: 'Selected Learners',
      packageSelected: 'Package Selected',
      remainingQuantity: '{quantity} available',
      productList: 'Product List',
      enrollAndContinue: 'Enroll & Continue',
      footerNote: ' All contents of packages will be assigned to a single learner.',
      classCancelled: 'Class Cancelled',
      rescheduleFee: 'Reschedule Fee',
      note: 'Note',
      rescheduleRegistration: 'Reschedule Registration',
      skipForNow: 'Skip for Now',
      skipForNowNote1: 'This package also includes an in person class.',
      skipForNowNote2: 'Please select the date of the in person Class',
      selectExamLanguage: 'Select Exam Language',
      assign: 'Assign',
      selectPackage: 'Selected Package',
      selectAPackage: 'Select a package',
      noPackageAvailable: 'No package available',

      rbsInstruction1: 'The CA Dept. of Alcoholic Beverage Control requires all servers to',
      createRbsAccount: 'Create an RBS Account',
      rbsInstruction2: 'to obtain a Server ID prior to starting the RBS training.',
      rbsInstruction3: 'The CA Dept. of Alcoholic Beverage Control requires all servers to obtain a Server ID prior to starting the RBS training.',
      rbsServerIdFee: 'Please note: the ABC charges a $3 fee to obtain a Server ID.',
      rbsServerId: 'RBS Server ID',
      learnerInfo: 'Learner Info',
      serverId: 'Server ID here',
      enter: 'Enter',
      rbsDialogStep1: 'Click here to',
      rbsDialogStep3: 'Verify your information is correct',

      dob: 'Date of Birth',
      shortDob: 'DOB',
      lastName: 'Last Name',
      seatsLeft: 'Seats Left',
      seatLeft: 'Seat Left',
      noSeatsLeft: 'Class full',
      noClassFound: 'No class found.',
      instantResults: 'Instant results',
      instantResultsNote: 'Classes marked with a star will be offered with instant results. Learners will need a laptop and a ServSafe account set up in advance. Details will be sent via email.',
      instantResultsLegend: 'Instant Results - Please bring your own laptop',

      private: 'Private Class',
      employeeId: 'Employee ID',

      manage: 'Manage',
      managePackages: 'Manage Packages',
      packageName: 'Package Name',
      availableQuantity: 'Available Quantity',
      deleteAvailablePackages: 'Delete Available Packages',
      areYouSureYouWantToDelete: 'Are you sure you want to delete',
      thisActionCannotBeUndone: 'This action cannot be undone.',
      totalAvailablePackages: 'Total available packages of this type',
      toConfirmPleaseTypeTheNumberOfAvailable: 'To confirm, please type the number of available',
      toDelete: 'to delete',
      seatRemovedSuccess: 'Available Seat removed successfully!',
    },
    examResults: {
      save: 'Save',
      delete: 'Delete',
      quizName: 'Quiz Name',
      language: 'Language',
      correctAnswers: 'Correct Answers',
      totalQuestions: 'Total Questions',
      examScore: 'Exam Score',
      dateStarted: 'Date Started',
      dateUpdated: 'Date Updated',
    },
    addressDialog: {
      requestForLaminatedCard: 'A laminated card has already been bought by your group admin. Enter the mailing address for card delivery.',
    },
    lookup: {
      courses: 'Courses',
      licenseStatus: 'License Statuses',
      attendanceStatus: 'Attendance Statuses',
      filterBy: 'Filter by',
      selected: 'Selected',
      package: 'Packages',
      trainingStatuses: 'Training Statuses',
      expirationStatuses: 'Expiration Statuses',
      visibility: 'Visibility',
      packageType: 'Package Type',
    },
    printedCopyPaymentDialog: {
      description: 'Order a Hard Copy of Your Certificate for',
    },
    newOrders: {
      selectPackage: 'Select Package',
      productsIncluded: 'Products Included',
      orderFreeOfCharge: 'This is order is free of charge. Are you sure to pay for this order?',
      quantity: 'Quantity',
      discount: 'Discount',
      price: 'Price',
      newOrder: 'New Order',
      addAdditionalPackages: 'Add Additional Packages',
      guide: 'Select package to see included products.',
      removeDiscount: 'Remove Discount',
      applyDiscount: 'Apply Discount',
      orderTotal: 'Order total',
      discountErrorMessage: 'Discount value must smaller than package price.',
      cannotDelete: 'You cannot delete this package. At least one package must be in a new order.',
      addOrChangeCreditCard: 'Add/Charge Credit card',
      addPayment: 'Add Payment',
      payNow: 'Pay Now',
      errorNotification: 'Please check the errors log on fields',
      successNotification: 'New order has been created successfully',
    },
    orders: {
      freeFoodHandlerCardNote: 'Free with Premium Food Manager package. Transferable to employee.',
      paymentType: 'Payment Type',
      balanceDue: 'Balance Due',
      purchaseOrderGuide: 'Click here to choose a training package and start a new order',
      name: 'Name',
      productPackages: 'Product/Packages',
      exportOrders: 'Export Orders',
      exportSelectedOrders: 'Export Selected Orders',
      exportAllOrders: 'Export All Orders',
      exportOrdersInSelectedPage: 'Export Orders in selected page',
      creditCardInfo: 'Credit Card Info',
      zip: 'Zip',
      address: 'Address',
      packageId: 'Package ID',
      packageName: 'Package Name',
      price: 'Price',
      markAsPaid: 'Mark as Paid',
      markAsUnpaid: 'Mark as Unpaid',
      quantity: 'Quantity',
      status: 'Status',
      paymentDate: 'Payment Date',
      appliedCode: 'Code',
      discountAmount: 'Discount Amount',
      perUnit: 'per unit',
      totalDiscount: 'Total Discount',
      totalAmount: 'Total Amount',
      expirationDate: 'Expiration Date',
      deleteOrder: 'Delete order',
      deleteConfirmationText: 'Are you sure you want to delete this order?',
      deleteConfirmedText: 'Yes, delete',
      deleteSuccessfullyText: 'Delete order successfully',
      delete: 'Delete',
      edit: 'Edit',
      viewReceiptInvoice: 'View Receipt/Invoice',
      viewInvoice: 'View Invoice',
      cancel: 'Cancel',
      saveChanges: 'Save Changes',
      order: 'Order',
      confirmation: 'Confirmation',
      studentName: 'Student Name',
      classDate: 'Class Date',
      city: 'City',
      createdDate: 'Created Date',
      createdBy: 'Created By',
      orderTotal: 'Order Total',
      balance: 'Balance',
      noOrderText: 'You currently do not have any orders.',
      notAllowEditAndDelete: 'Packages from this order have been assigned prior to payment. You cannot delete or edit this order.',
      buyProducts: 'Buy Products',
      check: 'Check',
      checkNumber: 'Check number',
      orderNotPaidYet: 'This order is not paid. Packages have been released for assignment.',
      dateOfRefund: 'Date of Refund',
      totalRefunded: 'Total Refunded',
      refundIssued: 'Refund Issued',
      refund: 'Refund',
      checkedTotal: '{checkedTotal} Items',
      selectedForRefund: 'Selected for Refund',
      enterRefundAmount: 'Enter Refund Amount',
      enterAmount: 'Enter Amount',
      issueRefund: 'Issue Refund',
      packageColumnName: 'Package',
      assignedToColumnName: 'Assigned to',
      refundSuccess: 'Success!',
      refundSuccessDescription: 'You have successfully refunded the following items',
      products: 'Products',
      unassigned: 'Unassigned',
      remove: 'Remove',
      apply: 'Apply',
      discountCode: 'Discount Code',
      discountTotal: 'Discount Total',
      cannotViewInvoice: 'An invoice/receipt can’t be generated for this order. Please contact us at 800-676-3121 to request a copy of the document, or send an email info&#64;premierfoodsafety.com',
      deleteOrderConfirmation: 'Are you sure to delete this order?',
      selectedForPay: '{count} orders selected',
      paySelected: 'Pay Selected',
      clear: 'Clear',
      payPalTransactionId: 'PayPal Transaction ID',
      payPalCancelConfirmMessage: 'If you close the PayPal payment window, you will be logged into the system and can complete the payment later.',
      payPalSuccessButPaymentCouldNotBeCompleted: 'The PayPal payment was successful, but there was a minor issue with the payment flow. If the order has not been marked as paid or anything unusual occurs, please contact support at 800-676-3121.',
      applePaySuccessButPaymentCouldNotBeCompleted: 'The Apple Pay payment was successful, but there was a minor issue with the payment flow. If the order has not been marked as paid or anything unusual occurs, please contact support at 800-676-3121.',
      enterCheckNumber: 'Enter Check Number',
      refundMethod: 'Refund Method',
      refundByCard: 'Refund by Card',
      refundByCheck: 'Refund by Check',
      refundByPayPal: 'Refund by PayPal',
      generateInvoice: 'Generate Invoice',
    },
    purchasePackages: {
      purchasePackages: 'Purchase packages',
      total: 'Total',
      promoCode: 'Promo Code',
      enterPromoCode: 'Enter Promo Code',
      applyCode: 'Apply Code',
      discountAppliedTo: 'Discount Applied to',
      code: 'Code',
      addAdditionalPackage: 'Add Additional Packages',
      checkout: 'Checkout',
      cannotApplyMultipleCodeMessage: 'You cannot apply multiple codes for 1 package.',
      codeIsAppliedMessage: 'Code {code} has already been applied.',
      removeDiscountCode: 'Remove discount code',
      allergenCta: 'Add Food Allergen Awareness Training',
    },
    unassignedCodes: {
      selectCodes: 'Select Codes',
      title: 'Unassigned Codes 4',
      assignCodeButton: 'Assign Code(s)',
      buyCodeButton: 'Buy Code(s)',
    },
    unassignedCourses: {
      title: 'Unassigned Courses',
      buyLicense: 'Buy License(s)',
      assignCourses: 'Assign Courses(s)',
      assignCourse: 'Assign Course',
    },
    unassignedLearnersTable: {
      deleteButton: 'Delete',
      addNewLearner: 'Add Learner',
      markAsActive: 'Mark Learner as Active',
      markAsInactive: 'Mark Learner as Inactive',
      markAsActiveInactive: 'Mark Learner as Active/Inactive',
      changeStatusGuidance: 'Select learners with the same status to update their status.',

      confirmMarkingInactive: 'Are you sure you want to mark learner(s) as inactive?',
      contentMarkingInactive: 'This will cancel the learner(s) account and also permanently remove all assigned training courses. <br/> To avoid losing any unused training packages, please transfer them to a new learner before proceeding.',
    },
    unassignedSeats: {
      title: 'Unassigned Seats',
      buySeats: 'Buy Seat(s)',
      assignSeats: 'Assign Seat(s)',
    },
    unassignedSections: {
      selectLearners: 'Select Learners',
      addNewLearner: 'Add Learner',
    },
    addNewLearnerDialog: {
      addNewLearner: 'Add Learner',
      firstName: 'First name',
      lastName: 'Last name',
      dob: 'Date Of Birth',
      emailAddress: 'Email address',
      jobTitle: 'Job title',
    },
    learnersTable: {
      bulkImport: 'Bulk Import',
      importLearnersInstructionDownloadTemplate: 'Add students in bulk by uploading a completed CSV Learners List template.',
      importLearnersInstructionUpload: 'Add your learners\' information to the template. Once done, you can upload your file here.',
      uploadLearnerList: 'Upload Learner List ',
      downloadSample: 'Download Template',
    },
    ancillary: {
      needHelp: 'Need Help',
      contactUs: 'Contact Us',
      text1: 'We are available to answer questions that are specifically related to the elearning training and course material',
      text2: 'If you have specific questions in regards to your business, please contact your local health department',
      callHelpDesk: 'Call Help Desk',
    },
    appFooter: {
      copyright: `©Copyright 2000-${currentYear} Premier Food Safety. All rights reserved.`,
    },
    coursePlayer: {
      select: 'Select',
      courseProgress: 'Course Progress',
      frameNotSupported: 'Your browser does not support frames.',
      certificateDialogTitle: '通知',
      certificateDialogMessage: '恭喜！您的证书已通过电子邮件发送给您.',
      certificateDialogButtonText: 'OK',
    },
    courseProgress: {
      purchased: 'Purchased',
      buyLaminatedCard: 'Buy Laminated Card',
      expires: 'Expires',
      transfer: 'Transfer',
      download: 'Download',
      start: 'Start',
      continue: 'Continue',
      review: 'Review',
    },
    courses: {
      myCourses: 'My Courses',
      doNotHaveCoursesAndAssign: 'You currently do not have any courses assigned to you. Click above to assign.',
      doNotHaveCourses: 'You currently do not have any courses',
      noCompletedCourses: 'You currently do not have any completed courses.',
      instruction: 'Select a course to see the details.',
    },
    documentGenerationDialog: {
      header: 'Documents appear here',
      note1: 'Please regenerate the document before sending',
      note2: 'This might be blank when this screen loads for the first time',
      generateDocument: 'Generate Document',
    },
    headerActions: {
      myPortal: 'My Portal',
      publicSite: 'Shop PFS',
      faq: 'FAQ',
      contactUs: 'Contact Us',
      myAccount: 'My Account',
      logout: 'Logout',
      learners: 'Learners',
      orders: 'Orders',
    },
    fmSurvey: {
      title: 'Get a $20 Amazon e-Gift Card',
      description: 'Complete our Food Manager survey and we will email you a $20 Amazon e-Gift Card within 1 week of completing it.',
      duration: 'Takes about 15 minutes',
      eligibilityLead: 'Eligibility: Only for those with',
      eligibilityYears: '3+ years',
      eligibilityTail: 'of experience working as a Food Manager',
      limit: 'Limit one survey per student.',
      takeSurvey: 'Take the Survey',
      giftIconAlt: 'Gift icon',
      clockIconAlt: 'Clock icon',
    },
    dashboardAnnouncement: {
      dismiss: 'Dismiss announcement',
    },
    logo: {
      title: 'Premier Food Safety',
    },
    profile: {
      registered: 'Registered',
      by: 'By',
      userId: 'User ID',
      editProfile: 'Edit profile',
    },
    stats: {
      assignSeats: 'Assign Seats',
      assigned: 'Assigned',
      classRegistrations: 'In-Person Food Manager',
      proctorURegistrations: 'Online Food Manager',
      elearningLicense: 'eLearning Licenses',
      assignLicense: 'Assign License',
      assignCode: 'Assign Code',
      unassigned: 'Available',
      purchased: 'Purchased',
      yourPurchases: 'Purchases',
      noPurchases: 'You don\'t have any seats yet. Seats show up here once an order is paid.',
    },
    userInfo: {
      welcome: 'Welcome back',
    },
    faqs: {
      common: {
        title: 'FAQs',
        1: 'The screen is frozen. I can\'t click the next button or do anything.',
        2: 'Log out and log back in',
        3: 'Restart your computer',
        4: 'Safari browser is currently not supported. Please make sure to view the course using',
        5: 'They are recommended for the best training experience',
        6: 'Clear your cache. This is important if you are using a shared computer where someone may have previously taken the same course',
        7: 'Use a different computer',
        8: 'I can\'t get to the next slide.',
        9: 'Click the \'Next\' or \'Play\' button to move forward',
        10: 'Make sure you are using',
        11: 'or',
        12: 'as your browser.',
        13: 'I finished the training but I can\'t print the certificate.',
        14: `To print the certificate you must achieve the passing score as stated in the Final Quiz.
          If you have not achieved this, you will not be able to print your certificate.
          You are able to view your score(s) in 'My Course Progress'
          and you are also able to re-take the quiz until you pass.`,
        15: 'I printed the certificate and it has another person\'s name.',
        16: `Verify that you are using your own login information by going to 'Course Progress'
          and verifying that your name appears on the top left corner`,
        17: 'If you registered under a different name, we will not be able to make any changes after the certificate has been issued',
        18: 'The screen is frozen or it is loading slowly.',
      },
      general: {
        title: 'General FAQs',
        createAccount: 'How to create an Account',
        login: 'How to Log in to an Existing Account',
        assignOnlineCourses: 'How to Assign Online Courses to Yourself',
        selfRegister: 'How to Self-Register for an In-Person Class',
        updateUserInfo: 'How to Update Your User Info',
        accessOnlineGuide: 'How to Access the Online Study Guide',
        resetPassword: 'How to Reset Your Password',
      },
      individualTutorial: {
        title: 'Tutorials for Individual Users',
        studentPortalFeature: 'Complete Guide to Student Portal Features',
        startOnlineCourse: 'How to Start Your Online Training Course',
        accessClassInformation: 'How to Access In-Person Class Information',
        findExamCode: 'How to Find your ProctorU Exam Code',
      },
      groupAdminTutorial: {
        title: 'Tutorials for Group Admins',
        completeGuide: 'Complete Guide to Group Admin Portal Features',
        addNewLearner: 'How to Add a New Learner',
        addGroupLearners: 'How to Add a Group of Learners in Bulk',
        removeLearner: 'How to Remove a Learner',
        markLearnerInactive: 'How to Mark Learners as Inactive',
        assignPackage: 'How to Assign In-Person and Online Training Packages to Yourself and Others',
        emailLearnersGroup: 'How to Email a Group of Learners Enrolled in an Online Course',
        resendExam: 'How to Resend a ProctorU Exam and Instructions to a Learner',
        accessDownLoadCards: 'How to Access and Download Cards and/or Certificates for Learners taking an Online Course',
        transferUnusedCourse: 'How to Transfer an Unused Online Course to a New Learner',
        generateLeanerReports: 'How to Generate Learner Reports',
        updateLearnerEmail: 'How to Update a Learner’s Email Address',
        resendPassword: 'How to Resend Password to a Learner',
        updatePassword: 'How to Update Your Admin Password',
        addSavePayment: 'How to Add and Save Payment Methods to your Account',
        shopMainSite: 'How to Shop the Main PFS Site',
        purchaseTrainingPackage: 'How to Purchase Training Packages from the Group Admin Dashboard',
      },
    },
    myAccount: {
      title: 'My Account',
      resetPassword: 'Reset password',
      deactivate: 'Deactivate account',
      activate: 'Activate account',
      saveChanges: 'Save Changes',
      changeUsername: 'Change username',
      resetPasswordSuccessfully: 'Reset password successfully.',
      changeUsernameSuccessfully: 'Change username successfully.',
      deactivateAccountConfirmation: 'Are you sure you want to deactivate your account?',
      reminderSettings: 'Reminder Settings',
      certificateRenewalReminder: 'Certificate renewal reminder',
      certificateRenewalReminderNote: 'Receive an email reminder as your certificate expiration date approaches.',
      inPersonClassReminder: 'In-Person Food Manager class reminder',
      inPersonClassReminderNote: 'Receive an email reminder about upcoming In-Person Food Manager certification classes',
      smsCertificateRenewalReminder: 'SMS certificate renewal reminder',
      smsCertificateRenewalReminderNote: 'Receive a text message reminder as your certificate expiration date approaches.',
      saveReminderSettings: 'Save Reminder Settings',
    },
    contactUs: {
      name: 'Name',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      subject: 'Subject',
      comment: 'Comment',
      submit: 'Submit',
      submitting: 'Submitting...',
    },
    eLearning: {
      emailLearners: 'Email Learners',
      hideStudent: 'Hide Student',
      unhideStudent: 'Unhide Student',
      noAssignedCourses: 'You currently do not have any registrations.',
      buyLicenses: 'Buy Licenses',
      restartTraining: 'Restart Training',
      newELearningLicenses: 'New e-Learning Licenses',
      orderLaminatedCard: 'Order Laminated Card',
      congratulateOnExam: 'Congratulations on passing your exam',
      style: 'Style',
      buyACreditCard: 'Buy a Credit Card',
      preBoughtCreditCard: 'You pre-bought a Credit Card',
      laminatedCardDescription1: 'Food Handler Card for',
      laminatedCardDescription2: 'You\'ll receive it within 7-10 business days.',
      buyNow: 'Buy Now',
      purchaseSuccess: 'Thank you for your purchase',
      purchaseLaminatedCardSuccessInfo: 'Your order is being processed. Please allow 7-10 business days to receive your card in the mail.',
      mailingNote: 'Enter the',
      mailingAddress: 'Mailing Address',
      mailingNote2: 'you want the card sent to.',
      laminatedCardNameNote: 'The following name will appear on your card. If the name is spelled incorrectly, please call us at 800-676-3121',
    },
    noteDrawer: {
      notes: 'Notes',
      addNote: 'Add Note',
      system: 'PFS System',
    },
    dashboard: {
      adminViewTitle: 'PFS Admin View',
      adminViewSubtitle: 'Home - User information',
      editUserInfo: 'edit-user-info-element',
      noGroupAdminWarning: 'Please select 1 Group Admin.',
      invalidUser: 'User ID is invalid. Please check it again.',
      unpaidOrders: {
        title: 'Unpaid Orders',
        description: 'These orders are awaiting payment. Seats become available once payment is received.',
        orderNumber: 'Order #',
        createdDate: 'Created Date',
        total: 'Total',
        balance: 'Balance Due',
        quickActions: 'Quick Actions',
        viewAllOrders: 'View all orders',
        latestNote: 'Showing the {count} most recent unpaid orders.',
      },
    },
    classRegistrations: {
      instructor: 'Instructor',
      onlyAllow1Class: 'Please choose only 1 class',
      notAllowOrderPrintedCopy: 'A printed copy is only available once students have taken and passed the ServSafe exam. This registration does not yet meet that criteria.',
      classMaterialsAndDocs: 'Class Materials & Docs',
      forUser: 'for user',
      selectClassForRetest: 'Select Class for Retest',
      selectClassForReschedule: 'Select Class for Reschedule',
      notAllowReschedule: 'This registration seems too late to be RESCHEDULED. Only allowing the following status to be rescheduled: Approved, No-Show.',
      notAllowRetest: 'Only following registration statuses accepted for retest: Attended, Completed-Fail.',
      notAllowDownloadCertificate: 'Only the following registration statuses accepted for downloading certificate: Completed-Pass.',
      certificateInProgress: 'Certificate is still in progress, please wait a little while.',
      studentPortal: 'Student Portal',
      yes: 'Y',
      no: 'N',
      generalSettings: 'General Settings',
      actions: 'Actions',
      documents: 'Documents',
      reschedule: 'Reschedule',
      transfer: 'Transfer',
      retest: 'Retest',
      cancel: 'Cancel',
      emailCertificate: 'Email Certificate',
      setFlag: 'Set Flag',
      unsetFlag: 'Unset Flag',
      discount: 'Discount',
      classCancelled: 'Class Cancelled',
      package: 'Package',
      // Columns name here.
      confirmation: 'Conf',
      order: 'Order',
      regBy: 'Reg. by',
      coName: 'Co. Name',
      regDate: 'Reg. Date',
      classDate: 'Class Date',
      classLocation: 'Class Location',
      compStatus: 'Comp. Status',
      paid: 'Paid',
      attendStatus: 'Status',
      balance: 'Balance',
    },
    restartTraining: {
      confirmationText: 'Are you sure you want to restart training?',
      title: 'Restart Training',
    },
    registration: {
      descriptionForOrderFromApex: 'This registration is from APEX, please click confirm button to process to APEX site.',
    },
    paymentInformation: {
      text: 'Payment Information',
      useNewCreditCard: 'Use New Credit Card',
      removeSelectedCard: 'Remove Selected Card',
      pleaseChooseCard: 'Please select a card.',
      proceedToPayPal: 'Proceed to PayPal',
      proceedToPayPalNote: '* You will complete your payment in PayPal (a new window or a redirect may open depending on your browser).',
    },
    paymentOptions: {
      payByCreditCard: 'Pay by Credit Card',
      payByCheck: 'Pay by Check',
      payByApplePay: 'Apple Pay',
      payByPayPal: 'Pay by PayPal',
    },
    paymentInformationForm: {
      addAndChargeCreditCard: 'Add & Charge Credit Card',
      addCreditCard: 'Add Credit Card',
      type: 'Type',
      typePlaceholder: 'Credit Card',
      nameOnCard: 'Name on Card',
      enterPlaceholder: 'Enter',
      creditCardNumber: 'Credit Card Number',
      expiration: 'Expiration',
      monthPlaceholder: 'Month',
      yearPlaceholder: 'Year',
      billingAddress: 'Billing Address',
      billingZip: 'Billing Zip',
      CC2Sev: 'CVV/CVC',
      saveForFutureUse: 'Save for future use',
    },
    creditCard: {
      readableVisa: 'Visa Credit Card',
      readableMasterCard: 'Master Card',
      readableAmEx: 'American Express Card',
      readableDiscover: 'Discover Card',
      endingIn: 'ending in',
      unknown: 'Unknown',
    },
    paymentStatus: {
      paid: 'Paid',
      unpaid: 'Unpaid',
    },
    userTypeReadable: {
      client: 'Client',
      instructor: 'Instructor',
      staff: 'Staff',
      manager: 'Manager',
      admin: 'Admin',
      elearningManager: 'ELearning Manager',
      elearningStudent: 'ELearning Student',
      student: 'Student',
    },
    readableMyAccountTabs: {
      myPortal: 'My Portal',
      accountSettings: 'Account Settings',
      userInformation: 'User Information',
      paymentInformation: 'Payment Information',
      proceedToPayPal: 'Proceed to PayPal',
      proceedToPayPalNote: '* You will complete your payment in PayPal (a new window or a redirect may open depending on your browser).',
    },
    notificationMessage: {
      default: 'Something went wrong!',
      commonSuccess: 'Success',
    },
    ordersService: {
      addOrChangeCreditCard: 'Add/Charge Credit card',
      addPayment: 'Add Payment',
      payNow: 'Pay Now',
    },
    cancelRegistrationDialog: {
      title: 'Cancel Registration',
      formTitle: '**** {days} days past class date ****',
      transactions: 'Transactions:',
      transactionsDescription: 'No payments found for this registration.',
      totalPaid: 'Total Paid:',
      proceedWithCancelation: 'Proceed with cancelation',
      refundRequested: 'Refund Requested',
      reason: 'Reason',
      type: 'Type',
      name: 'Name',
      amount: 'Amount',
      approve: 'Approve',
    },
    returnLicenseDialog: {
      return: 'Return',
      title: 'Return License',
      content: 'Return the {course} license assigned to {learner} back to available licenses? This cancels the assignment and the license can then be assigned to anyone in the group.',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    },
    transferCourseDialog: {
      title: 'Transfer Course',
      assign: 'Assign',
      transfer: 'Transfer',
    },
    transferClassRegistrationDialog: {
      title: 'Transfer Class',
      assign: 'Assign',
      note: 'Note',
    },
    generalSetting: {
      updateGeneralSettings: 'Update General Settings',
    },
    packageBenefits: {
      freeFoodHandlerCard: 'Free Food Handler Card',
      freeFoodHandlerCardTooltip: 'Transferable to employee',
      limitedTimeOffer: 'Limited-Time Offer',
    },
    checkout: {
      orderSummary: 'Order Summary',
      apply: 'Apply',
      total: 'Total',
      continueToCheckout: 'Continue to Checkout',
      removePackage: 'Remove Package',
      removePackageDialogContent: 'Are you sure you want to remove this package and all related discounts?',
      foodHandlerCardIncludedTitle: 'Food Handler Card Included',
      foodHandlerCardIncludedContent: 'A Food Handler Card is already included in your package. Do you still want to purchase the add-on?',
      freeFoodHandlerCardNote: 'Free with your Premium package. Transferable to employee.',
      confirm: 'Yes',
      cancel: 'No',
      removeDiscount: 'Remove Discount',
      removeDiscountDialogContent: 'Are you sure you want to remove this discount?',
      licenses: 'Licenses',
      includes: 'Includes',
      discountAppliedTo: 'Discount applied to',
      code: 'Code',
      purchase: 'Purchase',
      selectPackageForInformation: 'Please select package for more information',
      buyPackages: 'Buy Packages',
      startShopping: 'Start shopping',
      currentCartEmpty: 'Your shopping cart is currently empty',
    },
    reviewCart: {
      reviewYourCart: 'Review your cart',
    },
    createPaymentInformation: {
      unsupportedCardType: 'We support Visa, Amex, MasterCard only.',
    },
    userStatus: {
      active: 'Active',
      inactive: 'Inactive',
      activeInactive: 'Active/Inactive',
      all: 'All',
    },
    search: 'Search',
    searchExtendedCourses: 'Search by User ID, Order Id or Confirmation #',
    documentGenerationForm: {
      type: 'Type',
      to: 'To',
      from: 'From',
      cc: 'CC',
      additionalDocumentToAttach: 'Additional Document to Attach',
      addRegistrationNote: 'Add Registration Note (Optional)',
    },
    licenseStatus: {
      approved: 'Approved',
      attended: 'Attended',
      noShow: 'No-Show',
      completedPass: 'Completed-Pass',
      completedFail: 'Completed-Fail',
      cancelled: 'Cancelled',
      retestScheduled: 'Retest scheduled',
      chargeback: 'Chargeback',

      // Additional license status for online course.
      new: 'New',
      allocated: 'Allocated',
    },
    table: {
      viewing: 'Viewing',
      total: 'Total',
      noDataText: 'No data available',
      viewInfo: 'View Info',
    },
    time: {
      hours: 'hours',
      minutes: 'minutes',
      hour: 'hour',
      minute: 'minute',
    },
    packageType: {
      elearning: 'Online Courses',
      inPerson: 'In-Person Food Manager',
      proctoru: 'Online Food Manager',
    },
    languages: {
      english: 'English',
      spanish: 'Spanish',
      chinese: 'Chinese',
      korean: 'Korean',
    },
    transferPackage: {
      information: 'This list only shows eligible learners. Learners who have been assigned a package in this same category, or learners assigned an equivalent package in another category will not appear on this list.',
    },
    distances: {
      anyDistance: 'Any distance',
      miles: 'miles',
    },
    emailLearnersDialog: {
      emailLearner: 'Email Learners',
      subject: 'Subject',
      body: 'Body',
      from: 'From',
    },
    requireContactInfoDialog: {
      description: 'A mailing address and phone number are required to process the printed certificate. Please update your information in the My Account tab.',
      goToMyAccountTab: 'Go to My Account tab',
      useBillingAddress: 'Use the same as billing address',
    },
    registrationSuccessModal: {
      title: '欢迎！您的账户已准备就绪',
      subTitle: '注册完成！',
      info1: '您的用户名和密码已通过电子邮件发送',
      info2: '请保存您的登录信息：',
    },
    copied: '已复制',
    loading: '加载中...',
    folderManager: {
      title: 'SCORM Upload Manager',
      uploadingLabel: 'Uploading SCORM Package:',
      uploadingDesc: 'This process may take a few minutes depending on file size. Please do not close this window.',
      infoAlert: 'Upload SCORM packages to S3. Existing folders will be replaced.',
      labels: {
        language: 'Language',
        s3Folder: 'S3 Folder',
        scormPackage: 'SCORM Package',
        targetFolder: 'Target Folder',
        warning: 'Warning:',
        uploadSuccess: 'Upload Successful',
        uploadError: 'Upload Error',
      },
      messages: {
        confirmUploadFor: 'Do you want to upload the SCORM package for',
        folderReplacedWarning: 'This action will permanently replace all existing files in the target S3 folder. This cannot be undone.',
        uploadSuccess: 'Folder uploaded successfully to S3.',
        uploadFailed: 'Upload failed.',
        connectionError: 'Please check your connection and try again.',
      },
      buttons: {
        upload: 'Upload to S3',
        confirmUpload: 'Confirm Upload',
        cancel: 'Cancel',
        close: 'Close',
      },
    },
    externalLmsClientKeys: {
      title: 'External LMS Client Keys',
      createButton: 'Create New Client Key',
      editHeader: 'Edit New Client Key',
      clientName: 'Client Name',
      clientKey: 'Client Key',
      active: 'Active',
      action: 'Action',
      createdDate: 'Created Date',
      courseIds: 'Course IDs',
      leaveEmptyForAll: 'Leave empty for all',
      allCourses: '(All Courses)',
      domains: 'Domains',
      clientKeyHint: 'Min 10 characters, e.g. PANDA_12345',
      messages: {
        fetchFailed: 'Failed to fetch client keys.',
        updateSuccess: 'External LMS client key updated successfully.',
        updateFailed: 'Failed to update client key.',
        createSuccess: 'External LMS client key created successfully.',
        createFailed: 'Failed to create client key.',
        nameRequired: 'Client name is required.',
        keyRequired: 'Client key is required.',
        keyMinLength: 'Client key must be at least 10 characters.',
        domainsRequired: 'At least one domain is required.',
        invalidDomain: 'Invalid domain format (e.g. example.com).',
        clientKeyAlreadyExists: 'This client key already exists.',
      },
    },
    dashboardAnnouncementAdmin: {
      title: 'Title',
      message: 'Message',
      plainTextHint: 'Plain text only. Line breaks are kept.',
      startTime: 'Start time',
      endTime: 'End time',
      enabled: 'Enabled',
      dateTimePlaceholder: 'mm/dd/yyyy hh:mm AM',
      createdBy: 'Created by {name} on {date}',
      updatedBy: 'Last updated by {name} on {date}',
      unknownUser: 'User #{id}',
      messages: {
        required: 'This field is required.',
        invalidDateTime: 'Enter a date and time as mm/dd/yyyy hh:mm AM/PM.',
        endAfterStart: 'End time must be after Start time.',
        saveSuccess: 'Announcement saved.',
        saveFailed: 'Could not save the announcement.',
        fetchFailed: 'Could not load the announcement.',
      },
    },
    externalLmsRegistrations: {
      title: 'External LMS Registrations',
      confirmation: 'Conf #',
      occurrence: 'Occurrence',
      externalLearnerId: 'External Learner ID',
      trainingStatus: 'Training Status',
      searchPlaceholder: 'Search by Client Key, User ID, Confirmation #',
      status: {
        notStarted: 'Not Started',
        inProgress: 'In Progress',
        completedPassed: 'Completed Passed',
        completedFailed: 'Completed Failed',
      },
      completedDate: 'Completed Date',
      startDate: 'Start Date',
      endDate: 'End Date',
      exportExcel: 'Export Excel',
      exportSuccess: 'Export is ready.',
      exportFailed: 'Failed to export registrations.',
      exportStartDateRequired: 'Please select a start date.',
      exportEndDateBeforeStart: 'End date must be on or after the start date.',
    },
    handlerTopPane: {
      foodHandlersCard: 'Food Handler Card',
      startOnlineTraining: 'Start Online Training',
      groupDiscountsAvailable: 'Group Discounts Available',
      contactUs: 'Contact Us',
      features: [
        'ANAB Accredited',
        'Approved by CA Health Departments',
        'Download & Print Card Instantly',
      ],
    },
    ctaForm: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      whichCounty: 'Which county do you work in?',
      selectYourCounty: 'Select your county',
      continue: 'Continue',
      sanDiegoNotice: 'The California Food Handler Card is not valid in San Diego County. If you work in San Diego County,',
      sanBernardinoNotice: 'The California Food Handler Card is not valid in San Bernardino County. For more information,',
      riversideNotice: 'The California Food Handler Card is not valid in Riverside County. For more information,',
      clickHere: 'please click here.',
    },
    customerStats: {
      over45Years: 'Over 45 Years',
      ofExperience: 'of experience',
      over3Million: 'Over 3 Million',
      clientsTrained: 'clients trained',
      moneyGuarantee: '100% Money Back Guarantee',
    },
    customerTestimonials: {
      addToCart: 'Add to Cart',
    },
    estimateTime: {
      text: '90 mins',
      description: 'Estimated time to complete course + exam',
    },
    easyProcessVideo: {
      alt: 'How to Get Your CA Food Handler Card',
      title: 'How to Get Your CA Food Handler Card',
    },
    onlineProgram: {
      title: 'Join over 3 Million Satisfied Food Service Professionals',
      subTitle: 'Get your food handlers card with this 90-minute online certificate program',
      startedToday: 'Get started today',
    },
    aboutPfs: {
      subTitle: 'Industry Leader in Food Training',
      title: 'About Premier Food Safety',
      description: 'With over 45 years of experience, we are the leading providers of food safety training and certification solutions for the food service industry. Our accredited programs are approved by local health departments and designed to give you maximum flexibility when choosing training for yourself or your staff.',
      programs: 'We offer the ServSafe Food Manager Certification nationwide, and state-specific Food Handler Card programs to help you meet regulatory requirements easily and in an affordable manner.',
    },
    howItWorks: {
      caTitle: 'How to Get Your CA Food Handler Card',
      caDescription: 'To get your card today, you only need to register, take the online course, and pass the exam. Your card will be available for you to download immediately after. Watch the video for a step-by-step guide on the process.',
      easyProcess: 'Our Easy Process',
      step1: 'Step 1',
      step2: 'Step 2',
      step3: 'Step 3',
    },
    steps: {
      step1: {
        title: 'Register & Training',
        languages: 'Languages: English, Spanish (Español), Chinese (中文), and Korean (한국어)',
        onlineCourseLength: '100% Online Course Length: 90 Minutes (Including Exam)',
        startAndStop: 'Start and Stop as Needed',
        features: 'Course features Full Text Transcript & Closed Captioning',
      },
      step2: {
        title: 'Take the Exam',
        attempts: 'Exam Attempts: Unlimited (After 2 fails, course must be watched from the beginning)',
        passingScore: 'Minimum Passing Score: 70%',
        onlineAndMobile: '100% Online and Mobile Friendly',
      },
      step3: {
        title: 'Print Card & Certificate',
        downloadAndPrint: 'Download & Print from Home',
        validFor3Years: 'Card Valid for 3 Years',
        acceptedThroughout: 'Accepted throughout California except for Riverside, San Bernardino, and San Diego Counties',
        accessFor1Year: 'Training access for 1 year',
      },
    },
    contactSection: {
      groupDiscount: 'Looking for group discounts?',
      contactUs: 'Contact us',
    },
    certifications: {
      alcohol: {
        location: 'California AB1825 and SB1343 Courses',
        title: 'Workplace California Harassment Prevention Training for Employees',
        items: [
          'Register for Online Training',
          'Complete the Course & Print Certificate of Completion',
        ],
        learnMore: 'Learn More',
      },
      foodManager: {
        location: 'California Food Manager Certification',
        title: 'ServSafe® Online Course + Online Exam',
        items: [
          'Register for ServSafe In-Person Class or Online Course',
          'Choose Paper-based or Online ServSafe Exam',
        ],
        selectPackage: 'Select a Package',
      },
    },
    resources: {
      title: 'Resources',
      items: {
        regulations: 'California Regulations',
        retailFoodCode: 'California Retail Food Code',
        practiceTest: 'Free Food Handler Practice Exam',
        aboutCard: 'About Food Handler Cards',
        handwashing: 'Handwashing Guide',
        readyToEat: 'Ready-to-Eat Food Prep Guide',
      },
    },
    faqSection: {
      title: 'Frequently Asked Questions',
      ca: {
        q1: 'What is the California Food Handler Card Law?',
        a1: 'The California Food Handlers Card Law (based on SB303) requires all food handlers, unless exempt, to get a Food Handlers Card within 30 days of date of new hire and renew every 3 years.',
        q2: 'How do I get a ',
        q2_link: 'California Food Handlers Card?',
        q2_href: '/food-handlers-card/california',
        a2_start: 'The card issued upon successful completion of an ANAB-accredited food safety program, such as ',
        a2_link: 'Premier Food Safety',
        a2_end: ', and a 40-question exam with a minimum score of 70%.',
        q3: 'Who is considered a food handler?',
        a3: 'A food handler is any individual who is involved in the preparation, storage, or service of food in a food facility.',
        q4: 'Are there any exceptions to the California Food Handlers Card Law?',
        a4_title: 'Food handlers employed at any of the following are exempt from the law:',
        a4_list: [
          'Temporary food facilities (food booths),',
          'Certified farmers’ markets,',
          'Commissaries, grocery stores (including convenience stores),',
          'Licensed health care facilities,',
          'Mobile support units,',
          'Public and private school cafeterias,',
          'Restricted food service facilities,',
          'Retail stores where a majority of sales are from a pharmacy,',
          'Venues with snack bar services in which the majority of sales are from admission tickets,',
          'Certain food facilities with approved in-house food safety training,',
          'Food facilities subject to a collective bargaining agreement,',
          'Any city, county, city and county, state or regional facility used for the confinement of adults or minors, including, but not limited to, a county jail, juvenile hall, camp, ranch, or residential facility,',
          'An elderly nutrition program, administered by the California Department of Aging, and',
          'Food handlers working in the counties of Riverside, San Bernardino and San Diego and food handlers holding a valid Manager’s Food Safety Certificate.',
        ],
        q5: 'I work as a volunteer at a soup kitchen, food bank or a volunteer run restaurant. Do I require a Food Handlers Card?',
        a5: 'No, volunteers are exempt. The law only applies to employees who have been hired by food service establishments.',
        q6: 'Are grocery store employees required to get a Food Handlers Card?',
        a6: 'No, grocery stores are exempt from the ',
        a6_link: 'California Food Handlers Card law.',
        a6_href: '/food-handlers-card/california',
        q7: 'I work at a demonstration booth serving food samples at a grocery store. Am I required to get a California Food Handlers Card?',
        a7: 'No. Grocery store employees are exempt and demonstration companies are not permitted as food facilities.',
        q8: 'I currently hold a valid Manager’s Food Safety Certification. Do I need a California Food Handlers Card?',
        a8: 'No. The Food Manager Certification is a higher, more comprehensive certificate training that meets and exceeds the Food Handlers Card law requirements; therefore you are not required to obtain the Food Handlers Card.',
        q9: 'I am a part-time or temporary employee. Am I required to get a Food Handlers Card?',
        a9: 'Yes, all food handlers, regardless of how many hours they work, are required to obtain a Food Handlers Card, unless exempt.',
        q10: 'When will I get my Food Handlers Card?',
        a10: 'You will be able to download and print your Food Handlers Card as soon as you finish the online training and pass the final test.',
        q11: 'Do I have to complete the training all at once?',
        a11: 'No, you may complete the training in multiple sessions. Every time you log out of your account, your progress is saved, allowing you to resume the training later from the same section where you left off.',
        q12: 'What if I don’t have a printer at home to print my Food Handlers Card?',
        a12: 'If you don’t have access to a computer with a printer, you can still take the training online and, once you have passed the test, we can mail a printed copy of your California Food Handlers Card for an additional fee of $9.99.',
        q13: 'Is my employer responsible for paying for my training and Food Handlers Card?',
        a13: 'Yes. Effective January 1st, 2024, California Employers will be required to cover the cost of the food handler card training for all employees. For more information about the SB476 Law, please ',
        a13_link: 'click here',
        a13_href: '/food-handlers-card/california/sb476-law',
        q14: 'When will my food handlers card expire?',
        a14: 'The food handler card is valid for 3 years before you need to renew.',
        q15: 'Is my card valid anywhere in California?',
        a15_start: 'Your ',
        a15: ' is valid to work in any food service establishment in California, with the exception of those located in San Bernardino, Riverside and San Diego counties. These counties issue their own Food Handlers Cards.',
        a15_link: 'California Food Handlers Card',
        a15_href: '/food-handlers-card/california',
        q16: 'I need to get my Food Handlers Card but I do not have a computer, tablet or smartphone, what can I do?',
        a16_title: 'If you don’t have access to a computer or mobile device, here are a few suggestions:',
        a16_list: [
          'Go to your local library – computers are available for use to the public',
          'Ask a friend if you could borrow their computer for a few hours',
          'Talk to your supervisor about using a computer at work',
        ],
        q17: 'I work for multiple establishments. Do I need a Food Handlers Card for every single one of them?',
        a17: 'Generally, no. Your food handler card will be issued under your name and valid for 3 years, even if you start working for a different employer or work for two or more restaurants. However, if any of the establishments you work for is located in San Bernardino, San Diego or Riverside County, you will need to obtain a Food Handlers Card to work there. These counties issue their own food handler card.',
        q18: 'I currently work at a restaurant located in San Diego and hold a specific ',
        q18_link1: 'San Diego Food Handlers Card',
        q18_href1: '/food-handlers-card/san-diego-county',
        q18_mid: '. Am I required by law to get a ',
        q18_link2: 'California Food Handlers Card',
        q18_href2: '/food-handlers-card/california',
        q18_end: ' also?',
        a18: 'Yes, if you work for a restaurant outside San Diego County, such as Orange County, you need to get a California Food Handlers Card. This same rule applies if you are currently working for a restaurant in San Bernardino or Riverside County.',
        q19: 'What documentation are employers required to keep?',
        a19: 'Employers are responsible for maintaining accurate records that all food handlers employed by the establishment hold a valid California Food Handlers Card. An example of proper documentation would be to keep a copy of each food handler’s card on file, so it is available upon request to the next health inspector.',
        q20: 'If you have a group of 100 or more employees who need to be trained, please call us to receive a special group discount.',
        a20: 'For more information, call ',
        a20_phone: '800-676-3121',
        a20_phone_href: 'tel:+18006763121',
        a20_mid: ' or ',
        a20_link: 'request a quote',
        a20_href: '/food-handlers-card/california',
      },
    },
    handlerTopPane: {
      foodHandlersCard: 'Food Handler Card',
      startOnlineTraining: 'Start Online Training',
      groupDiscountsAvailable: 'Group Discounts Available',
      contactUs: 'Contact Us',
      features: [
        'ANAB Accredited',
        'Approved by CA Health Departments',
        'Download & Print Card Instantly',
      ],
    },
    ctaForm: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      whichCounty: 'Which county do you work in?',
      selectYourCounty: 'Select your county',
      continue: 'Continue',
      sanDiegoNotice: 'The California Food Handler Card is not valid in San Diego County. If you work in San Diego County,',
      sanBernardinoNotice: 'The California Food Handler Card is not valid in San Bernardino County. For more information,',
      riversideNotice: 'The California Food Handler Card is not valid in Riverside County. For more information,',
      clickHere: 'please click here.',
    },
    customerStats: {
      over45Years: 'Over 45 Years',
      ofExperience: 'of experience',
      over3Million: 'Over 3 Million',
      clientsTrained: 'clients trained',
      moneyGuarantee: '100% Money Back Guarantee',
    },
    customerTestimonials: {
      addToCart: 'Add to Cart',
    },
    estimateTime: {
      text: '90 mins',
      description: 'Estimated time to complete course + exam',
    },
    easyProcessVideo: {
      alt: 'How to Get Your CA Food Handler Card',
      title: 'How to Get Your CA Food Handler Card',
    },
    onlineProgram: {
      title: 'Join over 3 Million Satisfied Food Service Professionals',
      subTitle: 'Get your food handlers card with this 90-minute online certificate program',
      startedToday: 'Get started today',
    },
    aboutPfs: {
      subTitle: 'Industry Leader in Food Training',
      title: 'About Premier Food Safety',
      description: 'With over 45 years of experience, we are the leading providers of food safety training and certification solutions for the food service industry. Our accredited programs are approved by local health departments and designed to give you maximum flexibility when choosing training for yourself or your staff.',
      programs: 'We offer the ServSafe Food Manager Certification nationwide, and state-specific Food Handler Card programs to help you meet regulatory requirements easily and in an affordable manner.',
    },
    howItWorks: {
      caTitle: 'How to Get Your CA Food Handler Card',
      caDescription: 'To get your card today, you only need to register, take the online course, and pass the exam. Your card will be available for you to download immediately after. Watch the video for a step-by-step guide on the process.',
      easyProcess: 'Our Easy Process',
      step1: 'Step 1',
      step2: 'Step 2',
      step3: 'Step 3',
    },
    steps: {
      step1: {
        title: 'Register & Training',
        languages: 'Languages: English, Spanish (Español), Chinese (中文), and Korean (한국어)',
        onlineCourseLength: '100% Online Course Length: 90 Minutes (Including Exam)',
        startAndStop: 'Start and Stop as Needed',
        features: 'Course features Full Text Transcript & Closed Captioning',
      },
      step2: {
        title: 'Take the Exam',
        attempts: 'Exam Attempts: Unlimited (After 2 fails, course must be watched from the beginning)',
        passingScore: 'Minimum Passing Score: 70%',
        onlineAndMobile: '100% Online and Mobile Friendly',
      },
      step3: {
        title: 'Print Card & Certificate',
        downloadAndPrint: 'Download & Print from Home',
        validFor3Years: 'Card Valid for 3 Years',
        acceptedThroughout: 'Accepted throughout California except for Riverside, San Bernardino, and San Diego Counties',
        accessFor1Year: 'Training access for 1 year',
      },
    },
    contactSection: {
      groupDiscount: 'Looking for group discounts?',
      contactUs: 'Contact us',
    },
    certifications: {
      alcohol: {
        location: 'California AB1825 and SB1343 Courses',
        title: 'Workplace California Harassment Prevention Training for Employees',
        items: [
          'Register for Online Training',
          'Complete the Course & Print Certificate of Completion',
        ],
        learnMore: 'Learn More',
      },
      foodManager: {
        location: 'California Food Manager Certification',
        title: 'ServSafe® Online Course + Online Exam',
        items: [
          'Register for ServSafe In-Person Class or Online Course',
          'Choose Paper-based or Online ServSafe Exam',
        ],
        selectPackage: 'Select a Package',
      },
    },
    resources: {
      title: 'Resources',
      items: {
        regulations: 'California Regulations',
        retailFoodCode: 'California Retail Food Code',
        practiceTest: 'Free Food Handler Practice Exam',
        aboutCard: 'About Food Handler Cards',
        handwashing: 'Handwashing Guide',
        readyToEat: 'Ready-to-Eat Food Prep Guide',
      },
    },
    faqSection: {
      title: 'Frequently Asked Questions',
      ca: {
        q1: 'What is the California Food Handler Card Law?',
        a1: 'The California Food Handlers Card Law (based on SB303) requires all food handlers, unless exempt, to get a Food Handlers Card within 30 days of date of new hire and renew every 3 years.',
        q2: 'How do I get a ',
        q2_link: 'California Food Handlers Card?',
        q2_href: '/food-handlers-card/california',
        a2_start: 'The card issued upon successful completion of an ANAB-accredited food safety program, such as ',
        a2_link: 'Premier Food Safety',
        a2_end: ', and a 40-question exam with a minimum score of 70%.',
        q3: 'Who is considered a food handler?',
        a3: 'A food handler is any individual who is involved in the preparation, storage, or service of food in a food facility.',
        q4: 'Are there any exceptions to the California Food Handlers Card Law?',
        a4_title: 'Food handlers employed at any of the following are exempt from the law:',
        a4_list: [
          'Temporary food facilities (food booths),',
          'Certified farmers’ markets,',
          'Commissaries, grocery stores (including convenience stores),',
          'Licensed health care facilities,',
          'Mobile support units,',
          'Public and private school cafeterias,',
          'Restricted food service facilities,',
          'Retail stores where a majority of sales are from a pharmacy,',
          'Venues with snack bar services in which the majority of sales are from admission tickets,',
          'Certain food facilities with approved in-house food safety training,',
          'Food facilities subject to a collective bargaining agreement,',
          'Any city, county, city and county, state or regional facility used for the confinement of adults or minors, including, but not limited to, a county jail, juvenile hall, camp, ranch, or residential facility,',
          'An elderly nutrition program, administered by the California Department of Aging, and',
          'Food handlers working in the counties of Riverside, San Bernardino and San Diego and food handlers holding a valid Manager’s Food Safety Certificate.',
        ],
        q5: 'I work as a volunteer at a soup kitchen, food bank or a volunteer run restaurant. Do I require a Food Handlers Card?',
        a5: 'No, volunteers are exempt. The law only applies to employees who have been hired by food service establishments.',
        q6: 'Are grocery store employees required to get a Food Handlers Card?',
        a6: 'No, grocery stores are exempt from the ',
        a6_link: 'California Food Handlers Card law.',
        a6_href: '/food-handlers-card/california',
        q7: 'I work at a demonstration booth serving food samples at a grocery store. Am I required to get a California Food Handlers Card?',
        a7: 'No. Grocery store employees are exempt and demonstration companies are not permitted as food facilities.',
        q8: 'I currently hold a valid Manager’s Food Safety Certification. Do I need a California Food Handlers Card?',
        a8: 'No. The Food Manager Certification is a higher, more comprehensive certificate training that meets and exceeds the Food Handlers Card law requirements; therefore you are not required to obtain the Food Handlers Card.',
        q9: 'I am a part-time or temporary employee. Am I required to get a Food Handlers Card?',
        a9: 'Yes, all food handlers, regardless of how many hours they work, are required to obtain a Food Handlers Card, unless exempt.',
        q10: 'When will I get my Food Handlers Card?',
        a10: 'You will be able to download and print your Food Handlers Card as soon as you finish the online training and pass the final test.',
        q11: 'Do I have to complete the training all at once?',
        a11: 'No, you may complete the training in multiple sessions. Every time you log out of your account, your progress is saved, allowing you to resume the training later from the same section where you left off.',
        q12: 'What if I don’t have a printer at home to print my Food Handlers Card?',
        a12: 'If you don’t have access to a computer with a printer, you can still take the training online and, once you have passed the test, we can mail a printed copy of your California Food Handlers Card for an additional fee of $9.99.',
        q13: 'Is my employer responsible for paying for my training and Food Handlers Card?',
        a13: 'Yes. Effective January 1st, 2024, California Employers will be required to cover the cost of the food handler card training for all employees. For more information about the SB476 Law, please ',
        a13_link: 'click here',
        a13_href: '/food-handlers-card/california/sb476-law',
        q14: 'When will my food handlers card expire?',
        a14: 'The food handler card is valid for 3 years before you need to renew.',
        q15: 'Is my card valid anywhere in California?',
        a15_start: 'Your ',
        a15: ' is valid to work in any food service establishment in California, with the exception of those located in San Bernardino, Riverside and San Diego counties. These counties issue their own Food Handlers Cards.',
        a15_link: 'California Food Handlers Card',
        a15_href: '/food-handlers-card/california',
        q16: 'I need to get my Food Handlers Card but I do not have a computer, tablet or smartphone, what can I do?',
        a16_title: 'If you don’t have access to a computer or mobile device, here are a few suggestions:',
        a16_list: [
          'Go to your local library – computers are available for use to the public',
          'Ask a friend if you could borrow their computer for a few hours',
          'Talk to your supervisor about using a computer at work',
        ],
        q17: 'I work for multiple establishments. Do I need a Food Handlers Card for every single one of them?',
        a17: 'Generally, no. Your food handler card will be issued under your name and valid for 3 years, even if you start working for a different employer or work for two or more restaurants. However, if any of the establishments you work for is located in San Bernardino, San Diego or Riverside County, you will need to obtain a Food Handlers Card to work there. These counties issue their own food handler card.',
        q18: 'I currently work at a restaurant located in San Diego and hold a specific ',
        q18_link1: 'San Diego Food Handlers Card',
        q18_href1: '/food-handlers-card/san-diego-county',
        q18_mid: '. Am I required by law to get a ',
        q18_link2: 'California Food Handlers Card',
        q18_href2: '/food-handlers-card/california',
        q18_end: ' also?',
        a18: 'Yes, if you work for a restaurant outside San Diego County, such as Orange County, you need to get a California Food Handlers Card. This same rule applies if you are currently working for a restaurant in San Bernardino or Riverside County.',
        q19: 'What documentation are employers required to keep?',
        a19: 'Employers are responsible for maintaining accurate records that all food handlers employed by the establishment hold a valid California Food Handlers Card. An example of proper documentation would be to keep a copy of each food handler’s card on file, so it is available upon request to the next health inspector.',
        q20: 'If you have a group of 100 or more employees who need to be trained, please call us to receive a special group discount.',
        a20: 'For more information, call ',
        a20_phone: '800-676-3121',
        a20_phone_href: 'tel:+18006763121',
        a20_mid: ' or ',
        a20_link: 'request a quote',
        a20_href: '/food-handlers-card/california',
      },
    },
    handlerTopPane: {
      foodHandlersCard: 'Food Handler Card',
      startOnlineTraining: 'Start Online Training',
      groupDiscountsAvailable: 'Group Discounts Available',
      contactUs: 'Contact Us',
      features: [
        'ANAB Accredited',
        'Approved by CA Health Departments',
        'Download & Print Card Instantly',
      ],
    },
    ctaForm: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      whichCounty: 'Which county do you work in?',
      selectYourCounty: 'Select your county',
      continue: 'Continue',
      sanDiegoNotice: 'The California Food Handler Card is not valid in San Diego County. If you work in San Diego County,',
      sanBernardinoNotice: 'The California Food Handler Card is not valid in San Bernardino County. For more information,',
      riversideNotice: 'The California Food Handler Card is not valid in Riverside County. For more information,',
      clickHere: 'please click here.',
    },
    customerStats: {
      over45Years: 'Over 45 Years',
      ofExperience: 'of experience',
      over3Million: 'Over 3 Million',
      clientsTrained: 'clients trained',
      moneyGuarantee: '100% Money Back Guarantee',
    },
    customerTestimonials: {
      addToCart: 'Add to Cart',
    },
    estimateTime: {
      text: '90 mins',
      description: 'Estimated time to complete course + exam',
    },
    easyProcessVideo: {
      alt: 'How to Get Your CA Food Handler Card',
      title: 'How to Get Your CA Food Handler Card',
    },
    onlineProgram: {
      title: 'Join over 3 Million Satisfied Food Service Professionals',
      subTitle: 'Get your food handlers card with this 90-minute online certificate program',
      startedToday: 'Get started today',
    },
    aboutPfs: {
      subTitle: 'Industry Leader in Food Training',
      title: 'About Premier Food Safety',
      description: 'With over 45 years of experience, we are the leading providers of food safety training and certification solutions for the food service industry. Our accredited programs are approved by local health departments and designed to give you maximum flexibility when choosing training for yourself or your staff.',
      programs: 'We offer the ServSafe Food Manager Certification nationwide, and state-specific Food Handler Card programs to help you meet regulatory requirements easily and in an affordable manner.',
    },
    howItWorks: {
      caTitle: 'How to Get Your CA Food Handler Card',
      caDescription: 'To get your card today, you only need to register, take the online course, and pass the exam. Your card will be available for you to download immediately after. Watch the video for a step-by-step guide on the process.',
      easyProcess: 'Our Easy Process',
      step1: 'Step 1',
      step2: 'Step 2',
      step3: 'Step 3',
    },
    steps: {
      step1: {
        title: 'Register & Training',
        languages: 'Languages: English, Spanish (Español), Chinese (中文), and Korean (한국어)',
        onlineCourseLength: '100% Online Course Length: 90 Minutes (Including Exam)',
        startAndStop: 'Start and Stop as Needed',
        features: 'Course features Full Text Transcript & Closed Captioning',
      },
      step2: {
        title: 'Take the Exam',
        attempts: 'Exam Attempts: Unlimited (After 2 fails, course must be watched from the beginning)',
        passingScore: 'Minimum Passing Score: 70%',
        onlineAndMobile: '100% Online and Mobile Friendly',
      },
      step3: {
        title: 'Print Card & Certificate',
        downloadAndPrint: 'Download & Print from Home',
        validFor3Years: 'Card Valid for 3 Years',
        acceptedThroughout: 'Accepted throughout California except for Riverside, San Bernardino, and San Diego Counties',
        accessFor1Year: 'Training access for 1 year',
      },
    },
    contactSection: {
      groupDiscount: 'Looking for group discounts?',
      contactUs: 'Contact us',
    },
    certifications: {
      alcohol: {
        location: 'California AB1825 and SB1343 Courses',
        title: 'Workplace California Harassment Prevention Training for Employees',
        items: [
          'Register for Online Training',
          'Complete the Course & Print Certificate of Completion',
        ],
        learnMore: 'Learn More',
      },
      foodManager: {
        location: 'California Food Manager Certification',
        title: 'ServSafe® Online Course + Online Exam',
        items: [
          'Register for ServSafe In-Person Class or Online Course',
          'Choose Paper-based or Online ServSafe Exam',
        ],
        selectPackage: 'Select a Package',
      },
    },
    resources: {
      title: 'Resources',
      items: {
        regulations: 'California Regulations',
        retailFoodCode: 'California Retail Food Code',
        practiceTest: 'Free Food Handler Practice Exam',
        aboutCard: 'About Food Handler Cards',
        handwashing: 'Handwashing Guide',
        readyToEat: 'Ready-to-Eat Food Prep Guide',
      },
    },
    faqSection: {
      title: 'Frequently Asked Questions',
      ca: {
        q1: 'What is the California Food Handler Card Law?',
        a1: 'The California Food Handlers Card Law (based on SB303) requires all food handlers, unless exempt, to get a Food Handlers Card within 30 days of date of new hire and renew every 3 years.',
        q2: 'How do I get a ',
        q2_link: 'California Food Handlers Card?',
        q2_href: '/food-handlers-card/california',
        a2_start: 'The card issued upon successful completion of an ANAB-accredited food safety program, such as ',
        a2_link: 'Premier Food Safety',
        a2_end: ', and a 40-question exam with a minimum score of 70%.',
        q3: 'Who is considered a food handler?',
        a3: 'A food handler is any individual who is involved in the preparation, storage, or service of food in a food facility.',
        q4: 'Are there any exceptions to the California Food Handlers Card Law?',
        a4_title: 'Food handlers employed at any of the following are exempt from the law:',
        a4_list: [
          'Temporary food facilities (food booths),',
          'Certified farmers’ markets,',
          'Commissaries, grocery stores (including convenience stores),',
          'Licensed health care facilities,',
          'Mobile support units,',
          'Public and private school cafeterias,',
          'Restricted food service facilities,',
          'Retail stores where a majority of sales are from a pharmacy,',
          'Venues with snack bar services in which the majority of sales are from admission tickets,',
          'Certain food facilities with approved in-house food safety training,',
          'Food facilities subject to a collective bargaining agreement,',
          'Any city, county, city and county, state or regional facility used for the confinement of adults or minors, including, but not limited to, a county jail, juvenile hall, camp, ranch, or residential facility,',
          'An elderly nutrition program, administered by the California Department of Aging, and',
          'Food handlers working in the counties of Riverside, San Bernardino and San Diego and food handlers holding a valid Manager’s Food Safety Certificate.',
        ],
        q5: 'I work as a volunteer at a soup kitchen, food bank or a volunteer run restaurant. Do I require a Food Handlers Card?',
        a5: 'No, volunteers are exempt. The law only applies to employees who have been hired by food service establishments.',
        q6: 'Are grocery store employees required to get a Food Handlers Card?',
        a6: 'No, grocery stores are exempt from the ',
        a6_link: 'California Food Handlers Card law.',
        a6_href: '/food-handlers-card/california',
        q7: 'I work at a demonstration booth serving food samples at a grocery store. Am I required to get a California Food Handlers Card?',
        a7: 'No. Grocery store employees are exempt and demonstration companies are not permitted as food facilities.',
        q8: 'I currently hold a valid Manager’s Food Safety Certification. Do I need a California Food Handlers Card?',
        a8: 'No. The Food Manager Certification is a higher, more comprehensive certificate training that meets and exceeds the Food Handlers Card law requirements; therefore you are not required to obtain the Food Handlers Card.',
        q9: 'I am a part-time or temporary employee. Am I required to get a Food Handlers Card?',
        a9: 'Yes, all food handlers, regardless of how many hours they work, are required to obtain a Food Handlers Card, unless exempt.',
        q10: 'When will I get my Food Handlers Card?',
        a10: 'You will be able to download and print your Food Handlers Card as soon as you finish the online training and pass the final test.',
        q11: 'Do I have to complete the training all at once?',
        a11: 'No, you may complete the training in multiple sessions. Every time you log out of your account, your progress is saved, allowing you to resume the training later from the same section where you left off.',
        q12: 'What if I don’t have a printer at home to print my Food Handlers Card?',
        a12: 'If you don’t have access to a computer with a printer, you can still take the training online and, once you have passed the test, we can mail a printed copy of your California Food Handlers Card for an additional fee of $9.99.',
        q13: 'Is my employer responsible for paying for my training and Food Handlers Card?',
        a13: 'Yes. Effective January 1st, 2024, California Employers will be required to cover the cost of the food handler card training for all employees. For more information about the SB476 Law, please ',
        a13_link: 'click here',
        a13_href: '/food-handlers-card/california/sb476-law',
        q14: 'When will my food handlers card expire?',
        a14: 'The food handler card is valid for 3 years before you need to renew.',
        q15: 'Is my card valid anywhere in California?',
        a15_start: 'Your ',
        a15: ' is valid to work in any food service establishment in California, with the exception of those located in San Bernardino, Riverside and San Diego counties. These counties issue their own Food Handlers Cards.',
        a15_link: 'California Food Handlers Card',
        a15_href: '/food-handlers-card/california',
        q16: 'I need to get my Food Handlers Card but I do not have a computer, tablet or smartphone, what can I do?',
        a16_title: 'If you don’t have access to a computer or mobile device, here are a few suggestions:',
        a16_list: [
          'Go to your local library – computers are available for use to the public',
          'Ask a friend if you could borrow their computer for a few hours',
          'Talk to your supervisor about using a computer at work',
        ],
        q17: 'I work for multiple establishments. Do I need a Food Handlers Card for every single one of them?',
        a17: 'Generally, no. Your food handler card will be issued under your name and valid for 3 years, even if you start working for a different employer or work for two or more restaurants. However, if any of the establishments you work for is located in San Bernardino, San Diego or Riverside County, you will need to obtain a Food Handlers Card to work there. These counties issue their own food handler card.',
        q18: 'I currently work at a restaurant located in San Diego and hold a specific ',
        q18_link1: 'San Diego Food Handlers Card',
        q18_href1: '/food-handlers-card/san-diego-county',
        q18_mid: '. Am I required by law to get a ',
        q18_link2: 'California Food Handlers Card',
        q18_href2: '/food-handlers-card/california',
        q18_end: ' also?',
        a18: 'Yes, if you work for a restaurant outside San Diego County, such as Orange County, you need to get a California Food Handlers Card. This same rule applies if you are currently working for a restaurant in San Bernardino or Riverside County.',
        q19: 'What documentation are employers required to keep?',
        a19: 'Employers are responsible for maintaining accurate records that all food handlers employed by the establishment hold a valid California Food Handlers Card. An example of proper documentation would be to keep a copy of each food handler’s card on file, so it is available upon request to the next health inspector.',
        q20: 'If you have a group of 100 or more employees who need to be trained, please call us to receive a special group discount.',
        a20: 'For more information, call ',
        a20_phone: '800-676-3121',
        a20_phone_href: 'tel:+18006763121',
        a20_mid: ' or ',
        a20_link: 'request a quote',
        a20_href: '/food-handlers-card/california',
      },
    },
  },

  // Korean
  ko: {
    confirmDialog: {
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    },
    commonConfirmDialog: {
      title: 'Confirmation',
      content: 'Do you agree to continue this action?',
      unsavedChange: 'Do you want to close the dialog?',
      confirmation: 'Confirmation',
    },
    commonDeleteDialog: {
      title: 'Delete',
      content: 'Are you sure deleting this?',
    },
    editProfile: {
      userId: 'User ID',
      firstName: 'First Name',
      lastName: 'Last Name',
      middleName: 'Middle Name',
      company: 'Company',
      jobTitle: 'Job Title',
      address: 'Address',
      unitSuitApt: 'Unit/Suite/Apt #',
      dob: 'Date of Birth',
      language: 'Language',
      city: 'City',
      state: 'State',
      zipCode: 'Zip Code',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      additionalPhoneNumber: 'Additional Phone Number',
      updateProfileSuccess: 'Update your information successfully',

      addDateOfBirth: 'Add date of birth',
      courseRequireDob: 'This course require date of birth to proceed. Please input your date of birth.',
    },
    viewLearnerDetail: {
      apexRegistration: 'This registration is belong to Apex site. Please log in on Apex site to see detail',
      view: 'View',
    },
    accountSetting: {
      status: 'Status',
      userName: 'Username',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
    },
    paymentDialog: {
      addOrChargeCreditCard: 'Add/Charge Credit Card',
      payment: 'Payment',
      choosePaymentMethods: 'Choose payment methods',
      chargeSelectedCard: 'Charge selected card',
      checkName: 'Check name',
      checkNumber: 'Check number',
      amount: 'Amount ($)',
      payWithoutCheck: 'Pay without check',
      proceedWithoutCheck: 'Proceed without check',
      checkInfoNotRequired: 'Check info not required',
      allowSeatAssignmentsWithoutCheck: 'Allow seat assignments without check',
      pleaseMailYourCheckTo: 'Please mail your check to',
      groupAdminNoticeMessage: 'TRAINING PACKAGES WILL NOT BECOME ACTIVE UNTIL PAYMENT IS RECEIVED',
    },
    title: {
      assignedSeats: 'Assigned Seats',
      assigned: 'Assigned',
      classRegistrations: 'In-Person Food Manager',
      proctorURegistrations: 'Online Food Manager',
      actions: 'Actions',
      orders: 'Orders',
      adminELearning: 'Admin e-Learning',
      studentELearning: 'Student e-Learning',
      learners: 'Learners',
      accountSettings: 'Account Settings',
    },
    button: {
      getStarted: 'Get started',
      excelReport: 'Excel Report',
      hideUnhideRegistrations: 'Hide/Unhide Registrations',
      hideRegistrations: 'Hide Registrations',
      unhideRegistrations: 'Unhide Registrations',
      emailCertificate: 'Email Certificate',
      downloadCertificates: 'Download Certificates',
      resendPassword: 'Resend Password',
      submit: 'Submit',
      generate: 'Generate',
      send: 'Send',
      orderPrintedCopy: 'Order Printed Copy',
      downloadCertificate: 'Download Certificate',
      downloadCert: 'Download Cert',
      save: 'Save',
      edit: 'Edit',
      continueToCheckout: 'Continue to Checkout',
      documents: 'Documents',
      back: 'Back',
      markAsPaid: 'Mark as Paid',
      pay: 'Pay',
      remove: 'Remove',
      cancel: 'Cancel',
      close: 'Close',
      refund: 'Refund',
      refunded: 'Refunded',
      classRegistrationRefunded: 'This class was refunded',
      proctorURefunded: 'This code was refunded',
      eLearningRefunded: 'This training was refunded',
      notSupportRefundByCheck: 'Refunds by check are not supported',
      notSupportRefundByPaymentMethod: 'El sistema no acepta reembolsos si el pago es con {paymentMethod}',
      applyToSelected: 'Apply to Selected',
      create: 'Create',
      download: 'Download',
      expandMore: 'Expand More',
    },
    header: {
      firstName: 'First Name',
      lastName: 'Last Name',
      serverId: 'Server ID',
      emailAddress: 'Email Address',
      email: 'Email',
      status: 'Status',
      userId: 'User ID',
      instructorNotes: 'Instructor notes',
    },
    deleteLearnerDialog: {
      title: 'Delete learner',
      content: 'Are you sure you want to delete this learner?',
      pfsAdminContent: 'This action will permanently unassign learner from all assigned training courses.',
    },
    updateLearnerPosition: {
      update: 'Update',
    },
    updateLearnerProgress: {
      update: 'Update',
    },
    form: {
      requiredField: 'Required field',
    },

    // Components start from here.
    addQuizForm: {
      addAttempt: 'Add Attempt',
      addAttemptPlaceholder: 'Select Exam',
      add: 'Add',
    },
    assignedCourseDetail: {
      generalSettings: 'General Settings',
      examResults: 'Exam Results',
      actions: 'Actions',
      updateLearnerPosition: 'Update Learner\'s Position',
      currentProgress: 'Current Progress',
      studentInfo: 'Student Info',
      studentCourses: 'Student Courses',
      close: 'Close',
      saveCurrentProgressAs: 'Save current position as',
    },
    assignedCourse: {
      course: 'Course',
      packageInfo: 'Package Info',
      createdDate: 'Create Date',
      courseExpiration: 'Course Expiration',
      courseStatus: 'Course Status',
      hide: 'Hide Learners',
      unhide: 'Unhide Learners',
      hideUnhideLearners: 'Hide/Unhide Learners',
      changeVisibilityGuidance: 'Select learners to update visibility',
      hiddenUnhidden: 'Hidden/Unhidden',
    },
    visibility: {
      hidden: 'Hidden',
      unhidden: 'Unhidden',
    },
    courseStatus: {
      notStarted: 'Not Started',
      inProgress: 'In Progress',
      completed: 'Completed',
      active: 'Active',
      expired: 'Expired',
      notExpired: 'Not Expired',
    },
    assignedCourseTable: {
      userId: 'User ID',
      confirmation: 'Confirmation',
      assignedDate: 'Registered On',
      expiredDate: 'Expires On',
      course: 'Course',
      order: 'Order',
      serverId: 'Server ID',
      licenseStatus: 'License Status',
      quickActions: 'Quick Actions',
      trainingStatus: 'Training Status',
      courseProgress: 'Course Progress',
      completed: 'Completed',
      verificationCode: 'Verification Code #',
      studentName: 'Student Name',
      admin: 'Admin',
    },
    assignedProctorU: {
      assigned: 'Assigned',
      sent: 'Sent',
      transferPackage: 'Transfer Package',
      notSentYet: 'Not sent yet',
      unassigned: 'Unassigned',
      resendExamCode: 'Resend Exam Code',
      confirmation: 'Confirmation',
      studentName: 'Student Name',
      purchaseDate: 'Purchase Date',
      assignDate: 'Assign Date',
      examCode: 'Exam Code',
      packageInfo: 'Package Info',
      packageName: 'Package Name',
      order: 'Order',
      resendCodeSuccessfully: 'The code has been sent successfully',
      resendCodesSuccessfully: 'All codes have been sent successfully.',
      actions: 'Actions',
      documents: 'Documents',
      proctorURegistrations: 'ProctorU Registrations',
      dateSent: 'Date Sent',
      restartTraining: 'Restart Training',
      buyExamCodes: 'Buy Exam Codes',
      noAssignedRegistrations: 'You currently do not have any registrations.',
      code: 'Code',
      willBeTransferredFrom: 'will be transferred from',
      to: 'to',
    },
    proctorUColumns: {
      conf: 'Conf',
      order: 'Order',
      regDate: 'Reg. Date',
      paid: 'Paid',
      balance: 'Balance',
      registeredBy: 'Registered By',
      companyName: 'Company Name',
      status: 'Status',
      examCode: 'Exam Code',
    },
    assignedSeats: {
      confirmation: 'Confirmation',
      studentName: 'Student Name',
      order: 'Order',
      createdDate: 'Created Date',
      state: 'State',
      classInfo: 'Class Info',
      packageInfo: 'Package Info',
      packageName: 'Package Name',
      attendStatus: 'Status',
      balance: 'Balance',
      websiteOrLinks: 'Website / Links',
      studentPortal: 'Student Portal',
      classLocation: 'Class Location',
      classDate: 'Class Date',
      schedule: 'Schedule',
      noDataText: 'No registration found.',
      haveNoRegistrations: 'You currently do not have any registrations',
      buySeats: 'Buy Seats',
      newClassRegistration: 'New Class Registration',
      expirationDate: 'Exp. Date',
      selectDate: 'Select Date',
    },
    assignment: {
      state: 'State',
      addLine: 'Add line',
      online: 'Online Courses',
      almostFull: 'Almost full',
      full: 'Full',
      inPerson: 'In-Person Food Manager',
      proctorU: 'Online Food Manager',
      selectPackageToSeeLearnersList: 'Select a package to load learners list',
      classLanguage: 'Class language',
      year: 'Year',
      package: 'Package',
      assigned: 'assigned',
      assignedSuccessfully: 'Assigned Successfully',
      step1: 'Select Available Packages - Step 1',
      step2: 'Select Learners - Step 2',
      step3: 'Assign Seats - Step 3',
      assignLearners: 'Assign Learners',
      done: 'Done',
      noLearnerAvailable: 'No learners available',
      selectAtLeastOneLearner: 'You must add at least one learner to assign to the selected package',
      next: 'Next',
      courseRequireDob: 'This course requires the learner’s date of birth to comply with local regulatory authority reporting guidelines. Please make sure you enter the correct date below.',
      importAndAssignComplete: 'Import and assign package to learners complete',
      learnerSelectedExceedQuantity: 'The number of new learners selected exceeds the number of available packages.',
      selectAvailablePackagesSubtitle: 'All contents of packages will be assigned to a single learner',
      learners: 'Learners',
      success: 'Success',
      successSubtitle: 'You have successfully assigned the following to {learnerNumber} learners.',
      packageIncludes: 'Package Includes',
      show: 'Show',
      enroll: 'Enroll',
      states: 'States',
      businessZipCode: 'Business Zip Code',
      inactiveLearnersInSelections: 'There are inactive learners in selection list. Please deselect those learners.',
      location: 'Location',
      miles: 'Miles',
      language: 'Language',
      selected: 'Selected',
      select: 'Select',
      selectedLearners: 'Selected Learners',
      packageSelected: 'Package Selected',
      remainingQuantity: '{quantity} available',
      productList: 'Product List',
      enrollAndContinue: 'Enroll & Continue',
      footerNote: ' All contents of packages will be assigned to a single learner.',
      classCancelled: 'Class Cancelled',
      rescheduleFee: 'Reschedule Fee',
      note: 'Note',
      rescheduleRegistration: 'Reschedule Registration',
      skipForNow: 'Skip for Now',
      skipForNowNote1: 'This package also includes an in person class.',
      skipForNowNote2: 'Please select the date of the in person Class',
      selectExamLanguage: 'Select Exam Language',
      assign: 'Assign',
      selectPackage: 'Selected Package',
      selectAPackage: 'Select a package',
      noPackageAvailable: 'No package available',

      rbsInstruction1: 'The CA Dept. of Alcoholic Beverage Control requires all servers to',
      createRbsAccount: 'Create an RBS Account',
      rbsInstruction2: 'to obtain a Server ID prior to starting the RBS training.',
      rbsInstruction3: 'The CA Dept. of Alcoholic Beverage Control requires all servers to obtain a Server ID prior to starting the RBS training.',
      rbsServerIdFee: 'Please note: the ABC charges a $3 fee to obtain a Server ID.',
      rbsServerId: 'RBS Server ID',
      learnerInfo: 'Learner Info',
      serverId: 'Server ID here',
      enter: 'Enter',
      rbsDialogStep1: 'Click here to',
      rbsDialogStep3: 'Verify your information is correct',

      dob: 'Date of Birth',
      shortDob: 'DOB',
      lastName: 'Last Name',
      seatsLeft: 'Seats Left',
      seatLeft: 'Seat Left',
      noSeatsLeft: 'Class full',
      noClassFound: 'No class found.',
      instantResults: 'Instant results',
      instantResultsNote: 'Classes marked with a star will be offered with instant results. Learners will need a laptop and a ServSafe account set up in advance. Details will be sent via email.',
      instantResultsLegend: 'Instant Results - Please bring your own laptop',

      private: 'Private Class',
      employeeId: 'Employee ID',

      manage: 'Manage',
      managePackages: 'Manage Packages',
      packageName: 'Package Name',
      availableQuantity: 'Available Quantity',
      deleteAvailablePackages: 'Delete Available Packages',
      areYouSureYouWantToDelete: 'Are you sure you want to delete',
      thisActionCannotBeUndone: 'This action cannot be undone.',
      totalAvailablePackages: 'Total available packages of this type',
      toConfirmPleaseTypeTheNumberOfAvailable: 'To confirm, please type the number of available',
      toDelete: 'to delete',
      seatRemovedSuccess: 'Available Seat removed successfully!',
    },
    examResults: {
      save: 'Save',
      delete: 'Delete',
      quizName: 'Quiz Name',
      language: 'Language',
      correctAnswers: 'Correct Answers',
      totalQuestions: 'Total Questions',
      examScore: 'Exam Score',
      dateStarted: 'Date Started',
      dateUpdated: 'Date Updated',
    },
    addressDialog: {
      requestForLaminatedCard: 'A laminated card has already been bought by your group admin. Enter the mailing address for card delivery.',
    },
    lookup: {
      courses: 'Courses',
      licenseStatus: 'License Statuses',
      attendanceStatus: 'Attendance Statuses',
      filterBy: 'Filter by',
      selected: 'Selected',
      package: 'Packages',
      trainingStatuses: 'Training Statuses',
      expirationStatuses: 'Expiration Statuses',
      visibility: 'Visibility',
      packageType: 'Package Type',
    },
    printedCopyPaymentDialog: {
      description: 'Order a Hard Copy of Your Certificate for',
    },
    newOrders: {
      selectPackage: 'Select Package',
      productsIncluded: 'Products Included',
      orderFreeOfCharge: 'This is order is free of charge. Are you sure to pay for this order?',
      quantity: 'Quantity',
      discount: 'Discount',
      price: 'Price',
      newOrder: 'New Order',
      addAdditionalPackages: 'Add Additional Packages',
      guide: 'Select package to see included products.',
      removeDiscount: 'Remove Discount',
      applyDiscount: 'Apply Discount',
      orderTotal: 'Order total',
      discountErrorMessage: 'Discount value must smaller than package price.',
      cannotDelete: 'You cannot delete this package. At least one package must be in a new order.',
      addOrChangeCreditCard: 'Add/Charge Credit card',
      addPayment: 'Add Payment',
      payNow: 'Pay Now',
      errorNotification: 'Please check the errors log on fields',
      successNotification: 'New order has been created successfully',
    },
    orders: {
      freeFoodHandlerCardNote: 'Free with Premium Food Manager package. Transferable to employee.',
      paymentType: 'Payment Type',
      balanceDue: 'Balance Due',
      purchaseOrderGuide: 'Click here to choose a training package and start a new order',
      name: 'Name',
      productPackages: 'Product/Packages',
      exportOrders: 'Export Orders',
      exportSelectedOrders: 'Export Selected Orders',
      exportAllOrders: 'Export All Orders',
      exportOrdersInSelectedPage: 'Export Orders in selected page',
      creditCardInfo: 'Credit Card Info',
      zip: 'Zip',
      address: 'Address',
      packageId: 'Package ID',
      packageName: 'Package Name',
      price: 'Price',
      markAsPaid: 'Mark as Paid',
      markAsUnpaid: 'Mark as Unpaid',
      quantity: 'Quantity',
      status: 'Status',
      paymentDate: 'Payment Date',
      expirationDate: 'Expiration Date',
      appliedCode: 'Code',
      discountAmount: 'Discount Amount',
      perUnit: 'per unit',
      totalDiscount: 'Total Discount',
      totalAmount: 'Total Amount',
      deleteOrder: 'Delete order',
      deleteConfirmationText: 'Are you sure you want to delete this order?',
      deleteConfirmedText: 'Yes, delete',
      deleteSuccessfullyText: 'Delete order successfully',
      delete: 'Delete',
      edit: 'Edit',
      viewReceiptInvoice: 'View Receipt/Invoice',
      viewReceipt: 'View Invoice',
      cancel: 'Cancel',
      saveChanges: 'Save Changes',
      order: 'Order',
      confirmation: 'Confirmation',
      studentName: 'Student Name',
      classDate: 'Class Date',
      city: 'City',
      createdDate: 'Created Date',
      createdBy: 'Created By',
      orderTotal: 'Order Total',
      balance: 'Balance',
      noOrderText: 'You currently do not have any orders.',
      notAllowEditAndDelete: 'Packages from this order have been assigned prior to payment. You cannot delete or edit this order.',
      buyProducts: 'Buy Products',
      check: 'Check',
      checkNumber: 'Check number',
      orderNotPaidYet: 'This order is not paid. Packages have been released for assignment.',
      dateOfRefund: 'Date of Refund',
      totalRefunded: 'Total Refunded',
      refundIssued: 'Refund Issued',
      refund: 'Refund',
      checkedTotal: '{checkedTotal} Items',
      selectedForRefund: 'Selected for Refund',
      enterRefundAmount: 'Enter Refund Amount',
      enterAmount: 'Enter Amount',
      issueRefund: 'Issue Refund',
      packageColumnName: 'Package',
      assignedToColumnName: 'Assigned to',
      refundSuccess: 'Success!',
      refundSuccessDescription: 'You have successfully refunded the following items',
      products: 'Products',
      unassigned: 'Unassigned',
      remove: 'Remove',
      apply: 'Apply',
      discountCode: 'Discount Code',
      discountTotal: 'Discount Total',
      cannotViewInvoice: 'An invoice/receipt can’t be generated for this order. Please contact us at 800-676-3121 to request a copy of the document, or send an email info&#64;premierfoodsafety.com',
      deleteOrderConfirmation: 'Are you sure to delete this order?',
      selectedForPay: '{count} orders selected',
      paySelected: 'Pay Selected',
      clear: 'Clear',
      payPalTransactionId: 'PayPal Transaction ID',
      payPalCancelConfirmMessage: 'If you close the PayPal payment window, you will be logged into the system and can complete the payment later.',
      payPalSuccessButPaymentCouldNotBeCompleted: 'The PayPal payment was successful, but there was a minor issue with the payment flow. If the order has not been marked as paid or anything unusual occurs, please contact support at 800-676-3121.',
      applePaySuccessButPaymentCouldNotBeCompleted: 'The Apple Pay payment was successful, but there was a minor issue with the payment flow. If the order has not been marked as paid or anything unusual occurs, please contact support at 800-676-3121.',
      enterCheckNumber: 'Enter Check Number',
      refundMethod: 'Refund Method',
      refundByCard: 'Refund by Card',
      refundByCheck: 'Refund by Check',
      refundByPayPal: 'Refund by PayPal',
      generateInvoice: 'Generate Invoice',
    },
    purchasePackages: {
      purchasePackages: 'Purchase packages',
      total: 'Total',
      promoCode: 'Promo Code',
      enterPromoCode: 'Enter Promo Code',
      applyCode: 'Apply Code',
      discountAppliedTo: 'Discount Applied to',
      code: 'Code',
      addAdditionalPackage: 'Add Additional Packages',
      checkout: 'Checkout',
      cannotApplyMultipleCodeMessage: 'You cannot apply multiple codes for 1 package.',
      codeIsAppliedMessage: 'Code {code} has already been applied.',
      removeDiscountCode: 'Remove discount code',
      allergenCta: 'Add Food Allergen Awareness Training',
    },
    unassignedCodes: {
      selectCodes: 'Select Codes',
      title: 'Unassigned Codes 4',
      assignCodeButton: 'Assign Code(s)',
      buyCodeButton: 'Buy Code(s)',
    },
    unassignedCourses: {
      title: 'Unassigned Courses',
      buyLicense: 'Buy License(s)',
      assignCourses: 'Assign Courses(s)',
      assignCourse: 'Assign Course',
    },
    unassignedLearnersTable: {
      deleteButton: 'Delete',
      addNewLearner: 'Add Learner',
      markAsActive: 'Mark Learner as Active',
      markAsInactive: 'Mark Learner as Inactive',
      markAsActiveInactive: 'Mark Learner as Active/Inactive',
      changeStatusGuidance: 'Select learners with the same status to update their status.',

      confirmMarkingInactive: 'Are you sure you want to mark learner(s) as inactive?',
      contentMarkingInactive: 'This will cancel the learner(s) account and also permanently remove all assigned training courses. <br/> To avoid losing any unused training packages, please transfer them to a new learner before proceeding.',
    },
    unassignedSeats: {
      title: 'Unassigned Seats',
      buySeats: 'Buy Seat(s)',
      assignSeats: 'Assign Seat(s)',
    },
    unassignedSections: {
      selectLearners: 'Select Learners',
      addNewLearner: 'Add Learner',
    },
    addNewLearnerDialog: {
      addNewLearner: 'Add Learner',
      firstName: 'First name',
      lastName: 'Last name',
      dob: 'Date Of Birth',
      emailAddress: 'Email address',
      jobTitle: 'Job title',
    },
    learnersTable: {
      bulkImport: 'Bulk Import',
      importLearnersInstructionDownloadTemplate: 'Add students in bulk by uploading a completed CSV Learners List template.',
      importLearnersInstructionUpload: 'Add your learners\' information to the template. Once done, you can upload your file here.',
      uploadLearnerList: 'Upload Learner List ',
      downloadSample: 'Download Template',
    },
    ancillary: {
      needHelp: 'Need Help',
      contactUs: 'Contact Us',
      text1: 'We are available to answer questions that are specifically related to the elearning training and course material',
      text2: 'If you have specific questions in regards to your business, please contact your local health department',
      callHelpDesk: 'Call Help Desk',
    },
    appFooter: {
      copyright: `©Copyright 2000-${currentYear} Premier Food Safety. All rights reserved.`,
    },
    coursePlayer: {
      select: 'Select',
      courseProgress: 'Course Progress',
      frameNotSupported: 'Your browser does not support frames.',
      certificateDialogTitle: '알림',
      certificateDialogMessage: '축하합니다. 자격증이 이메일로 발송되었습니다.',
      certificateDialogButtonText: 'OK',
    },
    courseProgress: {
      purchased: 'Purchased',
      buyLaminatedCard: 'Buy Laminated Card',
      expires: 'Expires',
      transfer: 'Transfer',
      download: 'Download',
      start: 'Start',
      continue: 'Continue',
      review: 'Review',
    },
    courses: {
      myCourses: 'My Courses',
      doNotHaveCoursesAndAssign: 'You currently do not have any courses assigned to you. Click above to assign.',
      doNotHaveCourses: 'You currently do not have any courses',
      noCompletedCourses: 'You currently do not have any completed courses.',
      instruction: 'Select a course to see the details.',
    },
    documentGenerationDialog: {
      header: 'Documents appear here',
      note1: 'Please regenerate the document before sending',
      note2: 'This might be blank when this screen load the first time',
      generateDocument: 'Generate Document',
    },
    headerActions: {
      myPortal: 'My Portal',
      publicSite: 'Shop PFS',
      faq: 'FAQ',
      contactUs: 'Contact Us',
      myAccount: 'My Account',
      logout: 'Logout',
      learners: 'Learners',
      orders: 'Orders',
    },
    fmSurvey: {
      title: 'Get a $20 Amazon e-Gift Card',
      description: 'Complete our Food Manager survey and we will email you a $20 Amazon e-Gift Card within 1 week of completing it.',
      duration: 'Takes about 15 minutes',
      eligibilityLead: 'Eligibility: Only for those with',
      eligibilityYears: '3+ years',
      eligibilityTail: 'of experience working as a Food Manager',
      limit: 'Limit one survey per student.',
      takeSurvey: 'Take the Survey',
      giftIconAlt: 'Gift icon',
      clockIconAlt: 'Clock icon',
    },
    dashboardAnnouncement: {
      dismiss: 'Dismiss announcement',
    },
    logo: {
      title: 'Premier Food Safety',
    },
    profile: {
      registered: 'Registered',
      by: 'By',
      userId: 'User ID',
      editProfile: 'Edit profile',
    },
    stats: {
      assignSeats: 'Assign Seats',
      assigned: 'Assigned',
      classRegistrations: 'In-Person Food Manager',
      proctorURegistrations: 'Online Food Manager',
      elearningLicense: 'eLearning Licenses',
      assignLicense: 'Assign License',
      assignCode: 'Assign Code',
      unassigned: 'Available',
      purchased: 'Purchased',
      yourPurchases: 'Purchases',
      noPurchases: 'You don\'t have any seats yet. Seats show up here once an order is paid.',
    },
    userInfo: {
      welcome: 'Welcome back',
    },
    faqs: {
      common: {
        title: 'FAQs',
        1: 'The screen is frozen. I can\'t click the next button or do anything.',
        2: 'Log out and log back in',
        3: 'Restart your computer',
        4: 'Safari browser is currently not supported. Please make sure to view the course using',
        5: 'They are recommended for the best training experience',
        6: 'Clear your cache. This is important if you are using a shared computer where someone may have previously taken the same course',
        7: 'Use a different computer',
        8: 'I can\'t get to the next slide.',
        9: 'Click the \'Next\' or \'Play\' button to move forward',
        10: 'Make sure you are using',
        11: 'or',
        12: 'as your browser.',
        13: 'I finished the training but I can\'t print the certificate.',
        14: `To print the certificate you must achieve the passing score as stated in the Final Quiz.
          If you have not achieved this, you will not be able to print your certificate.
          You are able to view your score(s) in 'My Course Progress'
          and you are also able to re-take the quiz until you pass.`,
        15: 'I printed the certificate and it has another person\'s name.',
        16: `Verify that you are using your own login information by going to 'Course Progress'
          and verifying that your name appears on the top left corner`,
        17: 'If you registered under a different name, we will not be able to make any changes after the certificate has been issued',
        18: 'The screen is frozen or it is loading slowly.',
      },
      general: {
        title: 'General FAQs',
        createAccount: 'How to create an Account',
        login: 'How to Log in to an Existing Account',
        assignOnlineCourses: 'How to Assign Online Courses to Yourself',
        selfRegister: 'How to Self-Register for an In-Person Class',
        updateUserInfo: 'How to Update Your User Info',
        accessOnlineGuide: 'How to Access the Online Study Guide',
        resetPassword: 'How to Reset Your Password',
      },
      individualTutorial: {
        title: 'Tutorials for Individual Users',
        studentPortalFeature: 'Complete Guide to Student Portal Features',
        startOnlineCourse: 'How to Start Your Online Training Course',
        accessClassInformation: 'How to Access In-Person Class Information',
        findExamCode: 'How to Find your ProctorU Exam Code',
      },
      groupAdminTutorial: {
        title: 'Tutorials for Group Admins',
        completeGuide: 'Complete Guide to Group Admin Portal Features',
        addNewLearner: 'How to Add a New Learner',
        addGroupLearners: 'How to Add a Group of Learners in Bulk',
        removeLearner: 'How to Remove a Learner',
        markLearnerInactive: 'How to Mark Learners as Inactive',
        assignPackage: 'How to Assign In-Person and Online Training Packages to Yourself and Others',
        emailLearnersGroup: 'How to Email a Group of Learners Enrolled in an Online Course',
        resendExam: 'How to Resend a ProctorU Exam and Instructions to a Learner',
        accessDownLoadCards: 'How to Access and Download Cards and/or Certificates for Learners taking an Online Course',
        transferUnusedCourse: 'How to Transfer an Unused Online Course to a New Learner',
        generateLeanerReports: 'How to Generate Learner Reports',
        updateLearnerEmail: 'How to Update a Learner’s Email Address',
        resendPassword: 'How to Resend Password to a Learner',
        updatePassword: 'How to Update Your Admin Password',
        addSavePayment: 'How to Add and Save Payment Methods to your Account',
        shopMainSite: 'How to Shop the Main PFS Site',
        purchaseTrainingPackage: 'How to Purchase Training Packages from the Group Admin Dashboard',
      },
    },
    myAccount: {
      title: 'My Account',
      resetPassword: 'Reset password',
      deactivate: 'Deactivate account',
      activate: 'Activate account',
      saveChanges: 'Save Changes',
      changeUsername: 'Change username',
      resetPasswordSuccessfully: 'Reset password successfully.',
      changeUsernameSuccessfully: 'Change username successfully.',
      deactivateAccountConfirmation: 'Are you sure you want to deactivate your account?',
      reminderSettings: 'Reminder Settings',
      certificateRenewalReminder: 'Certificate renewal reminder',
      certificateRenewalReminderNote: 'Receive an email reminder as your certificate expiration date approaches.',
      inPersonClassReminder: 'In-Person Food Manager class reminder',
      inPersonClassReminderNote: 'Receive an email reminder about upcoming In-Person Food Manager certification classes',
      smsCertificateRenewalReminder: 'SMS certificate renewal reminder',
      smsCertificateRenewalReminderNote: 'Receive a text message reminder as your certificate expiration date approaches.',
      saveReminderSettings: 'Save Reminder Settings',
    },
    contactUs: {
      name: 'Name',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      subject: 'Subject',
      comment: 'Comment',
      submit: 'Submit',
      submitting: 'Submitting...',
    },
    eLearning: {
      emailLearners: 'Email Learners',
      hideStudent: 'Hide Student',
      unhideStudent: 'Unhide Student',
      noAssignedCourses: 'You currently do not have any registrations.',
      buyLicenses: 'Buy Licenses',
      restartTraining: 'Restart Training',
      newELearningLicenses: 'New e-Learning Licenses',
      orderLaminatedCard: 'Order Laminated Card',
      congratulateOnExam: 'Congratulations on passing your exam',
      style: 'Style',
      buyACreditCard: 'Buy a Credit Card',
      preBoughtCreditCard: 'You pre-bought a Credit Card',
      laminatedCardDescription1: 'Food Handler Card for',
      laminatedCardDescription2: 'You\'ll receive it within 7-10 business days.',
      buyNow: 'Buy Now',
      purchaseSuccess: 'Thank you for your purchase',
      purchaseLaminatedCardSuccessInfo: 'Your order is being processed. Please allow 7-10 business days to receive your card in the mail.',
      mailingNote: 'Enter the',
      mailingAddress: 'Mailing Address',
      mailingNote2: 'you want the card sent to.',
      laminatedCardNameNote: 'The following name will appear on your card. If the name is spelled incorrectly, please call us at 800-676-3121',
    },
    noteDrawer: {
      notes: 'Notes',
      addNote: 'Add Note',
      system: 'PFS System',
    },
    dashboard: {
      adminViewTitle: 'PFS Admin View',
      adminViewSubtitle: 'Home - User information',
      editUserInfo: 'edit-user-info-element',
      noGroupAdminWarning: 'Please select 1 Group Admin.',
      invalidUser: 'User ID is invalid. Please check it again.',
      unpaidOrders: {
        title: 'Unpaid Orders',
        description: 'These orders are awaiting payment. Seats become available once payment is received.',
        orderNumber: 'Order #',
        createdDate: 'Created Date',
        total: 'Total',
        balance: 'Balance Due',
        quickActions: 'Quick Actions',
        viewAllOrders: 'View all orders',
        latestNote: 'Showing the {count} most recent unpaid orders.',
      },
    },
    classRegistrations: {
      instructor: 'Instructor',
      onlyAllow1Class: 'Please choose only 1 class',
      notAllowOrderPrintedCopy: 'A printed copy is only available once students have taken and passed the ServSafe exam. This registration does not yet meet that criteria.',
      classMaterialsAndDocs: 'Class Materials & Docs',
      forUser: 'for user',
      selectClassForRetest: 'Select Class for Retest',
      selectClassForReschedule: 'Select Class for Reschedule',
      notAllowReschedule: 'This registration seems too late to be RESCHEDULED. Only allowing the following status to be rescheduled: Approved, No-Show.',
      notAllowRetest: 'Only following registration statuses accepted for retest: Attended, Completed-Fail.',
      notAllowDownloadCertificate: 'Only the following registration statuses accepted for downloading certificate: Completed-Pass.',
      certificateInProgress: 'Certificate is still in progress, please wait a little while.',
      studentPortal: 'Student Portal',
      yes: 'Y',
      no: 'N',
      generalSettings: 'General Settings',
      actions: 'Actions',
      documents: 'Documents',
      reschedule: 'Reschedule',
      transfer: 'Transfer',
      retest: 'Retest',
      cancel: 'Cancel',
      emailCertificate: 'Email Certificate',
      setFlag: 'Set Flag',
      unsetFlag: 'Unset Flag',
      discount: 'Discount',
      classCancelled: 'Class Cancelled',
      package: 'Package',
      // Columns name here.
      confirmation: 'Conf',
      order: 'Order',
      regBy: 'Reg. by',
      coName: 'Co. Name',
      regDate: 'Reg. Date',
      classDate: 'Class Date',
      classLocation: 'Class Location',
      compStatus: 'Comp. Status',
      paid: 'Paid',
      attendStatus: 'Status',
      balance: 'Balance',
    },
    restartTraining: {
      confirmationText: 'Are you sure you want to restart training?',
      title: 'Restart Training',
    },
    registration: {
      descriptionForOrderFromApex: 'This registration is from APEX, please click confirm button to process to APEX site.',
    },
    paymentInformation: {
      text: 'Payment Information',
      useNewCreditCard: 'Use New Credit Card',
      removeSelectedCard: 'Remove Selected Card',
      pleaseChooseCard: 'Please select a card.',
      proceedToPayPal: 'Proceed to PayPal',
      proceedToPayPalNote: '* You will complete your payment in PayPal (a new window or a redirect may open depending on your browser).',
    },
    paymentOptions: {
      payByCreditCard: 'Pay by Credit Card',
      payByCheck: 'Pay by Check',
      payByApplePay: 'Apple Pay',
      payByPayPal: 'Pay by PayPal',
    },
    paymentInformationForm: {
      addAndChargeCreditCard: 'Add & Charge Credit Card',
      addCreditCard: 'Add Credit Card',
      type: 'Type',
      typePlaceholder: 'Credit Card',
      nameOnCard: 'Name on Card',
      enterPlaceholder: 'Enter',
      creditCardNumber: 'Credit Card Number',
      expiration: 'Expiration',
      monthPlaceholder: 'Month',
      yearPlaceholder: 'Year',
      billingAddress: 'Billing Address',
      billingZip: 'Billing Zip',
      CC2Sev: 'CVV/CVC',
      saveForFutureUse: 'Save for future use',
    },
    creditCard: {
      readableVisa: 'Visa Credit Card',
      readableMasterCard: 'Master Card',
      readableAmEx: 'American Express Card',
      readableDiscover: 'Discover Card',
      endingIn: 'ending in',
      unknown: 'Unknown',
    },
    paymentStatus: {
      paid: 'Paid',
      unpaid: 'Unpaid',
    },
    userTypeReadable: {
      client: 'Client',
      instructor: 'Instructor',
      staff: 'Staff',
      manager: 'Manager',
      admin: 'Admin',
      elearningManager: 'ELearning Manager',
      elearningStudent: 'ELearning Student',
      student: 'Student',
    },
    readableMyAccountTabs: {
      myPortal: 'My Portal',
      accountSettings: 'Account Settings',
      userInformation: 'User Information',
      paymentInformation: 'Payment Information',
    },
    notificationMessage: {
      default: 'Something went wrong!',
      commonSuccess: 'Success',
    },
    ordersService: {
      addOrChangeCreditCard: 'Add/Charge Credit card',
      addPayment: 'Add Payment',
      payNow: 'Pay Now',
    },
    cancelRegistrationDialog: {
      title: 'Cancel Registration',
      formTitle: '**** {days} days past class date ****',
      transactions: 'Transactions:',
      transactionsDescription: 'No payments found for this registration.',
      totalPaid: 'Total Paid:',
      proceedWithCancelation: 'Proceed with cancelation',
      refundRequested: 'Refund Requested',
      reason: 'Reason',
      type: 'Type',
      name: 'Name',
      amount: 'Amount',
      approve: 'Approve',
    },
    returnLicenseDialog: {
      return: 'Return',
      title: 'Return License',
      content: 'Return the {course} license assigned to {learner} back to available licenses? This cancels the assignment and the license can then be assigned to anyone in the group.',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    },
    transferCourseDialog: {
      title: 'Transfer Course',
      assign: 'Assign',
      transfer: 'Transfer',
    },
    transferClassRegistrationDialog: {
      title: 'Transfer Class',
      assign: 'Assign',
      note: 'Note',
    },
    generalSetting: {
      updateGeneralSettings: 'Update General Settings',
    },
    packageBenefits: {
      freeFoodHandlerCard: 'Free Food Handler Card',
      freeFoodHandlerCardTooltip: 'Transferable to employee',
      limitedTimeOffer: 'Limited-Time Offer',
    },
    checkout: {
      orderSummary: 'Order Summary',
      apply: 'Apply',
      total: 'Total',
      continueToCheckout: 'Continue to Checkout',
      removePackage: 'Remove Package',
      removePackageDialogContent: 'Are you sure you want to remove this package and all related discounts?',
      foodHandlerCardIncludedTitle: 'Food Handler Card Included',
      foodHandlerCardIncludedContent: 'A Food Handler Card is already included in your package. Do you still want to purchase the add-on?',
      freeFoodHandlerCardNote: 'Free with your Premium package. Transferable to employee.',
      confirm: 'Yes',
      cancel: 'No',
      removeDiscount: 'Remove Discount',
      removeDiscountDialogContent: 'Are you sure you want to remove this discount?',
      licenses: 'Licenses',
      includes: 'Includes',
      discountAppliedTo: 'Discount applied to',
      code: 'Code',
      purchase: 'Purchase',
      selectPackageForInformation: 'Please select package for more information',
      buyPackages: 'Buy Packages',
      startShopping: 'Start shopping',
      currentCartEmpty: 'Your shopping cart is currently empty',
    },
    reviewCart: {
      reviewYourCart: 'Review your cart',
    },
    createPaymentInformation: {
      unsupportedCardType: 'We support Visa, Amex, MasterCard only.',
    },
    userStatus: {
      active: 'Active',
      inactive: 'Inactive',
      activeInactive: 'Active/Inactive',
      all: 'All',
    },
    search: 'Search',
    searchExtendedCourses: 'Search by User ID, Order Id or Confirmation #',
    documentGenerationForm: {
      type: 'Type',
      to: 'To',
      from: 'From',
      cc: 'CC',
      additionalDocumentToAttach: 'Additional Document to Attach',
      addRegistrationNote: 'Add Registration Note (Optional)',
    },
    licenseStatus: {
      approved: 'Approved',
      attended: 'Attended',
      noShow: 'No-Show',
      completedPass: 'Completed-Pass',
      completedFail: 'Completed-Fail',
      cancelled: 'Cancelled',
      retestScheduled: 'Retest scheduled',
      chargeback: 'Chargeback',

      // Additional license status for online course.
      new: 'New',
      allocated: 'Allocated',
    },
    table: {
      viewing: 'Viewing',
      total: 'Total',
      noDataText: 'No data available',
      viewInfo: 'View Info',
    },
    time: {
      hours: 'hours',
      minutes: 'minutes',
      hour: 'hour',
      minute: 'minute',
    },
    packageType: {
      elearning: 'Online Courses',
      inPerson: 'In-Person Food Manager',
      proctoru: 'Online Food Manager',
    },
    languages: {
      english: 'English',
      spanish: 'Spanish',
      chinese: 'Chinese',
      korean: 'Korean',
    },
    transferPackage: {
      information: 'This list only shows eligible learners. Learners who have been assigned a package in this same category, or learners assigned an equivalent package in another category will not appear on this list.',
    },
    distances: {
      anyDistance: 'Any distance',
      miles: 'miles',
    },
    emailLearnersDialog: {
      emailLearner: 'Email Learners',
      subject: 'Subject',
      body: 'Body',
      from: 'From',
    },
    requireContactInfoDialog: {
      description: 'A mailing address and phone number are required to process the printed certificate. Please update your information in the My Account tab.',
      goToMyAccountTab: 'Go to My Account tab',
      useBillingAddress: 'Use the same as billing address',
    },
    registrationSuccessModal: {
      title: '환영합니다! 계정이 준비되었습니다',
      subTitle: '등록 완료!',
      info1: '사용자 이름과 비밀번호가 이메일로 전송되었습니다.',
      info2: '로그인 정보를 저장하십시오:',
    },
    copied: '복사됨',
    loading: '로딩 중...',
    folderManager: {
      title: 'SCORM Upload Manager',
      uploadingLabel: 'Uploading SCORM Package:',
      uploadingDesc: 'This process may take a few minutes depending on file size. Please do not close this window.',
      infoAlert: 'Upload SCORM packages to S3. Existing folders will be replaced.',
      labels: {
        language: 'Language',
        s3Folder: 'S3 Folder',
        scormPackage: 'SCORM Package',
        targetFolder: 'Target Folder',
        warning: 'Warning:',
        uploadSuccess: 'Upload Successful',
        uploadError: 'Upload Error',
      },
      messages: {
        confirmUploadFor: 'Do you want to upload the SCORM package for',
        folderReplacedWarning: 'This action will permanently replace all existing files in the target S3 folder. This cannot be undone.',
        uploadSuccess: 'Folder uploaded successfully to S3.',
        uploadFailed: 'Upload failed.',
        connectionError: 'Please check your connection and try again.',
      },
      buttons: {
        upload: 'Upload to S3',
        confirmUpload: 'Confirm Upload',
        cancel: 'Cancel',
        close: 'Close',
      },
    },
    externalLmsClientKeys: {
      title: 'External LMS Client Keys',
      createButton: 'Create New Client Key',
      editHeader: 'Edit New Client Key',
      clientName: 'Client Name',
      clientKey: 'Client Key',
      active: 'Active',
      action: 'Action',
      createdDate: 'Created Date',
      courseIds: 'Course IDs',
      leaveEmptyForAll: 'Leave empty for all',
      allCourses: '(All Courses)',
      domains: 'Domains',
      clientKeyHint: 'Min 10 characters, e.g. PANDA_12345',
      messages: {
        fetchFailed: 'Failed to fetch client keys.',
        updateSuccess: 'External LMS client key updated successfully.',
        updateFailed: 'Failed to update client key.',
        createSuccess: 'External LMS client key created successfully.',
        createFailed: 'Failed to create client key.',
        nameRequired: 'Client name is required.',
        keyRequired: 'Client key is required.',
        keyMinLength: 'Client key must be at least 10 characters.',
        domainsRequired: 'At least one domain is required.',
        invalidDomain: 'Invalid domain format (e.g. example.com).',
        clientKeyAlreadyExists: 'This client key already exists.',
      },
    },
    dashboardAnnouncementAdmin: {
      title: 'Title',
      message: 'Message',
      plainTextHint: 'Plain text only. Line breaks are kept.',
      startTime: 'Start time',
      endTime: 'End time',
      enabled: 'Enabled',
      dateTimePlaceholder: 'mm/dd/yyyy hh:mm AM',
      createdBy: 'Created by {name} on {date}',
      updatedBy: 'Last updated by {name} on {date}',
      unknownUser: 'User #{id}',
      messages: {
        required: 'This field is required.',
        invalidDateTime: 'Enter a date and time as mm/dd/yyyy hh:mm AM/PM.',
        endAfterStart: 'End time must be after Start time.',
        saveSuccess: 'Announcement saved.',
        saveFailed: 'Could not save the announcement.',
        fetchFailed: 'Could not load the announcement.',
      },
    },
    externalLmsRegistrations: {
      title: 'External LMS Registrations',
      confirmation: 'Conf #',
      occurrence: 'Occurrence',
      externalLearnerId: 'External Learner ID',
      trainingStatus: 'Training Status',
      searchPlaceholder: 'Search by Client Key, User ID, Confirmation #',
      status: {
        notStarted: 'Not Started',
        inProgress: 'In Progress',
        completedPassed: 'Completed Passed',
        completedFailed: 'Completed Failed',
      },
      completedDate: 'Completed Date',
      startDate: 'Start Date',
      endDate: 'End Date',
      exportExcel: 'Export Excel',
      exportSuccess: 'Export is ready.',
      exportFailed: 'Failed to export registrations.',
      exportStartDateRequired: 'Please select a start date.',
      exportEndDateBeforeStart: 'End date must be on or after the start date.',
    },
    handlerTopPane: {
      foodHandlersCard: 'Food Handler Card',
      startOnlineTraining: 'Start Online Training',
      groupDiscountsAvailable: 'Group Discounts Available',
      contactUs: 'Contact Us',
      features: [
        'ANAB Accredited',
        'Approved by CA Health Departments',
        'Download & Print Card Instantly',
      ],
    },
    ctaForm: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      whichCounty: 'Which county do you work in?',
      selectYourCounty: 'Select your county',
      continue: 'Continue',
      sanDiegoNotice: 'The California Food Handler Card is not valid in San Diego County. If you work in San Diego County,',
      sanBernardinoNotice: 'The California Food Handler Card is not valid in San Bernardino County. For more information,',
      riversideNotice: 'The California Food Handler Card is not valid in Riverside County. For more information,',
      clickHere: 'please click here.',
    },
    customerStats: {
      over45Years: 'Over 45 Years',
      ofExperience: 'of experience',
      over3Million: 'Over 3 Million',
      clientsTrained: 'clients trained',
      moneyGuarantee: '100% Money Back Guarantee',
    },
    customerTestimonials: {
      addToCart: 'Add to Cart',
    },
    estimateTime: {
      text: '90 mins',
      description: 'Estimated time to complete course + exam',
    },
    easyProcessVideo: {
      alt: 'How to Get Your CA Food Handler Card',
      title: 'How to Get Your CA Food Handler Card',
    },
    onlineProgram: {
      title: 'Join over 3 Million Satisfied Food Service Professionals',
      subTitle: 'Get your food handlers card with this 90-minute online certificate program',
      startedToday: 'Get started today',
    },
    aboutPfs: {
      subTitle: 'Industry Leader in Food Training',
      title: 'About Premier Food Safety',
      description: 'With over 45 years of experience, we are the leading providers of food safety training and certification solutions for the food service industry. Our accredited programs are approved by local health departments and designed to give you maximum flexibility when choosing training for yourself or your staff.',
      programs: 'We offer the ServSafe Food Manager Certification nationwide, and state-specific Food Handler Card programs to help you meet regulatory requirements easily and in an affordable manner.',
    },
    howItWorks: {
      caTitle: 'How to Get Your CA Food Handler Card',
      caDescription: 'To get your card today, you only need to register, take the online course, and pass the exam. Your card will be available for you to download immediately after. Watch the video for a step-by-step guide on the process.',
      easyProcess: 'Our Easy Process',
      step1: 'Step 1',
      step2: 'Step 2',
      step3: 'Step 3',
    },
    steps: {
      step1: {
        title: 'Register & Training',
        languages: 'Languages: English, Spanish (Español), Chinese (中文), and Korean (한국어)',
        onlineCourseLength: '100% Online Course Length: 90 Minutes (Including Exam)',
        startAndStop: 'Start and Stop as Needed',
        features: 'Course features Full Text Transcript & Closed Captioning',
      },
      step2: {
        title: 'Take the Exam',
        attempts: 'Exam Attempts: Unlimited (After 2 fails, course must be watched from the beginning)',
        passingScore: 'Minimum Passing Score: 70%',
        onlineAndMobile: '100% Online and Mobile Friendly',
      },
      step3: {
        title: 'Print Card & Certificate',
        downloadAndPrint: 'Download & Print from Home',
        validFor3Years: 'Card Valid for 3 Years',
        acceptedThroughout: 'Accepted throughout California except for Riverside, San Bernardino, and San Diego Counties',
        accessFor1Year: 'Training access for 1 year',
      },
    },
    contactSection: {
      groupDiscount: 'Looking for group discounts?',
      contactUs: 'Contact us',
    },
    certifications: {
      alcohol: {
        location: 'California AB1825 and SB1343 Courses',
        title: 'Workplace California Harassment Prevention Training for Employees',
        items: [
          'Register for Online Training',
          'Complete the Course & Print Certificate of Completion',
        ],
        learnMore: 'Learn More',
      },
      foodManager: {
        location: 'California Food Manager Certification',
        title: 'ServSafe® Online Course + Online Exam',
        items: [
          'Register for ServSafe In-Person Class or Online Course',
          'Choose Paper-based or Online ServSafe Exam',
        ],
        selectPackage: 'Select a Package',
      },
    },
    resources: {
      title: 'Resources',
      items: {
        regulations: 'California Regulations',
        retailFoodCode: 'California Retail Food Code',
        practiceTest: 'Free Food Handler Practice Exam',
        aboutCard: 'About Food Handler Cards',
        handwashing: 'Handwashing Guide',
        readyToEat: 'Ready-to-Eat Food Prep Guide',
      },
    },
    faqSection: {
      title: 'Frequently Asked Questions',
      ca: {
        q1: 'What is the California Food Handler Card Law?',
        a1: 'The California Food Handlers Card Law (based on SB303) requires all food handlers, unless exempt, to get a Food Handlers Card within 30 days of date of new hire and renew every 3 years.',
        q2: 'How do I get a ',
        q2_link: 'California Food Handlers Card?',
        q2_href: '/food-handlers-card/california',
        a2_start: 'The card issued upon successful completion of an ANAB-accredited food safety program, such as ',
        a2_link: 'Premier Food Safety',
        a2_end: ', and a 40-question exam with a minimum score of 70%.',
        q3: 'Who is considered a food handler?',
        a3: 'A food handler is any individual who is involved in the preparation, storage, or service of food in a food facility.',
        q4: 'Are there any exceptions to the California Food Handlers Card Law?',
        a4_title: 'Food handlers employed at any of the following are exempt from the law:',
        a4_list: [
          'Temporary food facilities (food booths),',
          'Certified farmers’ markets,',
          'Commissaries, grocery stores (including convenience stores),',
          'Licensed health care facilities,',
          'Mobile support units,',
          'Public and private school cafeterias,',
          'Restricted food service facilities,',
          'Retail stores where a majority of sales are from a pharmacy,',
          'Venues with snack bar services in which the majority of sales are from admission tickets,',
          'Certain food facilities with approved in-house food safety training,',
          'Food facilities subject to a collective bargaining agreement,',
          'Any city, county, city and county, state or regional facility used for the confinement of adults or minors, including, but not limited to, a county jail, juvenile hall, camp, ranch, or residential facility,',
          'An elderly nutrition program, administered by the California Department of Aging, and',
          'Food handlers working in the counties of Riverside, San Bernardino and San Diego and food handlers holding a valid Manager’s Food Safety Certificate.',
        ],
        q5: 'I work as a volunteer at a soup kitchen, food bank or a volunteer run restaurant. Do I require a Food Handlers Card?',
        a5: 'No, volunteers are exempt. The law only applies to employees who have been hired by food service establishments.',
        q6: 'Are grocery store employees required to get a Food Handlers Card?',
        a6: 'No, grocery stores are exempt from the ',
        a6_link: 'California Food Handlers Card law.',
        a6_href: '/food-handlers-card/california',
        q7: 'I work at a demonstration booth serving food samples at a grocery store. Am I required to get a California Food Handlers Card?',
        a7: 'No. Grocery store employees are exempt and demonstration companies are not permitted as food facilities.',
        q8: 'I currently hold a valid Manager’s Food Safety Certification. Do I need a California Food Handlers Card?',
        a8: 'No. The Food Manager Certification is a higher, more comprehensive certificate training that meets and exceeds the Food Handlers Card law requirements; therefore you are not required to obtain the Food Handlers Card.',
        q9: 'I am a part-time or temporary employee. Am I required to get a Food Handlers Card?',
        a9: 'Yes, all food handlers, regardless of how many hours they work, are required to obtain a Food Handlers Card, unless exempt.',
        q10: 'When will I get my Food Handlers Card?',
        a10: 'You will be able to download and print your Food Handlers Card as soon as you finish the online training and pass the final test.',
        q11: 'Do I have to complete the training all at once?',
        a11: 'No, you may complete the training in multiple sessions. Every time you log out of your account, your progress is saved, allowing you to resume the training later from the same section where you left off.',
        q12: 'What if I don’t have a printer at home to print my Food Handlers Card?',
        a12: 'If you don’t have access to a computer with a printer, you can still take the training online and, once you have passed the test, we can mail a printed copy of your California Food Handlers Card for an additional fee of $9.99.',
        q13: 'Is my employer responsible for paying for my training and Food Handlers Card?',
        a13: 'Yes. Effective January 1st, 2024, California Employers will be required to cover the cost of the food handler card training for all employees. For more information about the SB476 Law, please ',
        a13_link: 'click here',
        a13_href: '/food-handlers-card/california/sb476-law',
        q14: 'When will my food handlers card expire?',
        a14: 'The food handler card is valid for 3 years before you need to renew.',
        q15: 'Is my card valid anywhere in California?',
        a15_start: 'Your ',
        a15: ' is valid to work in any food service establishment in California, with the exception of those located in San Bernardino, Riverside and San Diego counties. These counties issue their own Food Handlers Cards.',
        a15_link: 'California Food Handlers Card',
        a15_href: '/food-handlers-card/california',
        q16: 'I need to get my Food Handlers Card but I do not have a computer, tablet or smartphone, what can I do?',
        a16_title: 'If you don’t have access to a computer or mobile device, here are a few suggestions:',
        a16_list: [
          'Go to your local library – computers are available for use to the public',
          'Ask a friend if you could borrow their computer for a few hours',
          'Talk to your supervisor about using a computer at work',
        ],
        q17: 'I work for multiple establishments. Do I need a Food Handlers Card for every single one of them?',
        a17: 'Generally, no. Your food handler card will be issued under your name and valid for 3 years, even if you start working for a different employer or work for two or more restaurants. However, if any of the establishments you work for is located in San Bernardino, San Diego or Riverside County, you will need to obtain a Food Handlers Card to work there. These counties issue their own food handler card.',
        q18: 'I currently work at a restaurant located in San Diego and hold a specific ',
        q18_link1: 'San Diego Food Handlers Card',
        q18_href1: '/food-handlers-card/san-diego-county',
        q18_mid: '. Am I required by law to get a ',
        q18_link2: 'California Food Handlers Card',
        q18_href2: '/food-handlers-card/california',
        q18_end: ' also?',
        a18: 'Yes, if you work for a restaurant outside San Diego County, such as Orange County, you need to get a California Food Handlers Card. This same rule applies if you are currently working for a restaurant in San Bernardino or Riverside County.',
        q19: 'What documentation are employers required to keep?',
        a19: 'Employers are responsible for maintaining accurate records that all food handlers employed by the establishment hold a valid California Food Handlers Card. An example of proper documentation would be to keep a copy of each food handler’s card on file, so it is available upon request to the next health inspector.',
        q20: 'If you have a group of 100 or more employees who need to be trained, please call us to receive a special group discount.',
        a20: 'For more information, call ',
        a20_phone: '800-676-3121',
        a20_phone_href: 'tel:+18006763121',
        a20_mid: ' or ',
        a20_link: 'request a quote',
        a20_href: '/food-handlers-card/california',
      },
    },
    handlerTopPane: {
      foodHandlersCard: 'Food Handler Card',
      startOnlineTraining: 'Start Online Training',
      groupDiscountsAvailable: 'Group Discounts Available',
      contactUs: 'Contact Us',
      features: [
        'ANAB Accredited',
        'Approved by CA Health Departments',
        'Download & Print Card Instantly',
      ],
    },
    ctaForm: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      whichCounty: 'Which county do you work in?',
      selectYourCounty: 'Select your county',
      continue: 'Continue',
      sanDiegoNotice: 'The California Food Handler Card is not valid in San Diego County. If you work in San Diego County,',
      sanBernardinoNotice: 'The California Food Handler Card is not valid in San Bernardino County. For more information,',
      riversideNotice: 'The California Food Handler Card is not valid in Riverside County. For more information,',
      clickHere: 'please click here.',
    },
    customerStats: {
      over45Years: 'Over 45 Years',
      ofExperience: 'of experience',
      over3Million: 'Over 3 Million',
      clientsTrained: 'clients trained',
      moneyGuarantee: '100% Money Back Guarantee',
    },
    customerTestimonials: {
      addToCart: 'Add to Cart',
    },
    estimateTime: {
      text: '90 mins',
      description: 'Estimated time to complete course + exam',
    },
    easyProcessVideo: {
      alt: 'How to Get Your CA Food Handler Card',
      title: 'How to Get Your CA Food Handler Card',
    },
    onlineProgram: {
      title: 'Join over 3 Million Satisfied Food Service Professionals',
      subTitle: 'Get your food handlers card with this 90-minute online certificate program',
      startedToday: 'Get started today',
    },
    aboutPfs: {
      subTitle: 'Industry Leader in Food Training',
      title: 'About Premier Food Safety',
      description: 'With over 45 years of experience, we are the leading providers of food safety training and certification solutions for the food service industry. Our accredited programs are approved by local health departments and designed to give you maximum flexibility when choosing training for yourself or your staff.',
      programs: 'We offer the ServSafe Food Manager Certification nationwide, and state-specific Food Handler Card programs to help you meet regulatory requirements easily and in an affordable manner.',
    },
    howItWorks: {
      caTitle: 'How to Get Your CA Food Handler Card',
      caDescription: 'To get your card today, you only need to register, take the online course, and pass the exam. Your card will be available for you to download immediately after. Watch the video for a step-by-step guide on the process.',
      easyProcess: 'Our Easy Process',
      step1: 'Step 1',
      step2: 'Step 2',
      step3: 'Step 3',
    },
    steps: {
      step1: {
        title: 'Register & Training',
        languages: 'Languages: English, Spanish (Español), Chinese (中文), and Korean (한국어)',
        onlineCourseLength: '100% Online Course Length: 90 Minutes (Including Exam)',
        startAndStop: 'Start and Stop as Needed',
        features: 'Course features Full Text Transcript & Closed Captioning',
      },
      step2: {
        title: 'Take the Exam',
        attempts: 'Exam Attempts: Unlimited (After 2 fails, course must be watched from the beginning)',
        passingScore: 'Minimum Passing Score: 70%',
        onlineAndMobile: '100% Online and Mobile Friendly',
      },
      step3: {
        title: 'Print Card & Certificate',
        downloadAndPrint: 'Download & Print from Home',
        validFor3Years: 'Card Valid for 3 Years',
        acceptedThroughout: 'Accepted throughout California except for Riverside, San Bernardino, and San Diego Counties',
        accessFor1Year: 'Training access for 1 year',
      },
    },
    contactSection: {
      groupDiscount: 'Looking for group discounts?',
      contactUs: 'Contact us',
    },
    certifications: {
      alcohol: {
        location: 'California AB1825 and SB1343 Courses',
        title: 'Workplace California Harassment Prevention Training for Employees',
        items: [
          'Register for Online Training',
          'Complete the Course & Print Certificate of Completion',
        ],
        learnMore: 'Learn More',
      },
      foodManager: {
        location: 'California Food Manager Certification',
        title: 'ServSafe® Online Course + Online Exam',
        items: [
          'Register for ServSafe In-Person Class or Online Course',
          'Choose Paper-based or Online ServSafe Exam',
        ],
        selectPackage: 'Select a Package',
      },
    },
    resources: {
      title: 'Resources',
      items: {
        regulations: 'California Regulations',
        retailFoodCode: 'California Retail Food Code',
        practiceTest: 'Free Food Handler Practice Exam',
        aboutCard: 'About Food Handler Cards',
        handwashing: 'Handwashing Guide',
        readyToEat: 'Ready-to-Eat Food Prep Guide',
      },
    },
    faqSection: {
      title: 'Frequently Asked Questions',
      ca: {
        q1: 'What is the California Food Handler Card Law?',
        a1: 'The California Food Handlers Card Law (based on SB303) requires all food handlers, unless exempt, to get a Food Handlers Card within 30 days of date of new hire and renew every 3 years.',
        q2: 'How do I get a ',
        q2_link: 'California Food Handlers Card?',
        q2_href: '/food-handlers-card/california',
        a2_start: 'The card issued upon successful completion of an ANAB-accredited food safety program, such as ',
        a2_link: 'Premier Food Safety',
        a2_end: ', and a 40-question exam with a minimum score of 70%.',
        q3: 'Who is considered a food handler?',
        a3: 'A food handler is any individual who is involved in the preparation, storage, or service of food in a food facility.',
        q4: 'Are there any exceptions to the California Food Handlers Card Law?',
        a4_title: 'Food handlers employed at any of the following are exempt from the law:',
        a4_list: [
          'Temporary food facilities (food booths),',
          'Certified farmers’ markets,',
          'Commissaries, grocery stores (including convenience stores),',
          'Licensed health care facilities,',
          'Mobile support units,',
          'Public and private school cafeterias,',
          'Restricted food service facilities,',
          'Retail stores where a majority of sales are from a pharmacy,',
          'Venues with snack bar services in which the majority of sales are from admission tickets,',
          'Certain food facilities with approved in-house food safety training,',
          'Food facilities subject to a collective bargaining agreement,',
          'Any city, county, city and county, state or regional facility used for the confinement of adults or minors, including, but not limited to, a county jail, juvenile hall, camp, ranch, or residential facility,',
          'An elderly nutrition program, administered by the California Department of Aging, and',
          'Food handlers working in the counties of Riverside, San Bernardino and San Diego and food handlers holding a valid Manager’s Food Safety Certificate.',
        ],
        q5: 'I work as a volunteer at a soup kitchen, food bank or a volunteer run restaurant. Do I require a Food Handlers Card?',
        a5: 'No, volunteers are exempt. The law only applies to employees who have been hired by food service establishments.',
        q6: 'Are grocery store employees required to get a Food Handlers Card?',
        a6: 'No, grocery stores are exempt from the ',
        a6_link: 'California Food Handlers Card law.',
        a6_href: '/food-handlers-card/california',
        q7: 'I work at a demonstration booth serving food samples at a grocery store. Am I required to get a California Food Handlers Card?',
        a7: 'No. Grocery store employees are exempt and demonstration companies are not permitted as food facilities.',
        q8: 'I currently hold a valid Manager’s Food Safety Certification. Do I need a California Food Handlers Card?',
        a8: 'No. The Food Manager Certification is a higher, more comprehensive certificate training that meets and exceeds the Food Handlers Card law requirements; therefore you are not required to obtain the Food Handlers Card.',
        q9: 'I am a part-time or temporary employee. Am I required to get a Food Handlers Card?',
        a9: 'Yes, all food handlers, regardless of how many hours they work, are required to obtain a Food Handlers Card, unless exempt.',
        q10: 'When will I get my Food Handlers Card?',
        a10: 'You will be able to download and print your Food Handlers Card as soon as you finish the online training and pass the final test.',
        q11: 'Do I have to complete the training all at once?',
        a11: 'No, you may complete the training in multiple sessions. Every time you log out of your account, your progress is saved, allowing you to resume the training later from the same section where you left off.',
        q12: 'What if I don’t have a printer at home to print my Food Handlers Card?',
        a12: 'If you don’t have access to a computer with a printer, you can still take the training online and, once you have passed the test, we can mail a printed copy of your California Food Handlers Card for an additional fee of $9.99.',
        q13: 'Is my employer responsible for paying for my training and Food Handlers Card?',
        a13: 'Yes. Effective January 1st, 2024, California Employers will be required to cover the cost of the food handler card training for all employees. For more information about the SB476 Law, please ',
        a13_link: 'click here',
        a13_href: '/food-handlers-card/california/sb476-law',
        q14: 'When will my food handlers card expire?',
        a14: 'The food handler card is valid for 3 years before you need to renew.',
        q15: 'Is my card valid anywhere in California?',
        a15_start: 'Your ',
        a15: ' is valid to work in any food service establishment in California, with the exception of those located in San Bernardino, Riverside and San Diego counties. These counties issue their own Food Handlers Cards.',
        a15_link: 'California Food Handlers Card',
        a15_href: '/food-handlers-card/california',
        q16: 'I need to get my Food Handlers Card but I do not have a computer, tablet or smartphone, what can I do?',
        a16_title: 'If you don’t have access to a computer or mobile device, here are a few suggestions:',
        a16_list: [
          'Go to your local library – computers are available for use to the public',
          'Ask a friend if you could borrow their computer for a few hours',
          'Talk to your supervisor about using a computer at work',
        ],
        q17: 'I work for multiple establishments. Do I need a Food Handlers Card for every single one of them?',
        a17: 'Generally, no. Your food handler card will be issued under your name and valid for 3 years, even if you start working for a different employer or work for two or more restaurants. However, if any of the establishments you work for is located in San Bernardino, San Diego or Riverside County, you will need to obtain a Food Handlers Card to work there. These counties issue their own food handler card.',
        q18: 'I currently work at a restaurant located in San Diego and hold a specific ',
        q18_link1: 'San Diego Food Handlers Card',
        q18_href1: '/food-handlers-card/san-diego-county',
        q18_mid: '. Am I required by law to get a ',
        q18_link2: 'California Food Handlers Card',
        q18_href2: '/food-handlers-card/california',
        q18_end: ' also?',
        a18: 'Yes, if you work for a restaurant outside San Diego County, such as Orange County, you need to get a California Food Handlers Card. This same rule applies if you are currently working for a restaurant in San Bernardino or Riverside County.',
        q19: 'What documentation are employers required to keep?',
        a19: 'Employers are responsible for maintaining accurate records that all food handlers employed by the establishment hold a valid California Food Handlers Card. An example of proper documentation would be to keep a copy of each food handler’s card on file, so it is available upon request to the next health inspector.',
        q20: 'If you have a group of 100 or more employees who need to be trained, please call us to receive a special group discount.',
        a20: 'For more information, call ',
        a20_phone: '800-676-3121',
        a20_phone_href: 'tel:+18006763121',
        a20_mid: ' or ',
        a20_link: 'request a quote',
        a20_href: '/food-handlers-card/california',
      },
    },
    handlerTopPane: {
      foodHandlersCard: 'Food Handler Card',
      startOnlineTraining: 'Start Online Training',
      groupDiscountsAvailable: 'Group Discounts Available',
      contactUs: 'Contact Us',
      features: [
        'ANAB Accredited',
        'Approved by CA Health Departments',
        'Download & Print Card Instantly',
      ],
    },
    ctaForm: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      whichCounty: 'Which county do you work in?',
      selectYourCounty: 'Select your county',
      continue: 'Continue',
      sanDiegoNotice: 'The California Food Handler Card is not valid in San Diego County. If you work in San Diego County,',
      sanBernardinoNotice: 'The California Food Handler Card is not valid in San Bernardino County. For more information,',
      riversideNotice: 'The California Food Handler Card is not valid in Riverside County. For more information,',
      clickHere: 'please click here.',
    },
    customerStats: {
      over45Years: 'Over 45 Years',
      ofExperience: 'of experience',
      over3Million: 'Over 3 Million',
      clientsTrained: 'clients trained',
      moneyGuarantee: '100% Money Back Guarantee',
    },
    customerTestimonials: {
      addToCart: 'Add to Cart',
    },
    estimateTime: {
      text: '90 mins',
      description: 'Estimated time to complete course + exam',
    },
    easyProcessVideo: {
      alt: 'How to Get Your CA Food Handler Card',
      title: 'How to Get Your CA Food Handler Card',
    },
    onlineProgram: {
      title: 'Join over 3 Million Satisfied Food Service Professionals',
      subTitle: 'Get your food handlers card with this 90-minute online certificate program',
      startedToday: 'Get started today',
    },
    aboutPfs: {
      subTitle: 'Industry Leader in Food Training',
      title: 'About Premier Food Safety',
      description: 'With over 45 years of experience, we are the leading providers of food safety training and certification solutions for the food service industry. Our accredited programs are approved by local health departments and designed to give you maximum flexibility when choosing training for yourself or your staff.',
      programs: 'We offer the ServSafe Food Manager Certification nationwide, and state-specific Food Handler Card programs to help you meet regulatory requirements easily and in an affordable manner.',
    },
    howItWorks: {
      caTitle: 'How to Get Your CA Food Handler Card',
      caDescription: 'To get your card today, you only need to register, take the online course, and pass the exam. Your card will be available for you to download immediately after. Watch the video for a step-by-step guide on the process.',
      easyProcess: 'Our Easy Process',
      step1: 'Step 1',
      step2: 'Step 2',
      step3: 'Step 3',
    },
    steps: {
      step1: {
        title: 'Register & Training',
        languages: 'Languages: English, Spanish (Español), Chinese (中文), and Korean (한국어)',
        onlineCourseLength: '100% Online Course Length: 90 Minutes (Including Exam)',
        startAndStop: 'Start and Stop as Needed',
        features: 'Course features Full Text Transcript & Closed Captioning',
      },
      step2: {
        title: 'Take the Exam',
        attempts: 'Exam Attempts: Unlimited (After 2 fails, course must be watched from the beginning)',
        passingScore: 'Minimum Passing Score: 70%',
        onlineAndMobile: '100% Online and Mobile Friendly',
      },
      step3: {
        title: 'Print Card & Certificate',
        downloadAndPrint: 'Download & Print from Home',
        validFor3Years: 'Card Valid for 3 Years',
        acceptedThroughout: 'Accepted throughout California except for Riverside, San Bernardino, and San Diego Counties',
        accessFor1Year: 'Training access for 1 year',
      },
    },
    contactSection: {
      groupDiscount: 'Looking for group discounts?',
      contactUs: 'Contact us',
    },
    certifications: {
      alcohol: {
        location: 'California AB1825 and SB1343 Courses',
        title: 'Workplace California Harassment Prevention Training for Employees',
        items: [
          'Register for Online Training',
          'Complete the Course & Print Certificate of Completion',
        ],
        learnMore: 'Learn More',
      },
      foodManager: {
        location: 'California Food Manager Certification',
        title: 'ServSafe® Online Course + Online Exam',
        items: [
          'Register for ServSafe In-Person Class or Online Course',
          'Choose Paper-based or Online ServSafe Exam',
        ],
        selectPackage: 'Select a Package',
      },
    },
    resources: {
      title: 'Resources',
      items: {
        regulations: 'California Regulations',
        retailFoodCode: 'California Retail Food Code',
        practiceTest: 'Free Food Handler Practice Exam',
        aboutCard: 'About Food Handler Cards',
        handwashing: 'Handwashing Guide',
        readyToEat: 'Ready-to-Eat Food Prep Guide',
      },
    },
    faqSection: {
      title: 'Frequently Asked Questions',
      ca: {
        q1: 'What is the California Food Handler Card Law?',
        a1: 'The California Food Handlers Card Law (based on SB303) requires all food handlers, unless exempt, to get a Food Handlers Card within 30 days of date of new hire and renew every 3 years.',
        q2: 'How do I get a ',
        q2_link: 'California Food Handlers Card?',
        q2_href: '/food-handlers-card/california',
        a2_start: 'The card issued upon successful completion of an ANAB-accredited food safety program, such as ',
        a2_link: 'Premier Food Safety',
        a2_end: ', and a 40-question exam with a minimum score of 70%.',
        q3: 'Who is considered a food handler?',
        a3: 'A food handler is any individual who is involved in the preparation, storage, or service of food in a food facility.',
        q4: 'Are there any exceptions to the California Food Handlers Card Law?',
        a4_title: 'Food handlers employed at any of the following are exempt from the law:',
        a4_list: [
          'Temporary food facilities (food booths),',
          'Certified farmers’ markets,',
          'Commissaries, grocery stores (including convenience stores),',
          'Licensed health care facilities,',
          'Mobile support units,',
          'Public and private school cafeterias,',
          'Restricted food service facilities,',
          'Retail stores where a majority of sales are from a pharmacy,',
          'Venues with snack bar services in which the majority of sales are from admission tickets,',
          'Certain food facilities with approved in-house food safety training,',
          'Food facilities subject to a collective bargaining agreement,',
          'Any city, county, city and county, state or regional facility used for the confinement of adults or minors, including, but not limited to, a county jail, juvenile hall, camp, ranch, or residential facility,',
          'An elderly nutrition program, administered by the California Department of Aging, and',
          'Food handlers working in the counties of Riverside, San Bernardino and San Diego and food handlers holding a valid Manager’s Food Safety Certificate.',
        ],
        q5: 'I work as a volunteer at a soup kitchen, food bank or a volunteer run restaurant. Do I require a Food Handlers Card?',
        a5: 'No, volunteers are exempt. The law only applies to employees who have been hired by food service establishments.',
        q6: 'Are grocery store employees required to get a Food Handlers Card?',
        a6: 'No, grocery stores are exempt from the ',
        a6_link: 'California Food Handlers Card law.',
        a6_href: '/food-handlers-card/california',
        q7: 'I work at a demonstration booth serving food samples at a grocery store. Am I required to get a California Food Handlers Card?',
        a7: 'No. Grocery store employees are exempt and demonstration companies are not permitted as food facilities.',
        q8: 'I currently hold a valid Manager’s Food Safety Certification. Do I need a California Food Handlers Card?',
        a8: 'No. The Food Manager Certification is a higher, more comprehensive certificate training that meets and exceeds the Food Handlers Card law requirements; therefore you are not required to obtain the Food Handlers Card.',
        q9: 'I am a part-time or temporary employee. Am I required to get a Food Handlers Card?',
        a9: 'Yes, all food handlers, regardless of how many hours they work, are required to obtain a Food Handlers Card, unless exempt.',
        q10: 'When will I get my Food Handlers Card?',
        a10: 'You will be able to download and print your Food Handlers Card as soon as you finish the online training and pass the final test.',
        q11: 'Do I have to complete the training all at once?',
        a11: 'No, you may complete the training in multiple sessions. Every time you log out of your account, your progress is saved, allowing you to resume the training later from the same section where you left off.',
        q12: 'What if I don’t have a printer at home to print my Food Handlers Card?',
        a12: 'If you don’t have access to a computer with a printer, you can still take the training online and, once you have passed the test, we can mail a printed copy of your California Food Handlers Card for an additional fee of $9.99.',
        q13: 'Is my employer responsible for paying for my training and Food Handlers Card?',
        a13: 'Yes. Effective January 1st, 2024, California Employers will be required to cover the cost of the food handler card training for all employees. For more information about the SB476 Law, please ',
        a13_link: 'click here',
        a13_href: '/food-handlers-card/california/sb476-law',
        q14: 'When will my food handlers card expire?',
        a14: 'The food handler card is valid for 3 years before you need to renew.',
        q15: 'Is my card valid anywhere in California?',
        a15_start: 'Your ',
        a15: ' is valid to work in any food service establishment in California, with the exception of those located in San Bernardino, Riverside and San Diego counties. These counties issue their own Food Handlers Cards.',
        a15_link: 'California Food Handlers Card',
        a15_href: '/food-handlers-card/california',
        q16: 'I need to get my Food Handlers Card but I do not have a computer, tablet or smartphone, what can I do?',
        a16_title: 'If you don’t have access to a computer or mobile device, here are a few suggestions:',
        a16_list: [
          'Go to your local library – computers are available for use to the public',
          'Ask a friend if you could borrow their computer for a few hours',
          'Talk to your supervisor about using a computer at work',
        ],
        q17: 'I work for multiple establishments. Do I need a Food Handlers Card for every single one of them?',
        a17: 'Generally, no. Your food handler card will be issued under your name and valid for 3 years, even if you start working for a different employer or work for two or more restaurants. However, if any of the establishments you work for is located in San Bernardino, San Diego or Riverside County, you will need to obtain a Food Handlers Card to work there. These counties issue their own food handler card.',
        q18: 'I currently work at a restaurant located in San Diego and hold a specific ',
        q18_link1: 'San Diego Food Handlers Card',
        q18_href1: '/food-handlers-card/san-diego-county',
        q18_mid: '. Am I required by law to get a ',
        q18_link2: 'California Food Handlers Card',
        q18_href2: '/food-handlers-card/california',
        q18_end: ' also?',
        a18: 'Yes, if you work for a restaurant outside San Diego County, such as Orange County, you need to get a California Food Handlers Card. This same rule applies if you are currently working for a restaurant in San Bernardino or Riverside County.',
        q19: 'What documentation are employers required to keep?',
        a19: 'Employers are responsible for maintaining accurate records that all food handlers employed by the establishment hold a valid California Food Handlers Card. An example of proper documentation would be to keep a copy of each food handler’s card on file, so it is available upon request to the next health inspector.',
        q20: 'If you have a group of 100 or more employees who need to be trained, please call us to receive a special group discount.',
        a20: 'For more information, call ',
        a20_phone: '800-676-3121',
        a20_phone_href: 'tel:+18006763121',
        a20_mid: ' or ',
        a20_link: 'request a quote',
        a20_href: '/food-handlers-card/california',
      },
    },
  },
};
